import { select as x, pointer as qe, brushX as ms, scaleTime as Xs, extent as Ke, area as kt, line as It, axisBottom as Dt, axisLeft as fs, axisTop as Ys, axisRight as qs, scaleLinear as Oe, arc as Be, easeLinear as Ks, path as Rt, interpolateNumber as vs, quantize as Js, scaleBand as _t, hierarchy as Pt, pack as Qs, pie as en, interpolate as tn, interpolateRound as sn, min as dt, max as Nt, lineRadial as nn, curveLinearClosed as an, cluster as rn, tree as on, linkHorizontal as ln, treemap as cn, hsl as ys, color as bs, geoPath as dn, geoNaturalEarth1 as hn, geoMercator as un, geoEquirectangular as pn, geoConicEquidistant as gn, geoConicEqualArea as mn, geoAlbers as fn, geoEqualEarth as vn } from "d3";
import { t as Es, i as yn, U as Ss, V as bn, W as xs, X as En, Y as Sn, Z as xn, _ as On, g as y, d as he, h as Ie, G as Ht, $ as Tn, a0 as Q, z as J, a1 as $e, C as Os, a2 as Ut, L as de, I as Ln, a3 as Ts, f as wn, a4 as ve, M as ht, O as ut, j as pe, a5 as Pe, a6 as ge, l as fe, A as me, a7 as Mn, S as An, n as pt, D as Z, q as ce, a8 as ie, a9 as Cn, Q as kn, B as se, u as _e, s as tt, aa as zt, ab as In, ac as Ft, E as Ee } from "./color-scale-utils-38aedd61.mjs";
import { y as H, _ as f, K as ee, r as ye, q as Te, L as Dn, A as ue, m as $, s as Se, V as ke, S as te, e as P, Z as Le, i as le, f as Wt, J as st, d as Rn, F as Ne, n as nt, H as at, C as it, p as He, b as jt, D as rt, Q as _n, x as xe, $ as Ue, N as ot } from "./enums-a96ef472.mjs";
import { R as U } from "./a11y-7bad4f48.mjs";
import { t as lt, D as E, c as gt, G as Zt, a as Pn, p as Y, r as Xt, b as Vn } from "./angle-utils-a4fbf1b8.mjs";
import { sankey as Bn, sankeyLinkHorizontal as $n, sankeyJustify as Gn, sankeyLeft as Nn, sankeyRight as Hn } from "d3-sankey";
import { b as Ls } from "./_baseEach-81f85d61.mjs";
import Un from "d3-cloud";
function zn(r, e, t, s) {
  var n = -1, a = r == null ? 0 : r.length;
  for (s && a && (t = r[++n]); ++n < a; )
    t = e(t, r[n], n, r);
  return t;
}
function Fn(r) {
  return function(e) {
    return r == null ? void 0 : r[e];
  };
}
var Wn = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, jn = Fn(Wn);
const Zn = jn;
var Xn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Yn = "\\u0300-\\u036f", qn = "\\ufe20-\\ufe2f", Kn = "\\u20d0-\\u20ff", Jn = Yn + qn + Kn, Qn = "[" + Jn + "]", ea = RegExp(Qn, "g");
function ta(r) {
  return r = Es(r), r && r.replace(Xn, Zn).replace(ea, "");
}
var sa = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function na(r) {
  return r.match(sa) || [];
}
var aa = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function ia(r) {
  return aa.test(r);
}
var ws = "\\ud800-\\udfff", ra = "\\u0300-\\u036f", oa = "\\ufe20-\\ufe2f", la = "\\u20d0-\\u20ff", ca = ra + oa + la, Ms = "\\u2700-\\u27bf", As = "a-z\\xdf-\\xf6\\xf8-\\xff", da = "\\xac\\xb1\\xd7\\xf7", ha = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", ua = "\\u2000-\\u206f", pa = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Cs = "A-Z\\xc0-\\xd6\\xd8-\\xde", ga = "\\ufe0e\\ufe0f", ks = da + ha + ua + pa, Is = "['’]", Yt = "[" + ks + "]", ma = "[" + ca + "]", Ds = "\\d+", fa = "[" + Ms + "]", Rs = "[" + As + "]", _s = "[^" + ws + ks + Ds + Ms + As + Cs + "]", va = "\\ud83c[\\udffb-\\udfff]", ya = "(?:" + ma + "|" + va + ")", ba = "[^" + ws + "]", Ps = "(?:\\ud83c[\\udde6-\\uddff]){2}", Vs = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ce = "[" + Cs + "]", Ea = "\\u200d", qt = "(?:" + Rs + "|" + _s + ")", Sa = "(?:" + Ce + "|" + _s + ")", Kt = "(?:" + Is + "(?:d|ll|m|re|s|t|ve))?", Jt = "(?:" + Is + "(?:D|LL|M|RE|S|T|VE))?", Bs = ya + "?", $s = "[" + ga + "]?", xa = "(?:" + Ea + "(?:" + [ba, Ps, Vs].join("|") + ")" + $s + Bs + ")*", Oa = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Ta = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", La = $s + Bs + xa, wa = "(?:" + [fa, Ps, Vs].join("|") + ")" + La, Ma = RegExp([
  Ce + "?" + Rs + "+" + Kt + "(?=" + [Yt, Ce, "$"].join("|") + ")",
  Sa + "+" + Jt + "(?=" + [Yt, Ce + qt, "$"].join("|") + ")",
  Ce + "?" + qt + "+" + Kt,
  Ce + "+" + Jt,
  Ta,
  Oa,
  Ds,
  wa
].join("|"), "g");
function Aa(r) {
  return r.match(Ma) || [];
}
function Ca(r, e, t) {
  return r = Es(r), e = t ? void 0 : e, e === void 0 ? ia(r) ? Aa(r) : na(r) : r.match(e) || [];
}
var ka = "['’]", Ia = RegExp(ka, "g");
function Da(r) {
  return function(e) {
    return zn(Ca(ta(e).replace(Ia, "")), r, "");
  };
}
function Ra(r, e, t) {
  return r === r && (t !== void 0 && (r = r <= t ? r : t), e !== void 0 && (r = r >= e ? r : e)), r;
}
function Gs(r, e, t) {
  return t === void 0 && (t = e, e = void 0), t !== void 0 && (t = lt(t), t = t === t ? t : 0), e !== void 0 && (e = lt(e), e = e === e ? e : 0), Ra(lt(r), e, t);
}
function _a(r, e) {
  var t = -1, s = yn(r) ? Array(r.length) : [];
  return Ls(r, function(n, a, i) {
    s[++t] = e(n, a, i);
  }), s;
}
function Pa(r, e) {
  var t = Ss(r) ? bn : _a;
  return t(r, xs(e));
}
var Va = 1 / 0;
function Ba(r, e) {
  return En(Pa(r, e), Va);
}
function Ns(r, e) {
  return Sn(r, e);
}
var $a = Da(function(r, e, t) {
  return r + (t ? "-" : "") + e.toLowerCase();
});
const we = $a;
function Ga(r, e) {
  var t;
  return Ls(r, function(s, n, a) {
    return t = e(s, n, a), !t;
  }), !!t;
}
function Na(r, e, t) {
  var s = Ss(r) ? xn : Ga;
  return t && On(r, e, t) && (e = void 0), s(r, xs(e));
}
class z {
  constructor(e, t, s) {
    if (this.type = "", this.renderType = H.HTML, this.id = "", this.parent = void 0, this.configs = {}, this.model = e, this.services = t, s && (this.configs = s, this.configs.id)) {
      const n = y(this.model.getOptions(), "style", "prefix");
      this.id = `${n}--${this.configs.id}`;
    }
    this.parent || this.setParent(x(this.services.domUtils.getMainContainer()));
  }
  init() {
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    console.error("Error: Component did not provide the required render function.");
  }
  destroy() {
  }
  // Used to pass down information to the components
  setModel(e) {
    this.model = e;
  }
  // Used to pass down information to the components
  setServices(e) {
    this.services = e;
  }
  setParent(e) {
    var s;
    const t = this.parent;
    if (this.parent = e, !(t && t.node() === e.node()) && this.type) {
      const n = y(this.model.getOptions(), "style", "prefix");
      (s = this.parent) == null || s.classed(`${he}--${n}--${this.type}`, !0), t && t.classed(`${he}--${n}--${this.type}`, !1);
    }
  }
  getParent() {
    return this.parent;
  }
  getComponentContainer(e = { withinChartClip: !1 }) {
    if (this.type) {
      const t = y(this.model.getOptions(), "style", "prefix"), s = this.id ? `#${this.id}` : "", n = E.appendOrSelect(
        this.parent,
        `${this.renderType === H.SVG ? "svg" : "div"}${s}.${he}--${t}--${this.type}`
      );
      if (e.withinChartClip) {
        const a = this.model.get("chartClipId");
        if (a) {
          const o = x(`#${a}`).select("rect");
          o.size() !== 0 && parseFloat(o.attr("height")) > 0 && n.attr("clip-path", `url(#${a})`);
        }
      }
      return n.attr("width", "100%").attr("height", "100%");
    }
    return this.parent;
  }
  /**
   * graphs used in combo charts share a model with global options but can receive their own local options.
   * this function retrieves the global options and merges it with any options passed into this
   * component's config.options object.
   */
  getOptions() {
    return this.configs.options ? Ie({}, this.model.getOptions(), this.configs.options) : this.model.getOptions();
  }
}
const Hs = class extends z {
  constructor() {
    super(...arguments), this.type = "toolbar", this.renderType = H.HTML;
  }
  init() {
    const r = () => this.updateOverflowMenu(!1);
    this.services.events.addEventListener(f.Toolbar.SHOW_OVERFLOW_MENU, () => {
      this.renderOverflowMenu(), document.body.addEventListener("click", r);
    }), this.services.events.addEventListener(f.Toolbar.HIDE_OVERFLOW_MENU, () => {
      document.body.removeEventListener("click", r);
    });
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(r = !0) {
    const e = this.getComponentContainer().attr("role", "toolbar").attr("aria-label", `chart-${this.services.domUtils.getChartID()} toolbar`);
    if (y(this.getOptions(), "data", "loading"))
      e.html(""), this.overflowMenu = null;
    else {
      this.overflowMenu || (this.overflowMenu = e.append("div").attr(
        "class",
        "cds--overflow-menu-options cds--overflow-menu--flip cds--overflow-menu-options cds--overflow-menu--flip"
      ).attr("tabindex", -1).html("<ul role='menu'></ul>"));
      const { buttonList: s, overflowMenuItemList: n } = this.getControlConfigs();
      n && s.push(this.getOverflowButtonConfig());
      const a = e.selectAll("div.toolbar-control").data(s, (l) => l.id);
      a.exit().remove();
      const i = a.enter().append("div").attr("class", "toolbar-control cds--overflow-menu cds--overflow-menu").attr("role", "button"), o = this;
      i.merge(a).classed("disabled", (l) => l.shouldBeDisabled()).attr("aria-disabled", (l) => l.shouldBeDisabled()).attr("aria-label", (l) => l.title).html(
        (l) => `
			<button
				class="cds--overflow-menu__trigger cds--overflow-menu__trigger"
				aria-haspopup="true" aria-expanded="false" id="${this.services.domUtils.generateElementIDString(
          `control-${l.id}`
        )}" aria-label="${l.title}">
				<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" class="cds--overflow-menu__icon cds--overflow-menu__icon" viewBox="0 0 32 32" aria-hidden="true">
					${l.iconSVG.content}
				</svg>
			</button>`
      ).each(function(l, c) {
        x(this).select("svg").style("will-change", "transform").style("width", l.iconSVG.width !== void 0 ? l.iconSVG.width : "20px").style("height", l.iconSVG.height !== void 0 ? l.iconSVG.height : "20px"), x(this).select("button").on("click", (d) => {
          l.shouldBeDisabled() || o.triggerFunctionAndEvent(l, d, this);
        }).on("keydown", (d) => {
          d.key && d.key === "Enter" || d.key === " " ? (d.preventDefault(), o.triggerFunctionAndEvent(l, d, this)) : d.key && d.key === "ArrowLeft" ? o.focusOnPreviousEnabledToolbarItem(c) : d.key && d.key === "ArrowRight" && o.focusOnNextEnabledToolbarItem(c);
        });
      }), this.overflowButton = this.getComponentContainer().select(
        `button.cds--overflow-menu__trigger#${this.services.domUtils.generateElementIDString(
          "control-toolbar-overflow-menu"
        )}`
      );
    }
  }
  renderOverflowMenu() {
    const { overflowMenuItemList: r } = this.getControlConfigs(), e = this.overflowMenu.select("ul").selectAll("li.cds--overflow-menu-options__option").data(r, (s) => y(s, "id"));
    e.exit().remove();
    const t = e.enter().append("li").attr("id", (s) => this.services.domUtils.generateElementIDString(`control-${s.id}`)).attr("class", "cds--overflow-menu-options__option cds--overflow-menu-options__option").attr("role", "menuitem").attr("tabindex", 1);
    t.append("button").attr("class", "cds--overflow-menu-options__btn cds--overflow-menu-options__btn"), t.merge(e).classed("cds--overflow-menu-options__option--disabled", (s) => s.shouldBeDisabled()).classed("cds--overflow-menu-options__option--disabled", (s) => s.shouldBeDisabled()).attr("aria-disabled", (s) => s.shouldBeDisabled()).selectAll("button").text((s) => s.text);
  }
  isOverflowMenuOpen() {
    return this.overflowMenu.classed("is-open");
  }
  // show/hide overflow menu
  updateOverflowMenu(r) {
    this.overflowMenu && (this.overflowMenu.classed("is-open", r), this.overflowButton && (this.overflowButton.attr("aria-expanded", r), x(this.overflowButton.node().parentNode).classed("cds--overflow-menu--open", r).classed("cds--overflow-menu--open", r)), r ? this.services.events.dispatchEvent(f.Toolbar.SHOW_OVERFLOW_MENU) : this.services.events.dispatchEvent(f.Toolbar.HIDE_OVERFLOW_MENU));
  }
  // Toolbar controllers
  focusOnPreviousEnabledToolbarItem(r) {
    const e = this.getToolbarButtonItems();
    let t = e.length;
    for (let s = r - 1; s >= 0; s--)
      if (!e[s].shouldBeDisabled()) {
        t = s;
        break;
      }
    if (t < e.length) {
      const s = x(
        `button#${this.services.domUtils.generateElementIDString(
          `control-${e[t].id}`
        )}`
      ).node();
      "focus" in s && s.focus();
    }
  }
  focusOnNextEnabledToolbarItem(r) {
    const e = this.getToolbarButtonItems();
    let t = -1;
    for (let s = r + 1; s < e.length; s++)
      if (!e[s].shouldBeDisabled()) {
        t = s;
        break;
      }
    if (t > -1) {
      const s = x(
        `button#${this.services.domUtils.generateElementIDString(
          `control-${e[t].id}`
        )}`
      ).node();
      "focus" in s && s.focus();
    }
  }
  focusOnPreviousEnabledMenuItem(r) {
    const e = this.getOverflowMenuItems();
    let t = e.length;
    for (let s = r - 1; s >= 0; s--)
      if (!e[s].shouldBeDisabled()) {
        t = s;
        break;
      }
    if (t < e.length) {
      const s = x(
        `#${this.services.domUtils.generateElementIDString(
          `control-${e[t].id}`
        )} button`
      ).node();
      "focus" in s && s.focus();
    }
  }
  focusOnNextEnabledMenuItem(r) {
    const e = this.getOverflowMenuItems();
    let t = -1;
    for (let s = r + 1; s < e.length; s++)
      if (!e[s].shouldBeDisabled()) {
        t = s;
        break;
      }
    if (t > -1) {
      const s = x(
        `#${this.services.domUtils.generateElementIDString(
          `control-${e[t].id}`
        )} button`
      ).node();
      "focus" in s && s.focus();
    }
  }
  toggleOverflowMenu(r) {
    if (this.isOverflowMenuOpen())
      this.updateOverflowMenu(!1);
    else {
      this.updateOverflowMenu(!0);
      const e = this;
      this.getOverflowMenuItems().forEach((s, n) => {
        const a = x(
          `#${this.services.domUtils.generateElementIDString(`control-${s.id}`)}`
        );
        a !== null && (a.on("click", () => {
          e.triggerFunctionAndEvent(s, r, a.node()), e.updateOverflowMenu(!1);
        }), a.on("keydown", (i) => {
          i && i.key === "Enter" ? e.triggerFunctionAndEvent(s, r, a.node()) : i && i.key === "ArrowUp" ? e.focusOnPreviousEnabledMenuItem(n) : i && i.key === "ArrowDown" ? e.focusOnNextEnabledMenuItem(n) : i && i.key === "Escape" && e.updateOverflowMenu(!1), i.preventDefault();
        }));
      }), e.focusOnNextEnabledMenuItem(-1);
    }
    r && r.stopImmediatePropagation();
  }
  // Calls passed function && dispatches event
  triggerFunctionAndEvent(r, e, t) {
    typeof r.shouldBeDisabled == "function" && r.shouldBeDisabled() || (typeof r.clickFunction == "function" && r.clickFunction(e), this.services.events.dispatchEvent(f.Toolbar.BUTTON_CLICK, {
      control: r,
      event: e,
      element: t
    }));
  }
  getControlConfigs() {
    const r = y(this.getOptions(), "toolbar", "numberOfIcons") - 1, e = y(this.getOptions(), "toolbar", "controls"), t = [], s = [], n = [];
    return e.forEach((a) => {
      let i = null;
      a.type === ee.CUSTOM ? (y(a, "id") === null && (a.id = `toolbar-button-${Hs.buttonID++}`), y(a, "shouldBeDisabled") === null && (a.shouldBeDisabled = () => !1), i = a) : i = this.getControlConfigByType(a.type), i && (i.text = a.text ? a.text : a.type, i.id.indexOf("toolbar-export") !== -1 ? t.push(i) : s.length < r ? y(i, "iconSVG", "content") === null ? n.push(i) : s.push(i) : n.push(i));
    }), n.push(...t), n.length ? {
      buttonList: s,
      overflowMenuItemList: n
    } : {
      buttonList: s
    };
  }
  getToolbarButtonItems() {
    const { buttonList: r, overflowMenuItemList: e } = this.getControlConfigs();
    return e && r.push(this.getOverflowButtonConfig()), r || [];
  }
  getOverflowMenuItems() {
    const { overflowMenuItemList: r } = this.getControlConfigs();
    return r || [];
  }
  // special button config for overflow button
  getOverflowButtonConfig() {
    return {
      id: "toolbar-overflow-menu",
      title: "More options",
      shouldBeDisabled: () => !1,
      iconSVG: {
        content: `<circle cx="16" cy="8" r="2"></circle>
				<circle cx="16" cy="16" r="2"></circle>
				<circle cx="16" cy="24" r="2"></circle>`
      },
      clickFunction: (r) => this.toggleOverflowMenu(r)
    };
  }
  getControlConfigByType(r) {
    const e = this.services.zoom && this.services.zoom.isZoomBarEnabled() && !this.services.zoom.isEmptyState(), t = this.model.getDisplayData();
    let s;
    switch (r) {
      case ee.ZOOM_IN:
        e && (s = {
          id: "toolbar-zoomIn",
          title: "Zoom in",
          shouldBeDisabled: () => this.services.zoom.isMinZoomDomain(),
          iconSVG: {
            content: this.getControlIconByType(r)
          },
          clickFunction: () => this.services.zoom.zoomIn()
        });
        break;
      case ee.ZOOM_OUT:
        e && (s = {
          id: "toolbar-zoomOut",
          title: "Zoom out",
          shouldBeDisabled: () => this.services.zoom.isMaxZoomDomain(),
          iconSVG: {
            content: this.getControlIconByType(r)
          },
          clickFunction: () => this.services.zoom.zoomOut()
        });
        break;
      case ee.RESET_ZOOM:
        e && (s = {
          id: "toolbar-resetZoom",
          title: "Reset zoom",
          shouldBeDisabled: () => this.services.zoom.isMaxZoomDomain(),
          iconSVG: {
            content: this.getControlIconByType(r)
          },
          clickFunction: () => this.services.zoom.resetZoomDomain()
        });
        break;
      case ee.MAKE_FULLSCREEN:
        s = {
          id: "toolbar-makefullscreen",
          iconSVG: {
            content: this.getControlIconByType(r),
            width: "15px",
            height: "15px"
          },
          title: "Make fullscreen",
          shouldBeDisabled: () => !1,
          clickFunction: () => {
            this.services.domUtils.toggleFullscreen();
          }
        };
        break;
      case ee.SHOW_AS_DATATABLE:
        s = {
          id: "toolbar-showasdatatable",
          iconSVG: {
            content: this.getControlIconByType(r)
          },
          title: "Show as table",
          shouldBeDisabled: () => t.length === 0,
          clickFunction: () => this.services.events.dispatchEvent(f.Modal.SHOW)
        };
        break;
      case ee.EXPORT_CSV:
        s = {
          id: "toolbar-export-CSV",
          title: "Export as CSV",
          shouldBeDisabled: () => !1,
          iconSVG: {
            content: this.getControlIconByType(r)
          },
          clickFunction: () => this.model.exportToCSV()
        };
        break;
      case ee.EXPORT_PNG:
        s = {
          id: "toolbar-export-PNG",
          title: "Export as PNG",
          shouldBeDisabled: () => !1,
          iconSVG: {
            content: this.getControlIconByType(r)
          },
          clickFunction: () => this.services.domUtils.exportToPNG()
        };
        break;
      case ee.EXPORT_JPG:
        s = {
          id: "toolbar-export-JPG",
          title: "Export as JPG",
          shouldBeDisabled: () => !1,
          iconSVG: {
            content: this.getControlIconByType(r)
          },
          clickFunction: () => this.services.domUtils.exportToJPG()
        };
        break;
      default:
        throw Error("Not supported toolbar control type: " + r);
    }
    return s;
  }
  getControlIconByType(r) {
    switch (r) {
      case ee.ZOOM_IN:
        return `<polygon points="19 13 15 13 15 9 13 9 13 13 9 13 9 15 13 15 13 19 15 19 15 15 19 15 19 13"/>
						<path d="M22.45,21A10.87,10.87,0,0,0,25,14,11,11,0,1,0,14,25a10.87,10.87,0,0,0,7-2.55L28.59,30,30,28.59ZM14,23a9,9,0,1,1,9-9A9,9,0,0,1,14,23Z"/>`;
      case ee.ZOOM_OUT:
        return `<rect x="9" y="13" width="10" height="2"/>
						<path d="M22.45,21A10.87,10.87,0,0,0,25,14,11,11,0,1,0,14,25a10.87,10.87,0,0,0,7-2.55L28.59,30,30,28.59ZM14,23a9,9,0,1,1,9-9A9,9,0,0,1,14,23Z"/>`;
      case ee.RESET_ZOOM:
        return '<path d="M22.4478,21A10.855,10.855,0,0,0,25,14,10.99,10.99,0,0,0,6,6.4658V2H4v8h8V8H7.332a8.9768,8.9768,0,1,1-2.1,8H3.1912A11.0118,11.0118,0,0,0,14,25a10.855,10.855,0,0,0,7-2.5522L28.5859,30,30,28.5859Z"/>';
      case ee.MAKE_FULLSCREEN:
        return '<polygon points="21 2 21 4 26.59 4 17 13.58 18.41 15 28 5.41 28 11 30 11 30 2 21 2"/><polygon points="15 18.42 13.59 17 4 26.59 4 21 2 21 2 30 11 30 11 28 5.41 28 15 18.42"/>';
      case ee.SHOW_AS_DATATABLE:
        return '<rect x="4" y="6" width="18" height="2"/><rect x="4" y="12" width="18" height="2"/><rect x="4" y="18" width="18" height="2"/><rect x="4" y="24" width="18" height="2"/><rect x="26" y="6" width="2" height="2"/><rect x="26" y="12" width="2" height="2"/><rect x="26" y="18" width="2" height="2"/><rect x="26" y="24" width="2" height="2"/>';
      case ee.EXPORT_CSV:
        return '<path d="M22.4478,21A10.855,10.855,0,0,0,25,14,10.99,10.99,0,0,0,6,6.4658V2H4v8h8V8H7.332a8.9768,8.9768,0,1,1-2.1,8H3.1912A11.0118,11.0118,0,0,0,14,25a10.855,10.855,0,0,0,7-2.5522L28.5859,30,30,28.5859Z"/>';
      case ee.EXPORT_JPG:
        return '<path d="M22.4478,21A10.855,10.855,0,0,0,25,14,10.99,10.99,0,0,0,6,6.4658V2H4v8h8V8H7.332a8.9768,8.9768,0,1,1-2.1,8H3.1912A11.0118,11.0118,0,0,0,14,25a10.855,10.855,0,0,0,7-2.5522L28.5859,30,30,28.5859Z"/>';
      case ee.EXPORT_PNG:
        return '<path d="M22.4478,21A10.855,10.855,0,0,0,25,14,10.99,10.99,0,0,0,6,6.4658V2H4v8h8V8H7.332a8.9768,8.9768,0,1,1-2.1,8H3.1912A11.0118,11.0118,0,0,0,14,25a10.855,10.855,0,0,0,7-2.5522L28.5859,30,30,28.5859Z"/>';
      default:
        throw Error("Not supported toolbar control type: " + r);
    }
  }
};
let Ha = Hs;
Ha.buttonID = 0;
const Us = class extends z {
  constructor(r, e, t, s) {
    super(r, e, s), this.type = "layout", this.configs = s, this.children = t, this._instanceID = Us.instanceID++, this.init();
  }
  init() {
    this.children.forEach((r) => {
      r.components.forEach((e) => {
        e.init();
      });
    });
  }
  getPreferedAndFixedSizeSum() {
    const r = this.parent;
    let e = 0;
    return r.selectAll(`div.layout-child-${this._instanceID}`).filter((t) => {
      const s = y(t, "growth");
      return s === ye.PREFERRED || s === ye.FIXED;
    }).each(function(t) {
      e += t.size;
    }), e;
  }
  getNumOfStretchChildren() {
    return this.parent.selectAll(`div.layout-child-${this._instanceID}`).filter((e) => y(e, "growth") === ye.STRETCH).size();
  }
  render(r = !0) {
    const e = this.parent, { width: t, height: s } = E.getHTMLElementSize(e.node()), n = this.configs.direction === Te.ROW || this.configs.direction === Te.ROW_REVERSE, a = y(this.model.getOptions(), "style", "prefix"), i = e.classed(
      `${he}--${a}--layout-row`,
      this.configs.direction === Te.ROW
    ).classed(
      `${he}--${a}--layout-row-reverse`,
      this.configs.direction === Te.ROW_REVERSE
    ).classed(
      `${he}--${a}--layout-column`,
      this.configs.direction === Te.COLUMN
    ).classed(
      `${he}--${a}--layout-column-reverse`,
      this.configs.direction === Te.COLUMN_REVERSE
    ).classed(
      `${he}--${a}--layout-alignitems-center`,
      this.configs.alignItems === Dn.CENTER
    ).selectAll(`div.layout-child-${this._instanceID}`).data(this.children, (c) => c.id);
    i.enter().append("div").merge(e.selectAll(`div.layout-child-${this._instanceID}`)).attr("class", (c) => `layout-child layout-child-${this._instanceID} ${c.id}`).each(function(c) {
      c.components.forEach((d) => {
        const p = x(this), u = y(c, "renderType") === H.SVG;
        d.setParent(
          u ? E.appendOrSelect(p, "svg.layout-svg-wrapper").attr("width", "100%").attr("height", "100%") : p
        );
        const g = y(c, "growth");
        (g === ye.PREFERRED || g === ye.FIXED) && d.render(r);
      });
    }), e.selectAll(`div.layout-child-${this._instanceID}`).style("height", null).style("width", null).each(function(c) {
      const d = y(c, "growth"), h = y(c, "renderType") === H.SVG ? E.getSVGElementSize(x(this).select("svg.layout-svg-wrapper"), {
        useBBox: !0
      }) : E.getHTMLElementSize(this);
      if (d === ye.PREFERRED) {
        const u = n ? h.width : h.height, g = n ? t : s;
        c.size = u / g * 100;
      }
    }), i.exit().remove(), this.children.filter((c) => y(c, "growth") === ye.STRETCH).forEach((c) => {
      c.size = (100 - +this.getPreferedAndFixedSizeSum()) / +this.getNumOfStretchChildren();
    });
    const l = e.selectAll(`div.layout-child-${this._instanceID}`).data(this.children, (c) => c.id);
    n ? l.style("width", (c) => `${c.size / 100 * t}px`).style("height", "100%") : l.style("height", (c) => `${c.size / 100 * s}px`).style("width", "100%"), l.each(function(c) {
      c.components.forEach((d) => {
        y(c, "growth") === ye.STRETCH && d.render(r);
      });
    });
  }
  // Pass on model to children as well
  setModel(r) {
    super.setModel(r), this.children.forEach((e) => {
      e.components.forEach((t) => t.setModel(r));
    });
  }
  // Pass on essentials to children as well
  setServices(r) {
    super.setServices(r), this.children.forEach((e) => {
      e.components.forEach((t) => t.setServices(r));
    });
  }
  destroy() {
    this.children.forEach((r) => {
      r.components.forEach((e) => e.destroy());
    });
  }
};
let Ua = Us;
Ua.instanceID = Math.floor(Math.random() * 99999999999);
class ac extends z {
  constructor() {
    super(...arguments), this.type = "spacer";
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    this.getComponentContainer().style("width", `${this.configs.size || Ht.default.size}px`).style("height", `${this.configs.size || Ht.default.size}px`).attr("opacity", 0);
  }
}
var za = {
  prefix: "bx",
  selectorTabbable: `
    a[href], area[href], input:not([disabled]):not([tabindex='-1']),
    button:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']),
    textarea:not([disabled]):not([tabindex='-1']),
    iframe, object, embed, *[tabindex]:not([tabindex='-1']), *[contenteditable=true]
  `,
  selectorFocusable: `
    a[href], area[href], input:not([disabled]),
    button:not([disabled]),select:not([disabled]),
    textarea:not([disabled]),
    iframe, object, embed, *[tabindex], *[contenteditable=true]
  `
}, ct = za;
function Qt(r, e) {
  for (var t = 0; t < e.length; t++) {
    var s = e[t];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(r, s.key, s);
  }
}
function Fa(r, e, t) {
  return e && Qt(r.prototype, e), t && Qt(r, t), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function Wa(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ja(r) {
  return qa(r) || Ya(r) || Xa(r) || Za();
}
function Za() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xa(r, e) {
  if (r) {
    if (typeof r == "string")
      return mt(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set")
      return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return mt(r, e);
  }
}
function Ya(r) {
  if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null)
    return Array.from(r);
}
function qa(r) {
  if (Array.isArray(r))
    return mt(r);
}
function mt(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, s = new Array(e); t < e; t++)
    s[t] = r[t];
  return s;
}
function zs(r) {
  return r.reduce(function(e, t) {
    return Array.isArray(t) ? e.push.apply(e, ja(zs(t))) : e.push(t), e;
  }, []);
}
function Ka() {
  for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
    e[t] = arguments[t];
  return zs(e).reduce(function(s, n) {
    return n(s);
  }, /* @__PURE__ */ function() {
    function s() {
      Wa(this, s);
    }
    return Fa(s);
  }());
}
function ft(r) {
  "@babel/helpers - typeof";
  return ft = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ft(r);
}
function Ja(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function es(r, e) {
  for (var t = 0; t < e.length; t++) {
    var s = e[t];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(r, s.key, s);
  }
}
function Qa(r, e, t) {
  return e && es(r.prototype, e), t && es(r, t), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function ei(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: r,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(r, "prototype", {
    writable: !1
  }), e && vt(r, e);
}
function vt(r, e) {
  return vt = Object.setPrototypeOf || function(s, n) {
    return s.__proto__ = n, s;
  }, vt(r, e);
}
function ti(r) {
  var e = ni();
  return function() {
    var s = We(r), n;
    if (e) {
      var a = We(this).constructor;
      n = Reflect.construct(s, arguments, a);
    } else
      n = s.apply(this, arguments);
    return si(this, n);
  };
}
function si(r, e) {
  if (e && (ft(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Fs(r);
}
function Fs(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function ni() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function We(r) {
  return We = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, We(r);
}
function ai(r) {
  var e = /* @__PURE__ */ function(t) {
    ei(n, t);
    var s = ti(n);
    function n(a) {
      var i, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (Ja(this, n), i = s.call(this, a, o), i.children = [], !a || a.nodeType !== Node.ELEMENT_NODE)
        throw new TypeError("DOM element should be given to initialize this widget.");
      return i.element = a, i.options = Object.assign(Object.create(i.constructor.options), o), i.constructor.components.set(i.element, Fs(i)), i;
    }
    return Qa(n, [{
      key: "release",
      value: (
        /**
         * Releases this component's instance from the associated element.
         */
        function() {
          for (var i = this.children.pop(); i; i = this.children.pop())
            i.release();
          return this.constructor.components.delete(this.element), null;
        }
      )
    }], [{
      key: "create",
      value: function(i, o) {
        return this.components.get(i) || new this(i, o);
      }
    }]), n;
  }(r);
  return e;
}
function yt(r) {
  "@babel/helpers - typeof";
  return yt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, yt(r);
}
function ii(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ts(r, e) {
  for (var t = 0; t < e.length; t++) {
    var s = e[t];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(r, s.key, s);
  }
}
function ri(r, e, t) {
  return e && ts(r.prototype, e), t && ts(r, t), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function ze() {
  return typeof Reflect < "u" && Reflect.get ? ze = Reflect.get : ze = function(e, t, s) {
    var n = oi(e, t);
    if (n) {
      var a = Object.getOwnPropertyDescriptor(n, t);
      return a.get ? a.get.call(arguments.length < 3 ? e : s) : a.value;
    }
  }, ze.apply(this, arguments);
}
function oi(r, e) {
  for (; !Object.prototype.hasOwnProperty.call(r, e) && (r = De(r), r !== null); )
    ;
  return r;
}
function li(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: r,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(r, "prototype", {
    writable: !1
  }), e && bt(r, e);
}
function bt(r, e) {
  return bt = Object.setPrototypeOf || function(s, n) {
    return s.__proto__ = n, s;
  }, bt(r, e);
}
function ci(r) {
  var e = ui();
  return function() {
    var s = De(r), n;
    if (e) {
      var a = De(this).constructor;
      n = Reflect.construct(s, arguments, a);
    } else
      n = s.apply(this, arguments);
    return di(this, n);
  };
}
function di(r, e) {
  if (e && (yt(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return hi(r);
}
function hi(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function ui() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function De(r) {
  return De = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, De(r);
}
function pi(r) {
  var e = /* @__PURE__ */ function(t) {
    li(n, t);
    var s = ci(n);
    function n() {
      var a;
      ii(this, n);
      for (var i = arguments.length, o = new Array(i), l = 0; l < i; l++)
        o[l] = arguments[l];
      return a = s.call.apply(s, [this].concat(o)), a.handles = /* @__PURE__ */ new Set(), a;
    }
    return ri(n, [{
      key: "manage",
      value: (
        /**
         * Manages the given handle.
         * @param {Handle} handle The handle to manage.
         * @returns {Handle} The given handle.
         */
        function(i) {
          return this.handles.add(i), i;
        }
      )
      /**
       * Stop managing the given handle.
       * @param {Handle} handle The handle to stop managing.
       * @returns {Handle} The given handle.
       */
    }, {
      key: "unmanage",
      value: function(i) {
        return this.handles.delete(i), i;
      }
    }, {
      key: "release",
      value: function() {
        var i = this;
        return this.handles.forEach(function(o) {
          o.release(), i.handles.delete(o);
        }), ze(De(n.prototype), "release", this).call(this);
      }
    }]), n;
  }(r);
  return e;
}
function Ve(r) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), s = 1; s < e; s++)
    t[s - 1] = arguments[s];
  return r.addEventListener.apply(r, t), {
    release: function() {
      return r.removeEventListener.apply(r, t), null;
    }
  };
}
function Et(r) {
  "@babel/helpers - typeof";
  return Et = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Et(r);
}
function gi(r) {
  return yi(r) || vi(r) || fi(r) || mi();
}
function mi() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fi(r, e) {
  if (r) {
    if (typeof r == "string")
      return St(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set")
      return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return St(r, e);
  }
}
function vi(r) {
  if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null)
    return Array.from(r);
}
function yi(r) {
  if (Array.isArray(r))
    return St(r);
}
function St(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, s = new Array(e); t < e; t++)
    s[t] = r[t];
  return s;
}
function bi(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ss(r, e) {
  for (var t = 0; t < e.length; t++) {
    var s = e[t];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(r, s.key, s);
  }
}
function Ei(r, e, t) {
  return e && ss(r.prototype, e), t && ss(r, t), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function Si(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: r,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(r, "prototype", {
    writable: !1
  }), e && xt(r, e);
}
function xt(r, e) {
  return xt = Object.setPrototypeOf || function(s, n) {
    return s.__proto__ = n, s;
  }, xt(r, e);
}
function xi(r) {
  var e = Li();
  return function() {
    var s = je(r), n;
    if (e) {
      var a = je(this).constructor;
      n = Reflect.construct(s, arguments, a);
    } else
      n = s.apply(this, arguments);
    return Oi(this, n);
  };
}
function Oi(r, e) {
  if (e && (Et(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ti(r);
}
function Ti(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function Li() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function je(r) {
  return je = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, je(r);
}
function wi(r) {
  var e = /* @__PURE__ */ function(t) {
    Si(n, t);
    var s = xi(n);
    function n() {
      return bi(this, n), s.apply(this, arguments);
    }
    return Ei(n, [{
      key: "_changeState",
      value: (
        /* eslint-disable jsdoc/check-param-names */
        /**
         * The internal implementation for {@link EventedState#changeState `.changeState()`}, performing actual change in state.
         * @param {string} [state] The new state. Can be an omitted, which means toggling.
         * @param {object} [detail]
         *   The object that should be put to event details that is fired before/after changing state.
         *   Can have a `group` property, which specifies what state to be changed.
         * @param {EventedState~changeStateCallback} callback The callback called once changing state is finished or is canceled.
         * @private
         */
        function() {
          throw new Error("_changeState() should be overridden to perform actual change in state.");
        }
      )
      /**
       * Changes the state of this component.
       * @param {string} [state] The new state. Can be an omitted, which means toggling.
       * @param {object} [detail]
       *   The object that should be put to event details that is fired before/after changing state.
       *   Can have a `group` property, which specifies what state to be changed.
       * @param {EventedState~changeStateCallback} [callback] The callback called once changing state is finished or is canceled.
       */
    }, {
      key: "changeState",
      value: function() {
        for (var i = this, o = arguments.length, l = new Array(o), c = 0; c < o; c++)
          l[c] = arguments[c];
        var d = typeof l[0] == "string" ? l.shift() : void 0, p = Object(l[0]) === l[0] && typeof l[0] != "function" ? l.shift() : void 0, h = typeof l[0] == "function" ? l.shift() : void 0;
        if (typeof this.shouldStateBeChanged == "function" && !this.shouldStateBeChanged(d, p)) {
          h && h(null, !0);
          return;
        }
        var u = {
          group: p && p.group,
          state: d
        }, g = [u.group, d].filter(Boolean).join("-").split("-").map(function(L) {
          return L[0].toUpperCase() + L.substr(1);
        }).join(""), m = new CustomEvent(this.options["eventBefore".concat(g)], {
          bubbles: !0,
          cancelable: !0,
          detail: p
        }), b = p && p.delegatorNode || this.element, v = !b.dispatchEvent(m);
        if (v) {
          if (h) {
            var S = new Error("Changing state (".concat(JSON.stringify(u), ") has been canceled."));
            S.canceled = !0, h(S);
          }
        } else {
          var O = [d, p].filter(Boolean);
          this._changeState.apply(this, gi(O).concat([function() {
            b.dispatchEvent(new CustomEvent(i.options["eventAfter".concat(g)], {
              bubbles: !0,
              cancelable: !0,
              detail: p
            })), h && h();
          }]));
        }
      }
      /* eslint-enable jsdoc/check-param-names */
      /**
       * Tests if change in state should happen or not.
       * Classes inheriting {@link EventedState `EventedState`} should override this function.
       * @function EventedState#shouldStateBeChanged
       * @param {string} [state] The new state. Can be an omitted, which means toggling.
       * @param {object} [detail]
       *   The object that should be put to event details that is fired before/after changing state.
       *   Can have a `group` property, which specifies what state to be changed.
       * @returns {boolean}
       *   `false` if change in state shouldn't happen, e.g. when the given new state is the same as the current one.
       */
    }]), n;
  }(r);
  return e;
}
function Ot(r, e) {
  var t = r.target, s = r.currentTarget;
  if (typeof t.matches == "function") {
    if (t.matches(e))
      return t;
    if (t.matches("".concat(e, " *"))) {
      var n = t.closest(e);
      if ((s.nodeType === Node.DOCUMENT_NODE ? s.documentElement : s).contains(n))
        return n;
    }
  }
}
function ns(r) {
  if (!r || typeof r == "function")
    return {
      launchingElement: null,
      launchingEvent: null
    };
  var e = r.delegateTarget || r.currentTarget || r, t = r.currentTarget && r;
  if (e && !e.nodeType)
    throw new TypeError("DOM Node should be given for launching element.");
  if (t && !t.type)
    throw new TypeError("DOM event should be given for launching event.");
  return {
    launchingElement: e,
    launchingEvent: t
  };
}
function Tt(r) {
  "@babel/helpers - typeof";
  return Tt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Tt(r);
}
function Mi(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function as(r, e) {
  for (var t = 0; t < e.length; t++) {
    var s = e[t];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(r, s.key, s);
  }
}
function Ai(r, e, t) {
  return e && as(r.prototype, e), t && as(r, t), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function Ci(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: r,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(r, "prototype", {
    writable: !1
  }), e && Lt(r, e);
}
function Lt(r, e) {
  return Lt = Object.setPrototypeOf || function(s, n) {
    return s.__proto__ = n, s;
  }, Lt(r, e);
}
function ki(r) {
  var e = Ri();
  return function() {
    var s = Ze(r), n;
    if (e) {
      var a = Ze(this).constructor;
      n = Reflect.construct(s, arguments, a);
    } else
      n = s.apply(this, arguments);
    return Ii(this, n);
  };
}
function Ii(r, e) {
  if (e && (Tt(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Di(r);
}
function Di(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function Ri() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ze(r) {
  return Ze = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Ze(r);
}
function _i(r) {
  var e = /* @__PURE__ */ function(t) {
    Ci(n, t);
    var s = ki(n);
    function n() {
      return Mi(this, n), s.apply(this, arguments);
    }
    return Ai(n, [{
      key: "show",
      value: (
        /**
         */
        /**
         * Switch to 'shown' state.
         * @param [evtOrElem] The launching event or element.
         * @param {EventedState~changeStateCallback} [callback] The callback.
         */
        function(i, o) {
          (!i || typeof i == "function") && (o = i), this.changeState("shown", ns(i), o);
        }
      )
      /**
       * Switch to 'hidden' state.
       * @param [evtOrElem] The launching event or element.
       * @param {EventedState~changeStateCallback} [callback] The callback.
       */
    }, {
      key: "hide",
      value: function(i, o) {
        (!i || typeof i == "function") && (o = i), this.changeState("hidden", ns(i), o);
      }
    }]), n;
  }(r);
  return e;
}
var Pi = [wi, _i];
const Vi = Pi;
var Ws = function() {
};
process.env.NODE_ENV !== "production" && (Ws = function(r, e, t) {
  var s = arguments.length;
  t = new Array(s > 2 ? s - 2 : 0);
  for (var n = 2; n < s; n++)
    t[n - 2] = arguments[n];
  if (e === void 0)
    throw new Error(
      "`warning(condition, format, ...args)` requires a warning message argument"
    );
  if (e.length < 10 || /^[s\W]*$/.test(e))
    throw new Error(
      "The warning format should be able to uniquely identify this warning. Please, use a more descriptive format than: " + e
    );
  if (!r) {
    var a = 0, i = "Warning: " + e.replace(/%s/g, function() {
      return t[a++];
    });
    typeof console < "u" && console.error(i);
    try {
      throw new Error(i);
    } catch {
    }
  }
});
var Bi = Ws;
const $i = /* @__PURE__ */ Tn(Bi);
function wt(r) {
  "@babel/helpers - typeof";
  return wt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, wt(r);
}
function Gi(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function is(r, e) {
  for (var t = 0; t < e.length; t++) {
    var s = e[t];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(r, s.key, s);
  }
}
function Ni(r, e, t) {
  return e && is(r.prototype, e), t && is(r, t), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function Hi(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: r,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(r, "prototype", {
    writable: !1
  }), e && Mt(r, e);
}
function Mt(r, e) {
  return Mt = Object.setPrototypeOf || function(s, n) {
    return s.__proto__ = n, s;
  }, Mt(r, e);
}
function Ui(r) {
  var e = Wi();
  return function() {
    var s = Xe(r), n;
    if (e) {
      var a = Xe(this).constructor;
      n = Reflect.construct(s, arguments, a);
    } else
      n = s.apply(this, arguments);
    return zi(this, n);
  };
}
function zi(r, e) {
  if (e && (wt(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Fi(r);
}
function Fi(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function Wi() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Xe(r) {
  return Xe = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Xe(r);
}
function ji(r) {
  var e = /* @__PURE__ */ function(t) {
    Hi(n, t);
    var s = Ui(n);
    function n() {
      return Gi(this, n), s.apply(this, arguments);
    }
    return Ni(n, null, [{
      key: "init",
      value: (
        /**
         * `true` suggests that this component is lazily initialized upon an action/event, etc.
         * @type {boolean}
         */
        /**
         * Instantiates this component in the given element.
         * If the given element indicates that it's an component of this class, instantiates it.
         * Otherwise, instantiates this component by clicking on launcher buttons
         * (buttons with attribute that `options.attribInitTarget` points to) of this component in the given node.
         * @param {Node} target The DOM node to instantiate this component in. Should be a document or an element.
         * @param {object} [options] The component options.
         * @param {string} [options.selectorInit] The CSS selector to find this component.
         * @param {string} [options.attribInitTarget] The attribute name in the launcher buttons to find target component.
         * @returns {Handle} The handle to remove the event listener to handle clicking.
         */
        function() {
          var i = this, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = Object.assign(Object.create(this.options), l);
          if (!o || o.nodeType !== Node.ELEMENT_NODE && o.nodeType !== Node.DOCUMENT_NODE)
            throw new TypeError("DOM document or DOM element should be given to search for and initialize this widget.");
          if (o.nodeType === Node.ELEMENT_NODE && o.matches(c.selectorInit))
            this.create(o, l);
          else {
            var d = c.initEventNames.map(function(p) {
              return Ve(o, p, function(h) {
                var u = Ot(h, "[".concat(c.attribInitTarget, "]"));
                if (u) {
                  h.delegateTarget = u;
                  var g = u.ownerDocument.querySelectorAll(u.getAttribute(c.attribInitTarget));
                  if (g.length > 1)
                    throw new Error("Target widget must be unique.");
                  if (g.length === 1) {
                    u.tagName === "A" && h.preventDefault();
                    var m = i.create(g[0], l);
                    typeof m.createdByLauncher == "function" && m.createdByLauncher(h);
                  }
                }
              });
            });
            return {
              release: function() {
                for (var h = d.pop(); h; h = d.pop())
                  h.release();
              }
            };
          }
          return "";
        }
      )
    }]), n.forLazyInit = !0, n;
  }(r);
  return e;
}
function At(r) {
  "@babel/helpers - typeof";
  return At = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, At(r);
}
function Zi(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function rs(r, e) {
  for (var t = 0; t < e.length; t++) {
    var s = e[t];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(r, s.key, s);
  }
}
function Xi(r, e, t) {
  return e && rs(r.prototype, e), t && rs(r, t), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function Yi(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: r,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(r, "prototype", {
    writable: !1
  }), e && Ct(r, e);
}
function Ct(r, e) {
  return Ct = Object.setPrototypeOf || function(s, n) {
    return s.__proto__ = n, s;
  }, Ct(r, e);
}
function qi(r) {
  var e = Qi();
  return function() {
    var s = Ye(r), n;
    if (e) {
      var a = Ye(this).constructor;
      n = Reflect.construct(s, arguments, a);
    } else
      n = s.apply(this, arguments);
    return Ki(this, n);
  };
}
function Ki(r, e) {
  if (e && (At(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ji(r);
}
function Ji(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function Qi() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ye(r) {
  return Ye = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Ye(r);
}
var er = /* @__PURE__ */ function(r) {
  Yi(t, r);
  var e = qi(t);
  function t(s, n) {
    var a;
    return Zi(this, t), a = e.call(this, s, n), a._handleFocusinListener = void 0, a._handleKeydownListener = void 0, a._handleFocusin = function(i) {
      var o = a.element.querySelector(a.options.selectorModalContainer) || a.element;
      a.element.classList.contains(a.options.classVisible) && !o.contains(i.target) && a.options.selectorsFloatingMenus.every(function(l) {
        return !Ot(i, l);
      }) && a.element.querySelector(ct.selectorTabbable).focus();
    }, a._hookCloseActions(), a;
  }
  return Xi(t, [{
    key: "createdByLauncher",
    value: (
      /**
       * A method that runs when `.init()` is called from `initComponentByLauncher`.
       * @param {Event} evt The event fired on the launcher button.
       */
      function(n) {
        this.show(n);
      }
    )
    /**
     * Determines whether or not to emit events and callback function when `.changeState()` is called from `eventedState`.
     * @param {string} state The new state.
     * @returns {boolean} `true` if the given `state` is different from current state.
     */
  }, {
    key: "shouldStateBeChanged",
    value: function(n) {
      return n === "shown" ? !this.element.classList.contains(this.options.classVisible) : this.element.classList.contains(this.options.classVisible);
    }
    /**
     * Changes the shown/hidden state.
     * @private
     * @param {string} state The new state.
     * @param {object} detail The detail data to be included in the event that will be fired.
     * @param {Function} callback Callback called when change in state completes.
     */
  }, {
    key: "_changeState",
    value: function(n, a, i) {
      var o = this, l, c = function() {
        if (l && (l = o.unmanage(l).release()), n === "shown" && o.element.offsetWidth > 0 && o.element.offsetHeight > 0) {
          o.previouslyFocusedNode = o.element.ownerDocument.activeElement;
          var u = o.element.querySelector(o.options.selectorPrimaryFocus) || o.element.querySelector(ct.selectorTabbable);
          u.focus(), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && $i(u, "Modals need to contain a focusable element by either using " + "`".concat(o.options.selectorPrimaryFocus, "` or settings.selectorTabbable."));
        }
        i();
      };
      if (this._handleFocusinListener && (this._handleFocusinListener = this.unmanage(this._handleFocusinListener).release()), n === "shown") {
        var d = "onfocusin" in this.element.ownerDocument.defaultView, p = d ? "focusin" : "focus";
        this._handleFocusinListener = this.manage(Ve(this.element.ownerDocument, p, this._handleFocusin, !d));
      }
      n === "hidden" ? (this.element.classList.toggle(this.options.classVisible, !1), this.element.ownerDocument.body.classList.toggle(this.options.classBody, !1), (this.options.selectorFocusOnClose || this.previouslyFocusedNode) && (this.element.ownerDocument.querySelector(this.options.selectorFocusOnClose) || this.previouslyFocusedNode).focus()) : n === "shown" && (this.element.classList.toggle(this.options.classVisible, !0), this.element.ownerDocument.body.classList.toggle(this.options.classBody, !0)), l = this.manage(Ve(this.element, "transitionend", c));
    }
  }, {
    key: "_hookCloseActions",
    value: function() {
      var n = this;
      this.manage(Ve(this.element, "click", function(a) {
        var i = Ot(a, n.options.selectorModalClose);
        i && (a.delegateTarget = i), (i || a.target === n.element) && n.hide(a);
      })), this._handleKeydownListener && (this._handleKeydownListener = this.unmanage(this._handleKeydownListener).release()), this._handleKeydownListener = this.manage(Ve(this.element.ownerDocument.body, "keydown", function(a) {
        a.which === 27 && n.shouldStateBeChanged("hidden") && (a.stopPropagation(), n.hide(a));
      }));
    }
    /**
     * Handles `focusin` (or `focus` depending on browser support of `focusin`) event to do wrap-focus behavior.
     * @param {Event} evt The event.
     * @private
     */
  }], [{
    key: "options",
    get: (
      /**
       * The component options.
       * If `options` is specified in the constructor, {@linkcode Modal.create .create()}, or {@linkcode Modal.init .init()},
       * properties in this object are overridden for the instance being create and how {@linkcode Modal.init .init()} works.
       * @member Modal.options
       * @type {object}
       * @property {string} selectorInit The CSS class to find modal dialogs.
       * @property {string} [selectorModalClose] The selector to find elements that close the modal.
       * @property {string} [selectorPrimaryFocus] The CSS selector to determine the element to put focus when modal gets open.
       * @property {string} [selectorFocusOnClose] The CSS selector to determine the element to put focus when modal closes.
       *   If undefined, focus returns to the previously focused element prior to the modal opening.
       * @property {string} [selectorModalContainer] The CSS selector for the content container of the modal for focus wrap feature.
       * @property {string} attribInitTarget The attribute name in the launcher buttons to find target modal dialogs.
       * @property {string[]} [selectorsFloatingMenu]
       *   The CSS selectors of floating menus.
       *   Used for detecting if focus-wrap behavior should be disabled temporarily.
       * @property {string} [classVisible] The CSS class for the visible state.
       * @property {string} [classBody] The CSS class for `<body>` with open modal.
       * @property {string} [classNoScroll] The CSS class for hiding scroll bar in body element while modal is shown.
       * @property {string} [eventBeforeShown]
       *   The name of the custom event fired before this modal is shown.
       *   Cancellation of this event stops showing the modal.
       * @property {string} [eventAfterShown]
       *   The name of the custom event telling that modal is sure shown
       *   without being canceled by the event handler named by `eventBeforeShown` option (`modal-beingshown`).
       * @property {string} [eventBeforeHidden]
       *   The name of the custom event fired before this modal is hidden.
       *   Cancellation of this event stops hiding the modal.
       * @property {string} [eventAfterHidden]
       *   The name of the custom event telling that modal is sure hidden
       *   without being canceled by the event handler named by `eventBeforeHidden` option (`modal-beinghidden`).
       */
      function() {
        var n = ct.prefix;
        return {
          selectorInit: "[data-modal]",
          selectorModalClose: "[data-modal-close]",
          selectorPrimaryFocus: "[data-modal-primary-focus]",
          selectorsFloatingMenus: [".".concat(n, "--overflow-menu-options"), ".".concat(n, "--tooltip"), ".flatpickr-calendar"],
          selectorModalContainer: ".".concat(n, "--modal-container"),
          classVisible: "is-visible",
          classBody: "".concat(n, "--body--with-modal-open"),
          attribInitTarget: "data-modal-target",
          initEventNames: ["click"],
          eventBeforeShown: "modal-beingshown",
          eventAfterShown: "modal-shown",
          eventBeforeHidden: "modal-beinghidden",
          eventAfterHidden: "modal-hidden"
        };
      }
    )
  }]), t.components = /* @__PURE__ */ new WeakMap(), t;
}(Ka(ai, ji, Vi, pi));
const tr = er;
class ic extends z {
  constructor(e, t, s) {
    super(e, t, s), this.type = "modal", this.isEventListenerAdded = !1, this.handleShowModal = () => {
      this.modal.html(this.getModalHTML()), this.modal.select("div.cds--modal-footer button.cds--btn").on("click", () => this.model.exportToCSV()), tr.create(this.modal.node()).show();
    }, this.init();
  }
  addEventListeners() {
    this.services.events.addEventListener(f.Modal.SHOW, this.handleShowModal);
  }
  removeEventListeners() {
    this.services.events.removeEventListener(f.Modal.SHOW, this.handleShowModal);
  }
  getModalHTML() {
    const e = this.model.getOptions(), t = y(e, "style", "prefix"), s = this.model.getTabularDataArray();
    return `
		<div class="cds--modal-container cds--modal-container">
			<div class="cds--modal-header cds--modal-header">
				<p class="cds--modal-header__label cds--type-delta cds--modal-header__label cds--type-delta" id="modal-title">Tabular representation</p>

				<p class="cds--modal-header__heading cds--type-beta cds--modal-header__heading cds--type-beta" id="modal-description">${e.title}</p>

				<button class="cds--modal-close cds--modal-close" type="button" data-modal-close aria-label="close modal"  data-modal-primary-focus>
					<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-label="Close" width="20" height="20" viewBox="0 0 32 32" role="img" class="cds--modal-close__icon cds--modal-close__icon">
						<path d="M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"></path>
					</svg>
				</button>
			</div>

			<div class="cds--modal-content cds--modal-content">
				<table class="cds--data-table cds--data-table--no-border cds--data-table cds--data-table--no-border">
					<thead>
						<tr>
							${Q(s, 0).map(
      (n) => `<th scope="col">
								<div class="cds--table-header-label cds--table-header-label">${n}</div>
							</th>`
    ).join("")}
						</tr>
					</thead>

					<tbody>${s.slice(1).map(
      (n) => `
							<tr>
								${n.map((a) => `<td>${a}</td>`).join("")}
							</tr>`
    ).join("")}
					</tbody>
				</table>
			</div>

			<div class="cds--modal-footer cds--modal-footer">
			  <div class="${he}--${t}-modal-footer-spacer"></div>
			  <button class="cds--btn cds--btn--primary cds--btn cds--btn--primary" type="button" data-modal-primary-focus>Download as CSV</button>
			</div>
		</div>`;
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    const t = this.model.getOptions();
    if (!this.isEventListenerAdded) {
      const s = x(this.services.domUtils.getHolder()), n = y(t, "style", "prefix");
      this.modal = E.appendOrSelect(s, `div.${he}--${n}--modal`), this.addEventListeners(), this.isEventListenerAdded = !0, this.modal.attr("data-modal", !0).attr("class", "cds--modal cds--modal").attr("role", "dialog").attr("aria-modal", !0).attr("aria-labelledby", "modal-title").attr("aria-describedby", "modal-description").attr("tabindex", -1);
    }
  }
  destroy() {
    this.removeEventListeners(), this.isEventListenerAdded = !1;
  }
}
class sr extends z {
  constructor() {
    super(...arguments), this.type = "title", this.renderType = H.HTML;
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    const t = this.getComponentContainer(), s = y(this.getOptions(), "title"), n = t.selectAll("p.title").data([s]);
    if (n.enter().append("p").classed("title", !0).attr("role", "heading").attr("aria-level", 2).merge(n).html((a) => a), n.node() && n.node().offsetWidth < n.node().scrollWidth) {
      const a = this;
      n.on("mouseover", function(i) {
        a.services.events.dispatchEvent(f.Tooltip.SHOW, {
          event: i,
          hoveredElement: n,
          content: n.text()
        });
      }).on("mousemove", function(i) {
        a.services.events.dispatchEvent(f.Tooltip.MOVE, {
          event: i
        });
      }).on("mouseout", function() {
        a.services.events.dispatchEvent(f.Tooltip.HIDE);
      });
    }
    n.exit().remove();
  }
  /**
   * Truncates title creating ellipses and attaching tooltip for exposing full title.
   */
  truncateTitle(e, t) {
    if (t <= 0)
      return;
    const s = e.text();
    if (e.node().getComputedTextLength() > t) {
      e.append("tspan").text("...");
      const n = E.appendOrSelect(e, "tspan").node().getComputedTextLength(), a = e.text(), i = this.getSubstringIndex(
        e.node(),
        0,
        a.length - 1,
        t - n
      );
      e.html(a.substring(0, i - 1)).append("tspan").text("...");
      const o = this;
      e.on("mouseover", function(l) {
        o.services.events.dispatchEvent(f.Tooltip.SHOW, {
          event: l,
          hoveredElement: e,
          content: s
        });
      }).on("mousemove", function(l) {
        o.services.events.dispatchEvent(f.Tooltip.MOVE, {
          event: l
        });
      }).on("mouseout", function() {
        o.services.events.dispatchEvent(f.Tooltip.HIDE);
      });
    }
  }
  // computes the maximum space a title can take
  getMaxTitleWidth() {
    return E.getSVGElementSize(this.parent.node(), {
      useAttrs: !0
    }).width;
  }
  /**
   * Returns the index for a maximum length substring that is less than the width parameter.
   * @param title the title node used for getting the text lengths of substrings
   * @param start the start index for the binary search
   * @param end the end index for the binary search
   * @param width the width of the svg container that holds the title
   */
  getSubstringIndex(e, t, s, n) {
    const a = Math.floor((s + t) / 2);
    return e.getSubStringLength(0, a) > n ? this.getSubstringIndex(e, t, a, n) : e.getSubStringLength(0, a) < n ? e.getSubStringLength(0, a + 1) > n ? a : this.getSubstringIndex(e, a, s, n) : a;
  }
}
class nr extends z {
  constructor() {
    super(...arguments), this.type = "legend", this.renderType = H.HTML;
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    const t = this.getOptions(), s = y(t, "legend"), n = y(s, "alignment"), a = y(t, "legend", "orientation");
    let i = this.model.getDataGroups();
    const { DISABLED: o } = J.items.status, l = i.some((S) => S.status === o), c = y(s, "order"), d = this.getComponentContainer().classed("center-aligned", n === ue.CENTER).classed("right-aligned", n === ue.RIGHT).classed(a, !0).classed("has-deactivated-items", l).attr("role", U.GROUP).attr("aria-label", "Data groups").attr("data-name", "legend-items");
    c && (i = this.sortDataGroups(i, c));
    const p = d.selectAll("div.legend-item").data(i, (S) => S.name), h = p.enter().append("div").attr("class", "legend-item");
    h.merge(d.selectAll("div.legend-item")).classed("active", function(S) {
      return S.status === J.items.status.ACTIVE;
    });
    const u = y(this.getOptions(), "legend", "clickable");
    d.classed("clickable", u && i.length > 1);
    const g = J.checkbox.radius, m = h.append("div").classed("checkbox", !0), b = m.merge(p.select("div.checkbox")).attr("role", U.CHECKBOX).attr("tabindex", u ? 0 : -1).attr(
      "aria-labelledby",
      (S, O) => this.services.domUtils.generateElementIDString(`legend-datagroup-${O}-title`)
    ).attr("aria-checked", ({ status: S }) => S === J.items.status.ACTIVE).attr("width", g * 2).attr("height", g * 2).attr(
      "class",
      (S) => this.model.getColorClassName({
        classNameTypes: [$.BACKGROUND],
        dataGroupName: S.name,
        originalClassName: "checkbox"
      })
    ).style(
      "background",
      (S) => S.status === J.items.status.ACTIVE ? this.model.getFillColor(S.name) || this.model.getStrokeColor(S.name) : null
    ).classed("active", function(S) {
      return S.status === J.items.status.ACTIVE;
    });
    m.append("svg").attr("focusable", !1).attr("preserveAspectRatio", "xMidYMid meet").attr("xmlns", "http://www.w3.org/2000/svg").attr("width", "11").attr("height", "11").attr("viewBox", "0 0 31 28").attr("aria-hidden", !0).style("will-change", "transform").append("path").attr("d", "M13 21.2l-7.1-7.1-1.4 1.4 7.1 7.1L13 24 27.1 9.9l-1.4-1.5z"), h.append("p").merge(p.select("p"));
    const v = y(t, "legend", "additionalItems");
    if (v && i.length) {
      const S = this, O = d.selectAll("div.additional-item").data(v);
      O.exit().remove();
      const L = O.enter().append("div").merge(O).classed("legend-item", !0).classed("additional", !0).attr(
        "aria-labelledby",
        (k, _) => this.services.domUtils.generateElementIDString(
          `legend-datagroup-${b.size() + _}-title`
        )
      );
      L.selectAll("*").remove();
      let w, T = 1;
      L.append("svg").classed("icon", !0).each(function(k) {
        const _ = x(this);
        !w || w != k.type ? (w = k.type, T = 1) : T++, S.addAdditionalItem(_, k, T);
      }), L.append("p").merge(L.select("p")), this.truncateLegendText();
    }
    p.exit().on("mouseover", null).on("click", null).on("mouseout", null).remove(), u && h.size() > 1 && this.addEventListeners();
  }
  sortDataGroups(e, t) {
    if (e.sort(
      (s, n) => t.indexOf(s.name) - t.indexOf(n.name)
    ), t.length < e.length) {
      const s = e.length - t.length;
      return e.slice(s).concat(e.slice(0, s));
    }
    return e;
  }
  addAdditionalItem(e, t, s) {
    const { width: n, height: a } = J.area;
    if (t.type === Se.RADIUS ? e.style("width", `${a}px`).style("height", `${a}px`) : e.style("width", `${n}px`).style("height", `${a}px`), t.type === Se.RADIUS) {
      const { iconData: i, fill: o, stroke: l } = J.radius;
      e.attr("fill", "none").selectAll("circle").data(i).enter().append("circle").classed("radius", !0).attr("role", U.IMG).attr("aria-label", "radius").attr("cx", (d) => d.cx).attr("cy", (d) => d.cy).attr("r", (d) => d.r).style("fill", t.fill ? t.fill : o).style("stroke", t.stroke ? t.stroke : l);
    } else if (t.type === Se.LINE) {
      const i = J.line;
      e.select("line.line").empty() && e.append("line").classed(`line-${s}`, !0).attr("role", U.IMG).attr("aria-label", "line").attr("x1", 0).attr("y1", i.yPosition).attr("x2", n).attr("y2", i.yPosition).style("stroke", t.stroke ? t.stroke : i.stroke).style("stroke-width", i.strokeWidth);
    } else if (t.type === Se.AREA)
      e.select("rect.area").empty() && e.append("rect").classed(`area-${s}`, !0).attr("role", U.IMG).attr("aria-label", "area").attr("width", n).attr("height", a).style("fill", s > 3 && !t.fill ? J.area.fill : t.fill).style("stroke", t.stroke);
    else if (t.type === Se.SIZE) {
      const { iconData: i, fill: o, stroke: l } = J.size;
      e.attr("fill", "none").attr("role", U.IMG).attr("aria-label", "size").selectAll("rect").data(i).enter().append("rect").classed("size", !0).attr("width", (d) => d.width).attr("height", (d) => d.height).attr("y", () => 0).style("fill", t.fill ? t.fill : o).style("stroke", t.stroke ? t.stroke : l).style("stroke-width", 1);
    } else if (t.type === Se.QUARTILE) {
      const { iconData: i } = J.quartile;
      e.selectAll("rect").attr("role", U.IMG).attr("aria-label", "quartile").data(i).enter().append("rect").attr("class", (l, c) => `quartile-${c === 0 ? "wrapper" : "line"}`).attr("x", (l) => l.x).attr("y", (l) => l.y).attr("width", (l) => l.width).attr("height", (l) => l.height);
    } else if (t.type === Se.ZOOM) {
      const { iconData: i, color: o } = y(Os, "legend", "zoom"), l = e.attr("role", U.IMG).attr("aria-label", "zoom").selectAll("g.icon").data(i).enter();
      l.append("g").attr("x", (c) => c.x).attr("y", (c) => c.y).attr("width", (c) => c.width).attr("height", (c) => c.height).append("polygon").attr(
        "points",
        "7.7 4.82 5.78 4.82 5.78 2.89 4.82 2.89 4.82 4.82 2.89 4.82 2.89 5.78 4.82 5.78 4.82 7.7 5.78 7.7 5.78 5.78 7.7 5.78 7.7 4.82"
      ).attr("fill", () => t.color ? t.color : o), l.append("path").attr(
        "d",
        "M9.36,8.67A5.22,5.22,0,0,0,10.59,5.3,5.3,5.3,0,1,0,5.3,10.59,5.22,5.22,0,0,0,8.67,9.36L12.32,13l.68-.68Zm-4.06,1A4.34,4.34,0,1,1,9.63,5.3,4.33,4.33,0,0,1,5.3,9.63Z"
      ).attr("fill", () => t.color ? t.color : o);
    }
  }
  truncateLegendText() {
    const e = this.getComponentContainer(), t = y(this.getOptions(), "legend", "truncation"), s = y(t, "type"), n = y(t, "threshold"), a = y(t, "numCharacter"), i = e.selectAll("div.legend-item p");
    i.attr("id", function() {
      return (this.parentNode.querySelector("div.checkbox") || this.parentNode).getAttribute("aria-labelledby");
    }), s !== ke.NONE ? i.html(function(o) {
      return o.name.length > n ? $e(o.name, s, a) : o.name;
    }) : i.html((o) => o.name);
  }
  addEventListeners() {
    const e = this, t = this.getComponentContainer(), s = this.getOptions(), n = y(s, "legend"), a = y(n, "truncation");
    t.selectAll("div.legend-item").on("mouseover", function(i) {
      e.services.events.dispatchEvent(f.Legend.ITEM_HOVER, {
        hoveredElement: x(this)
      });
      const o = x(this);
      o.select("div.checkbox").classed("hovered", !0);
      const l = o.datum();
      l.name.length > a.threshold && a.type !== ke.NONE && e.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: i,
        hoveredElement: o,
        content: l.name
      });
    }).on("mousemove", function(i) {
      x(this).datum().name.length > a.threshold && a.type !== ke.NONE && e.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: i
      });
    }).on("click", function() {
      e.services.events.dispatchEvent(f.Legend.ITEM_CLICK, {
        clickedElement: x(this)
      });
      const o = x(this).datum();
      e.model.toggleDataLabel(o.name);
    }).on("mouseout", function() {
      const i = x(this);
      i.select("div.checkbox").classed("hovered", !1), i.datum().name.length > a.threshold && a.type !== ke.NONE && e.services.events.dispatchEvent(f.Tooltip.HIDE), e.services.events.dispatchEvent(f.Legend.ITEM_MOUSEOUT, {
        hoveredElement: i
      });
    }), t.selectAll("div.legend-item div.checkbox").on("keyup", function(i) {
      i.key && i.key === "Tab" && e.services.events.dispatchEvent(f.Legend.ITEM_HOVER, {
        hoveredElement: x(this)
      });
    }), t.selectAll("div.legend-item div.checkbox").on("keydown", function(i, o) {
      i.key && i.key === " " ? (i.preventDefault(), e.model.toggleDataLabel(o.name)) : i.key && i.key === "Tab" && e.services.events.dispatchEvent(f.Legend.ITEM_MOUSEOUT, {
        hoveredElement: x(this)
      });
    }), t.selectAll("g.additional-item").on("mouseover", function(i) {
      const o = x(this), l = o.datum();
      l.name.length > a.threshold && e.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: i,
        hoveredElement: o,
        content: l.name
      });
    });
  }
}
class ar extends z {
  constructor(e, t, s) {
    super(e, t, s), this.type = "chart-clip", this.renderType = H.SVG, this.chartClipId = "chart-clip-id-" + Math.floor(Math.random() * 99999999999), this.init();
  }
  init() {
    this.model.set({ chartClipId: this.chartClipId }, { skipUpdate: !0 });
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    this.createClipPath();
  }
  createClipPath() {
    const e = this.parent, { cartesianScales: t } = this.services;
    if (!t)
      throw new Error("Service cartesianScales was undefined");
    const s = t.getMainXScale(), n = t.getMainYScale(), [a, i] = s.range(), [o, l] = n.range();
    if (!e)
      throw new Error("svg is undefined");
    this.chartClipPath = E.appendOrSelect(e, `clipPath.${this.type}`).attr(
      "id",
      this.chartClipId
    );
    const c = E.appendOrSelect(this.chartClipPath, `rect.${this.type}`);
    i - a > 0 && c.attr("x", a).attr("y", l).attr("width", i - a).attr("height", o - l), this.chartClipPath.merge(c).lower();
  }
}
class rc extends ar {
  constructor() {
    super(...arguments), this.type = "canvas-chart-clip", this.chartClipId = "canvas-chart-clip-id-" + Math.floor(Math.random() * 99999999999);
  }
  createClipPath() {
    const e = this.parent, { width: t, height: s } = E.getSVGElementSize(this.parent, {
      useAttrs: !0
    });
    this.chartClipPath = E.appendOrSelect(e, `clipPath.${this.type}`).attr(
      "id",
      this.chartClipId
    );
    const n = E.appendOrSelect(this.chartClipPath, `rect.${this.type}`);
    n.attr("x", 0).attr("y", 0).attr("width", t).attr("height", s), this.chartClipPath.merge(n).lower();
  }
}
var Me, ne;
(function(r) {
  r.LEFT = "left", r.RIGHT = "right", r.TOP = "top", r.BOTTOM = "bottom";
})(ne || (ne = {}));
var os = (Me = {}, Me[ne.LEFT] = function(r, e, t) {
  return {
    top: r.top - Math.round(e.offsetHeight / 2) + Math.round(t.height / 2),
    left: Math.round(r.left - e.offsetWidth)
  };
}, Me[ne.RIGHT] = function(r, e, t) {
  return {
    top: r.top - Math.round(e.offsetHeight / 2) + Math.round(t.height / 2),
    left: Math.round(r.left + t.width)
  };
}, Me[ne.TOP] = function(r, e, t) {
  return {
    top: Math.round(r.top - e.offsetHeight),
    left: r.left - Math.round(e.offsetWidth / 2) + Math.round(t.width / 2)
  };
}, Me[ne.BOTTOM] = function(r, e, t) {
  return {
    top: Math.round(r.top + t.height),
    left: r.left - Math.round(e.offsetWidth / 2) + Math.round(t.width / 2)
  };
}, Me), ls = typeof window < "u" ? window : {
  innerHeight: 0,
  scrollY: 0,
  innerWidth: 0,
  scrollX: 0
}, Je = (
  /** @class */
  function() {
    function r(e) {
      e === void 0 && (e = {}), this.positions = os, this.positions = Object.assign({}, os, e);
    }
    return r.prototype.getRelativeOffset = function(e) {
      for (var t = {
        left: e.offsetLeft,
        top: e.offsetTop
      }; e.offsetParent && getComputedStyle(e.offsetParent).position === "static"; )
        t.left += e.offsetLeft, t.top += e.offsetTop, e = e.offsetParent;
      return t;
    }, r.prototype.getAbsoluteOffset = function(e) {
      for (var t = e, s = {
        top: 0,
        left: 0
      }; t.offsetParent; ) {
        var n = getComputedStyle(t.offsetParent);
        n.position === "static" && n.marginLeft && n.marginTop && (parseInt(n.marginTop, 10) && (s.top += parseInt(n.marginTop, 10)), parseInt(n.marginLeft, 10) && (s.left += parseInt(n.marginLeft, 10))), t = t.offsetParent;
      }
      var a = e.getBoundingClientRect(), i = document.body.getBoundingClientRect();
      return {
        top: a.top - i.top + s.top,
        left: a.left - i.left + s.left
      };
    }, r.prototype.findRelative = function(e, t, s) {
      var n = this.getRelativeOffset(e), a = e.getBoundingClientRect();
      return this.calculatePosition(n, a, t, s);
    }, r.prototype.findAbsolute = function(e, t, s) {
      var n = this.getAbsoluteOffset(e), a = e.getBoundingClientRect();
      return this.calculatePosition(n, a, t, s);
    }, r.prototype.findPosition = function(e, t, s, n) {
      n === void 0 && (n = this.getAbsoluteOffset.bind(this));
      var a = n(e), i = e.getBoundingClientRect();
      return this.calculatePosition(a, i, t, s);
    }, r.prototype.findPositionAt = function(e, t, s) {
      return this.calculatePosition(e, { top: 0, left: 0, height: 0, width: 0 }, t, s);
    }, r.prototype.getPlacementBox = function(e, t) {
      var s = e.offsetHeight + t.top, n = e.offsetWidth + t.left;
      return {
        top: t.top,
        bottom: s,
        left: t.left,
        right: n
      };
    }, r.prototype.addOffset = function(e, t, s) {
      return t === void 0 && (t = 0), s === void 0 && (s = 0), Object.assign({}, e, {
        top: e.top + t,
        left: e.left + s
      });
    }, r.prototype.setElement = function(e, t) {
      e.style.top = t.top + "px", e.style.left = t.left + "px";
    }, r.prototype.findBestPlacement = function(e, t, s, n, a) {
      var i = this;
      n === void 0 && (n = this.defaultContainerFunction.bind(this)), a === void 0 && (a = this.findPosition.bind(this));
      var o = s.map(function(l) {
        var c = a(e, t, l), d = i.getPlacementBox(t, c), p = 0, h = 0, u = n();
        d.top < u.top ? p = u.top - d.top : d.bottom > u.height && (p = d.bottom - u.height), d.left < u.left ? h = u.left - d.left : d.right > u.width && (h = d.right - u.width), p && !h ? h = 1 : h && !p && (p = 1);
        var g = t.offsetHeight * t.offsetWidth, m = p * h, b = g - m, v = b / g;
        return {
          placement: l,
          weight: v
        };
      });
      return o.sort(function(l, c) {
        return c.weight - l.weight;
      }), o[0].placement;
    }, r.prototype.findBestPlacementAt = function(e, t, s, n) {
      var a = this;
      n === void 0 && (n = this.defaultContainerFunction.bind(this));
      var i = function(o, l, c) {
        return a.findPositionAt(e, l, c);
      };
      return this.findBestPlacement(null, t, s, n, i);
    }, r.prototype.defaultContainerFunction = function() {
      return {
        // we go with window here, because that's going to be the simple/common case
        top: 0,
        left: 0,
        height: ls.innerHeight,
        width: ls.innerWidth
      };
    }, r.prototype.calculatePosition = function(e, t, s, n) {
      return this.positions[n] ? this.positions[n](e, s, t) : (console.error("No function found for placement, defaulting to 0,0"), { left: 0, top: 0 });
    }, r;
  }()
);
new Je();
class ir extends z {
  constructor(e, t, s) {
    super(e, t, s), this.type = "tooltip", this.renderType = H.HTML, this.isEventListenerAdded = !1, this.positionService = new Je(), this.handleShowTooltip = (n) => {
      const a = n.detail.data || n.detail.items;
      let i;
      const o = this.formatItems(this.getItems(n));
      n.detail.content ? i = `<div class="title-tooltip"><p>${n.detail.content}</p></div>` : i = this.getTooltipHTML(o);
      const l = E.appendOrSelect(this.tooltip, "div.content-box");
      if (y(this.getOptions(), "tooltip", "customHTML"))
        if (n.detail.content) {
          const c = `<div class="title-tooltip"><p>${n.detail.content}</p></div>`;
          l.html(c);
        } else
          l.html(this.model.getOptions().tooltip.customHTML(a, i));
      else
        l.html(i);
      l.selectAll(".datapoint-tooltip").each(function(c, d) {
        const p = o[d];
        o[d] && o[d].color && x(this).select(".tooltip-color").attr("class", "tooltip-color").style("background-color", p.color);
      }), this.positionTooltip(n), this.tooltip.classed("hidden", !1).attr("aria-hidden", !1);
    }, this.handleHideTooltip = () => {
      this.tooltip.classed("hidden", !0).attr("aria-hidden", !0);
    }, this.init();
  }
  addTooltipEventListener() {
    this.services.events.addEventListener(f.Tooltip.MOVE, (e) => {
      this.tooltip.classed("hidden") === !1 && this.positionTooltip(e);
    }), this.services.events.addEventListener(f.Tooltip.SHOW, this.handleShowTooltip), this.services.events.addEventListener(f.Tooltip.HIDE, this.handleHideTooltip), this.services.events.addEventListener(f.Chart.MOUSEOUT, this.handleHideTooltip);
  }
  removeTooltipEventListener() {
    this.services.events.removeEventListener(f.Tooltip.MOVE, null), this.services.events.removeEventListener(f.Tooltip.SHOW, this.handleShowTooltip), this.services.events.removeEventListener(f.Tooltip.HIDE, this.handleHideTooltip), this.services.events.removeEventListener(f.Chart.MOUSEOUT, this.handleHideTooltip);
  }
  getItems(e) {
    return e.detail.items ? e.detail.items : [];
  }
  formatItems(e) {
    const t = this.getOptions(), s = y(t, "tooltip", "truncation", "type"), n = y(t, "tooltip", "truncation", "threshold"), a = y(t, "tooltip", "truncation", "numCharacter");
    return s !== ke.NONE ? e.map((i) => {
      const o = i.labelIcon ? 12 : 0;
      return i.value = i.value ? this.valueFormatter(i.value, i.label) : i.value, i.label && i.label.length + o > n && (i.label = $e(i.label, s, a)), i.value && i.value.length > n && (i.value = $e(i.value, s, a)), i;
    }) : e;
  }
  getTooltipHTML(e) {
    return '<ul class="multi-tooltip">' + e.map(
      (t) => `<li>
					<div class="datapoint-tooltip${t.bold ? " bold" : ""}">
						${t.class || t.color ? `<div class="tooltip-color ${t.class}"></div>` : ""}
						<div class="label">
						<p>${t.label || ""}</p>
						${t.labelIcon ? `<span class="label-icon"/>${t.labelIcon}</span>` : ""}
						</div>
						${t.value === void 0 || t.value === null ? "" : `<p class="value"/>${t.value}</p>`}
					</div>
				</li>`
    ).join("") + "</ul>";
  }
  valueFormatter(e, t) {
    const s = this.getOptions(), n = y(s, "tooltip", "valueFormatter");
    if (n)
      return n(e, t);
    if (typeof e.getTime == "function")
      return Ut(e, "MMM d, yyyy");
    try {
      if (typeof e == "string" && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(e))
        return Ut(Date.parse(e), "MMM d, yyyy");
    } catch {
    }
    return e.toLocaleString();
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    const t = this.getOptions(), s = y(t, "tooltip", "enabled");
    if (s) {
      const n = x(this.services.domUtils.getHolder()), a = y(t, "style", "prefix");
      this.tooltip = E.appendOrSelect(n, `div.${he}--${a}--tooltip`), this.tooltip.style("max-width", null).attr("role", "tooltip"), this.isEventListenerAdded || (this.addTooltipEventListener(), this.isEventListenerAdded = !0), this.tooltip.classed("hidden", !0);
    } else
      !s && this.isEventListenerAdded && (this.removeTooltipEventListener(), this.isEventListenerAdded = !1);
  }
  positionTooltip(e) {
    const t = this.services.domUtils.getHolder(), s = this.tooltip.node(), n = this.getOptions(), a = y(n, "zoomBar", "top", "enabled");
    let i = y(e, "detail", "mousePosition");
    if (!i)
      i = qe(y(e, "detail", "event"), t);
    else {
      const h = y(n, "zoomBar", "top", "type"), u = de.height[h];
      a && (i[1] += u + de.spacerHeight);
    }
    const o = t.offsetWidth, l = t.offsetHeight;
    let c;
    i[0] / o > 0.9 ? c = ne.LEFT : i[0] / o < 0.1 ? c = ne.RIGHT : c = this.positionService.findBestPlacementAt(
      {
        left: i[0],
        top: i[1]
      },
      s,
      [ne.RIGHT, ne.LEFT, ne.TOP, ne.BOTTOM],
      () => ({
        top: void 0,
        // properties were never set to optional (probably should)
        left: void 0,
        // ditto
        width: o,
        height: l
      })
    );
    let { horizontalOffset: d } = Ln;
    c === ne.LEFT && (d *= -1);
    const p = this.positionService.findPositionAt(
      {
        left: i[0] + d,
        top: i[1]
      },
      s,
      c
    );
    this.positionService.setElement(s, p);
  }
}
const Fe = class extends z {
  constructor() {
    super(...arguments), this.type = "grid-brush", this.renderType = H.SVG, this.selectionSelector = "rect.selection", this.frontSelectionSelector = "rect.frontSelection";
  }
  // needs to match the class name in _grid-brush.scss
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(r = !0) {
    const e = this.parent, t = this.getComponentContainer();
    if (!e)
      throw new Error("SVG was not defined");
    const s = E.appendOrSelect(e, "svg.chart-grid-backdrop"), n = E.appendOrSelect(s, `g.${this.type}`), a = E.appendOrSelect(n, this.selectionSelector), { width: i, height: o } = E.getSVGElementSize(s, {
      useAttrs: !0
    }), { cartesianScales: l } = this.services, c = l.getMainXScaleType(), d = l.getMainXScale(), [p] = d.range();
    t.attr("transform", `translate(${p},0)`);
    const h = E.appendOrSelect(t, this.frontSelectionSelector);
    if (d && c === te.TIME) {
      let u = this.model.get("zoomDomain");
      u === void 0 && (u = this.services.zoom.getDefaultZoomBarDomain(), u && this.model.set({ zoomDomain: u }, { animate: !1 }));
      const g = (L) => {
        const w = L[1] - L[0];
        let T = "0," + w.toString();
        const k = Math.floor(o / Fe.DASH_LENGTH), _ = k * Fe.DASH_LENGTH;
        for (let F = 0; F < k; F++)
          T += "," + Fe.DASH_LENGTH;
        T += "," + (o - _), k % 2 === 1 && (T += ",0"), T += "," + w.toString(), T += "," + o.toString(), h.attr("stroke-dasharray", T);
      }, m = (L) => {
        const w = L.selection;
        w === null || w[0] === w[1] || (h.attr("x", parseFloat(a.attr("x")) + parseFloat(s.attr("x"))).attr("y", a.attr("y")).attr("width", a.attr("width")).attr("height", a.attr("height")).style("cursor", "pointer").style("display", null), g(w));
      }, b = (L, w) => {
        const T = Xs().range([0, i]).domain(u);
        let k = [T.invert(L), T.invert(w)];
        k[0].valueOf() === k[1].valueOf() && (k = this.services.zoom.getDefaultZoomBarDomain()), (u[0].valueOf() !== k[0].valueOf() || u[1].valueOf() !== k[1].valueOf()) && this.services.zoom.handleDomainChange(k);
      };
      let v;
      const S = (L) => {
        const w = L.selection;
        w !== null && (b(w[0], w[1]), n.call(v.move, null), h.style("display", "none"));
      };
      o != 0 && i != 0 && (v = ms().extent([
        [0, 0],
        [i - 1, o]
      ]).on("start brush end", m).on("end.brushed", S), n.call(v));
      const O = this.services.zoom.getZoomRatio();
      s.on("click", function(L) {
        if (L.shiftKey) {
          const w = this.services.domUtils.getHolder(), T = qe(n.node(), w)[0];
          let k = T - i * O / 2;
          k < 0 && (k = 0);
          let _ = T + i * O / 2;
          _ > i && (_ = i), b(k, _);
        }
      });
    }
  }
};
let rr = Fe;
rr.DASH_LENGTH = 4;
class oc extends z {
  constructor() {
    super(...arguments), this.type = "zoom-bar", this.renderType = H.SVG, this.MIN_SELECTION_DIFF = 9e-10, this.brushSelector = "g.zoom-bar-brush", this.clipId = "zoomBarClip-" + Math.floor(Math.random() * 99999999999), this.brush = ms(), this.highlightStrokeWidth = 1;
  }
  init() {
    this.services.events.addEventListener(f.ZoomBar.UPDATE, this.render.bind(this));
    const e = y(this.getOptions(), "zoomBar", P.TOP, "data");
    this.model.setZoomBarData(e);
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    const t = this.getComponentContainer(), s = this.services.zoom.isZoomBarLoading(P.TOP), n = this.services.zoom.isZoomBarLocked(P.TOP), a = y(this.getOptions(), "zoomBar", P.TOP, "type"), i = y(this.getOptions(), "axes", P.BOTTOM, "highlights"), o = de.height[a], { width: l } = E.getSVGElementSize(this.parent, {
      useAttrs: !0
    });
    if (l === 0)
      return;
    let c = 0;
    const d = this.model.get("axesMargins");
    d && d.left && (c = d.left);
    const p = E.appendOrSelect(t, "svg.zoom-container").attr("width", "100%").attr("height", o).attr("opacity", 1);
    if (E.appendOrSelect(t, "rect.zoom-spacer").attr("x", 0).attr("y", o).attr("width", "100%").attr("height", de.spacerHeight).attr("opacity", 1).attr("fill", "none"), a === Le.GRAPH_VIEW ? E.appendOrSelect(p, "rect.zoom-bg").attr("x", c).attr("y", 0).attr("width", l - c).attr("height", "100%").classed("zoom-bg-skeleton", s).style(
      "stroke",
      s ? `url(#${this.services.domUtils.generateElementIDString("shimmer-lines")})` : null
    ) : a === Le.SLIDER_VIEW && E.appendOrSelect(p, "rect.zoom-slider-bg").attr("x", c).attr("y", o / 2 - 1).attr("width", l - c).attr("height", 2).classed("zoom-slider-bg-skeleton", s).style(
      "stroke",
      s ? `url(#${this.services.domUtils.generateElementIDString("shimmer-lines")})` : null
    ), s) {
      this.renderSkeleton(p, c, l);
      return;
    }
    const { cartesianScales: h } = this.services, u = h.getMainXScale(), g = h.getMainYScale(), m = h.getMainXScaleType();
    if (u && m === te.TIME) {
      let b = this.services.zoom.getZoomBarData();
      if (Ts(b) || b.length === 1)
        return;
      this.xScale = u.copy(), this.yScale = g.copy();
      const v = this.services.zoom.getDefaultZoomBarDomain(b);
      b = this.compensateDataForDefaultDomain(b, v);
      const S = this.model.get("initialZoomDomain"), O = y(
        this.getOptions(),
        "zoomBar",
        P.TOP,
        "initialZoomDomain"
      );
      O && O[0] && O[1] && (O[0] = new Date(O[0]), O[1] = new Date(O[1])), O && !(S && S[0].valueOf() === O[0].valueOf() && S[1].valueOf() === O[1].valueOf()) ? this.model.set(
        {
          // use a new object instead of newInitialZoomDomain
          initialZoomDomain: Ie([], O),
          zoomDomain: O ? Ie([], O) : v
        },
        { skipUpdate: !0 }
      ) : O === null && S !== null && this.model.set(
        {
          initialZoomDomain: null,
          zoomDomain: Ie([], v)
        },
        { skipUpdate: !0 }
      ), this.xScale.range([c, l]).domain(v), this.maxSelectionRange = this.xScale.range(), this.yScale.range([0, o - 6]).domain(Ke(b, (T) => T.value));
      const L = this.model.get("zoomDomain");
      if (a === Le.GRAPH_VIEW && (this.renderZoomBarArea(p, "path.zoom-graph-area-unselected", b, null), this.updateClipPath(t, this.clipId, 0, 0, 0, 0), this.renderZoomBarArea(p, "path.zoom-graph-area", b, this.clipId), this.renderZoomBarBaseline(p, c, l), i)) {
        const T = i.highlightStartMapsTo, k = i.highlightEndMapsTo, _ = i.color, F = i.labelMapsTo;
        i.data.forEach((V, A) => {
          E.appendOrSelect(p, `rect.highlight-${A}`).attr("height", o - 2 * this.highlightStrokeWidth).attr("y", this.highlightStrokeWidth).attr("x", this.xScale(V[T])).attr(
            "width",
            this.xScale(V[k]) - this.xScale(V[T])
          ).style(
            "fill",
            _ && _.scale[V[F]] ? _.scale[V[F]] : null
          ).style("fill-opacity", 0.1).style(
            "stroke",
            _ && _.scale[V[F]] ? _.scale[V[F]] : null
          ).style("stroke-dasharray", "2, 2").attr("stroke-width", "1px");
        });
      }
      this.addBrushEventListener(L, c, l);
      const w = E.appendOrSelect(t, this.brushSelector).call(this.brush);
      if (L !== void 0)
        if (L[0].valueOf() === L[1].valueOf())
          w.call(this.brush.move, this.xScale.range()), this.updateBrushHandle(this.getComponentContainer(), this.xScale.range());
        else {
          const T = L.map((k) => this.xScale(k));
          T[1] - T[0] < this.MIN_SELECTION_DIFF || (w.call(this.brush.move, T), this.updateBrushHandle(this.getComponentContainer(), T));
        }
      n && (this.brush.filter(() => !1), w.selectAll("rect").attr("cursor", "auto"));
    }
  }
  addBrushEventListener(e, t, s) {
    const n = (o) => {
      const l = o.selection;
      l === null ? this.handleBrushedEvent(o, e, this.xScale, this.xScale.range()) : l[0] === l[1] || this.handleBrushedEvent(o, e, this.xScale, l);
    }, a = y(this.getOptions(), "zoomBar", P.TOP, "type"), i = de.height[a];
    this.brush.extent([
      [t, 0],
      [s, i]
    ]).on("start brush end", null).on("start brush end", n);
  }
  // brush event listener
  handleBrushedEvent(e, t, s, n) {
    const a = [s.invert(n[0]), s.invert(n[1])];
    if (this.updateBrushHandle(this.getComponentContainer(), n), e.sourceEvent != null && (e.sourceEvent.type === "mousemove" || e.sourceEvent.type === "mouseup" || e.sourceEvent.type === "mousedown" || e.sourceEvent.type === "touchstart" || e.sourceEvent.type === "touchmove" || e.sourceEvent.type === "touchend")) {
      (t === void 0 || t[0] !== a[0] || t[1] !== a[1]) && this.services.zoom.handleDomainChange(a, {
        dispatchEvent: !1
      });
      let i;
      e.type === "start" ? i = f.ZoomBar.SELECTION_START : e.type === "brush" ? i = f.ZoomBar.SELECTION_IN_PROGRESS : e.type === "end" && (i = f.ZoomBar.SELECTION_END, this.services.events.dispatchEvent(f.ZoomDomain.CHANGE, {
        newDomain: a
      })), this.services.events.dispatchEvent(i, {
        selection: n,
        newDomain: a
      });
    }
  }
  updateBrushHandle(e, t) {
    const s = this, n = de.handleWidth, a = y(this.getOptions(), "zoomBar", P.TOP, "type"), i = de.height[a], o = -n / 2, l = de.handleBarWidth, c = a === Le.GRAPH_VIEW ? de.handleBarHeight : 6, d = -l / 2, p = (i - c) / 2;
    e.select(this.brushSelector).selectAll("rect.handle").data([{ type: "w" }, { type: "e" }]).attr("x", function(u) {
      if (u.type === "w")
        return Math.max(t[0] + o, s.maxSelectionRange[0]);
      if (u.type === "e")
        return Math.min(t[1] + o, s.maxSelectionRange[1] - n);
    }).attr("y", 0).attr("width", n).attr("height", i).attr("cursor", "ew-resize").style("display", null);
    const h = e.select(this.brushSelector).selectAll("rect.handle-bar").data([{ type: "w" }, { type: "e" }]);
    h.enter().append("rect").attr("class", function(u) {
      return "handle-bar handle-bar--" + u.type;
    }), h.attr("x", function(u) {
      if (u.type === "w")
        return Math.max(
          t[0] + d,
          s.maxSelectionRange[0] - o + d
        );
      if (u.type === "e")
        return Math.min(
          t[1] + d,
          s.maxSelectionRange[1] + o + d
        );
    }).attr("y", p).attr("width", l).attr("height", c).attr("cursor", "ew-resize"), a === Le.SLIDER_VIEW && this.updateSliderSelectedArea(t), this.updateClipPath(
      e,
      this.clipId,
      t[0],
      0,
      t[1] - t[0],
      i
    );
  }
  updateSliderSelectedArea(e) {
    const t = y(this.getOptions(), "zoomBar", P.TOP, "type"), s = de.height[t], a = this.getComponentContainer().select("svg.zoom-container");
    E.appendOrSelect(a, "rect.zoom-slider-selected-area").attr("x", e[0]).attr("y", s / 2 - 1).attr("width", e[1] - e[0]).attr("height", 2);
  }
  renderZoomBarArea(e, t, s, n) {
    const { cartesianScales: a } = this.services, i = a.getMainXAxisPosition(), o = a.getMainYAxisPosition(), l = a.getMainXScaleType(), c = a.getMainYScaleType(), d = (v, S, O) => (L) => a.getValueFromScale(v, S, O, L), p = d(this.xScale, l, i), h = d(this.yScale, c, o), u = y(this.getOptions(), "zoomBar", P.TOP, "type"), g = de.height[u], m = kt().x((v) => p(v)).y0(g).y1((v) => g - h(v)), b = E.appendOrSelect(e, t).datum(s).attr("d", m);
    n && b.attr("clip-path", `url(#${n})`);
  }
  updateClipPath(e, t, s, n, a, i) {
    const o = E.appendOrSelect(e, "clipPath").attr("id", t);
    E.appendOrSelect(o, "rect").attr("x", s).attr("y", n).attr("width", a).attr("height", i);
  }
  // assume the domains in data are already sorted
  compensateDataForDefaultDomain(e, t) {
    if (!e || e.length < 2)
      return;
    const s = wn(e), n = this.services.cartesianScales.getDomainIdentifier(), a = this.services.cartesianScales.getRangeIdentifier();
    if (Number(t[0]) < Number(s[0][n])) {
      const i = {};
      i[n] = t[0], i[a] = 0, s.unshift(i);
    }
    if (Number(t[1]) > Number(s[s.length - 1][n])) {
      const i = {};
      i[n] = t[1], i[a] = 0, s.push(i);
    }
    return s;
  }
  renderZoomBarBaseline(e, t, s, n = !1) {
    const a = y(this.model.getOptions(), "zoomBar", P.TOP, "type"), i = de.height[a], o = It()([
      [t, i],
      [s, i]
    ]);
    E.appendOrSelect(e, "path.zoom-bg-baseline").attr("d", o).classed("zoom-bg-baseline-skeleton", n).style(
      "stroke",
      n ? `url(#${this.services.domUtils.generateElementIDString("shimmer-lines")})` : null
    );
  }
  renderSkeleton(e, t, s) {
    this.renderZoomBarArea(e, "path.zoom-graph-area-unselected", [], null), this.renderZoomBarArea(e, "path.zoom-graph-area", [], this.clipId), this.brush.on("start brush end", null), E.appendOrSelect(this.getComponentContainer(), this.brushSelector).html(null), y(this.getOptions(), "zoomBar", P.TOP, "type") === Le.GRAPH_VIEW && this.renderZoomBarBaseline(e, t, s, !0);
  }
  destroy() {
    this.brush.on("start brush end", null), this.services.events.removeEventListener(f.ZoomBar.UPDATE, this.render.bind(this));
  }
}
class lc extends z {
  constructor(e, t) {
    super(e, t), this.type = "threshold", this.renderType = H.SVG, this.positionService = new Je();
  }
  render(e = !1) {
    const t = y(this.getOptions(), "axes"), s = [];
    Object.keys(t).forEach((h) => {
      if (Object.values(P).includes(h)) {
        const u = t[h];
        u.thresholds && u.thresholds.length > 0 && s.push({
          axisPosition: h,
          thresholds: u.thresholds,
          correspondingDatasets: u == null ? void 0 : u.correspondingDatasets,
          mapsTo: u == null ? void 0 : u.mapsTo
        });
      }
    });
    const a = this.getComponentContainer({ withinChartClip: !0 }).selectAll("g.axis-thresholds").data(s, (h) => h.axisPosition);
    a.exit().attr("opacity", 0).remove();
    const o = a.enter().append("g").merge(a);
    o.attr("class", (h) => `axis-thresholds ${h.axisPosition}`);
    const l = o.selectAll("g.threshold-group").data(
      (h) => h.thresholds.map((u) => (u.axisPosition = h.axisPosition, u.datum = this.constructDatumObj(h, u), u))
    );
    l.exit().attr("opacity", 0).remove();
    const c = l.enter().append("g");
    c.append("line").attr("class", "threshold-line"), c.append("rect").attr("class", "threshold-hoverable-area"), c.merge(l).attr("class", "threshold-group");
    const p = this;
    o.each(function({ axisPosition: h }) {
      const u = p.services.cartesianScales.getScaleByPosition(
        h
      ), g = p.services.cartesianScales.getScaleTypeByPosition(h);
      let m = null, b = null;
      h === P.LEFT || h === P.RIGHT ? (b = u, m = p.services.cartesianScales.getMainXScale()) : (m = u, b = p.services.cartesianScales.getMainYScale());
      const v = g === te.LABELS, [S, O] = m.range(), [L, w] = b.range(), { cartesianScales: T } = p.services, k = T.getOrientation(), _ = (G) => T.getDomainValue(G), F = (G) => T.getRangeValue(G), [V, A] = ve(
        _,
        F,
        k
      ), M = x(this);
      h === P.TOP || h === P.BOTTOM ? (M.selectAll("line.threshold-line").transition().call(
        (G) => p.services.transitions.setupTransition({
          transition: G,
          name: "threshold-line-update",
          animate: e
        })
      ).attr("y1", w).attr("y2", L).attr(
        "x1",
        ({ datum: G }) => V(G) + (v ? u.step() / 2 : 0)
      ).attr(
        "x2",
        ({ datum: G }) => V(G) + (v ? u.step() / 2 : 0)
      ).style("stroke", ({ fillColor: G }) => G), M.selectAll("rect.threshold-hoverable-area").attr("x", 0).attr("y", ({ datum: G }) => -V(G)).attr("width", Math.abs(L - w)).classed("rotate", !0)) : (M.selectAll("line.threshold-line").transition().call(
        (G) => p.services.transitions.setupTransition({
          transition: G,
          name: "threshold-line-update",
          animate: e
        })
      ).attr("x1", S).attr("x2", O).attr(
        "y1",
        ({ datum: G }) => A(G) + (v ? u.step() / 2 : 0)
      ).attr(
        "y2",
        ({ datum: G }) => A(G) + (v ? u.step() / 2 : 0)
      ).style("stroke", ({ fillColor: G }) => G), M.selectAll("rect.threshold-hoverable-area").attr("x", S).attr("y", ({ datum: G }) => A(G)).attr("width", Math.abs(O - S)).classed("rotate", !1));
    }), this.services.events.addEventListener(f.Threshold.SHOW, (h) => {
      this.setThresholdLabelPosition(h.detail), this.label.classed("hidden", !1);
    }), this.services.events.addEventListener(f.Threshold.HIDE, () => {
      this.label.classed("hidden", !0);
    }), this.appendThresholdLabel(), this.addEventListeners();
  }
  getFormattedValue(e) {
    const { value: t, axisPosition: s } = e, n = this.getOptions();
    if (this.services.cartesianScales.getScaleTypeByPosition(s) === te.TIME) {
      const i = [P.LEFT, P.RIGHT].includes(s), o = this.services.cartesianScales.getMainXScale(), l = this.services.cartesianScales.getMainYScale(), c = i ? l : o, d = y(n, "timeScale"), p = ht(
        c.ticks(),
        y(d, "timeInterval")
      );
      return ut(t, 0, c.ticks(), p, d);
    }
    return t.toLocaleString("en");
  }
  appendThresholdLabel() {
    const e = x(this.services.domUtils.getHolder()), t = y(this.getOptions(), "style", "prefix");
    this.label = E.appendOrSelect(
      e,
      `div.${he}--${t}--threshold--label`
    ).classed("hidden", !0);
  }
  setThresholdLabelPosition({ event: e, datum: t }) {
    const s = this.services.domUtils.getHolder(), n = qe(e, s), a = t.valueFormatter ? t.valueFormatter(t.value) : this.getFormattedValue(t);
    this.label.html(`${t.label || "Threshold"}: ${a}`).style("background-color", t.fillColor);
    const i = this.label.node(), o = this.positionService.findBestPlacementAt(
      {
        left: n[0],
        top: n[1]
      },
      i,
      [ne.RIGHT, ne.LEFT, ne.TOP, ne.BOTTOM],
      () => ({
        top: void 0,
        // other package lists this as non-optional
        left: void 0,
        // ditto
        width: s.offsetWidth,
        height: s.offsetHeight
      })
    ), l = this.positionService.findPositionAt(
      {
        left: n[0],
        top: n[1]
      },
      i,
      o
    );
    this.positionService.setElement(i, l);
  }
  // Constructs object to pass in scale functions
  constructDatumObj(e, t) {
    const s = {};
    return e.correspondingDatasets && (s.group = y(e, "correspondingDatasets", 0)), s[e.mapsTo] = t.value, s;
  }
  addEventListeners() {
    const e = this;
    this.getComponentContainer({ withinChartClip: !0 }).selectAll("rect.threshold-hoverable-area").on("mouseover mousemove", function(s) {
      x(this.parentNode).select("line.threshold-line").classed("active", !0), e.services.events.dispatchEvent(f.Threshold.SHOW, {
        event: s,
        hoveredElement: x(this),
        datum: x(this).datum()
      });
    }).on("mouseout", function(s) {
      x(this.parentNode).select("line.threshold-line").classed("active", !1), e.services.events.dispatchEvent(f.Threshold.HIDE, {
        event: s,
        hoveredElement: x(this),
        datum: x(this).datum()
      });
    });
  }
}
class cc extends z {
  constructor(e, t) {
    super(e, t), this.type = "highlight", this.renderType = H.SVG, this.positionService = new Je(), this.highlightStrokeWidth = 1;
  }
  render(e = !1) {
    const t = y(this.getOptions(), "axes"), s = [];
    Object.keys(t).forEach((h) => {
      if (Object.values(P).includes(h)) {
        const u = t[h];
        u.highlights && u.highlights.data.length > 0 && s.push({
          axisPosition: h,
          highlightStartMapsTo: u.highlights.highlightStartMapsTo,
          highlightEndMapsTo: u.highlights.highlightEndMapsTo,
          labelMapsTo: u.highlights.labelMapsTo,
          highlight: u.highlights.data,
          color: u.highlights.color
        });
      }
    });
    const a = this.getComponentContainer({ withinChartClip: !0 }).selectAll("g.axis-highlight").data(s, (h) => h.axisPosition);
    a.exit().attr("opacity", 0).remove();
    const o = a.enter().append("g").merge(a);
    o.attr("class", (h) => `axis-highlight ${h.axisPosition}`);
    const l = o.selectAll("g.highlight-group").data(
      (h) => h.highlight.map((u) => (u.axisPosition = h.axisPosition, u.highlightStartMapsTo = h.highlightStartMapsTo, u.labelMapsTo = h.labelMapsTo, u.color = h.color, u.highlightEndMapsTo = h.highlightEndMapsTo, u))
    );
    l.exit().attr("opacity", 0).remove();
    const c = l.enter().append("g");
    c.append("rect").attr("class", "highlight-bar"), c.append("line").attr("class", "highlight-line"), c.merge(l).attr("class", "highlight-group");
    const p = this;
    o.each(function({ axisPosition: h }) {
      const u = p.services.cartesianScales.getMainXScale(), g = p.services.cartesianScales.getMainYScale(), [m, b] = u.range(), [v, S] = g.range(), { cartesianScales: O } = p.services, L = O.getOrientation(), w = (V) => O.getDomainValue(V), T = (V) => O.getRangeValue(V), [k, _] = ve(
        w,
        T,
        L
      ), F = x(this);
      h === P.TOP || h === P.BOTTOM ? F.selectAll("rect.highlight-bar").transition().call(
        (V) => p.services.transitions.setupTransition({
          transition: V,
          name: "highlight-bar-update",
          animate: e
        })
      ).attr("y", Math.max(S + p.highlightStrokeWidth, 0)).attr("height", Math.max(v - 2 * p.highlightStrokeWidth, 0)).attr("x", ({ highlightStartMapsTo: V, ...A }) => k(A[V])).attr(
        "width",
        ({ highlightStartMapsTo: V, highlightEndMapsTo: A, ...M }) => Math.max(k(M[A]) - k(M[V]), 0)
      ).style("stroke", ({ color: V, labelMapsTo: A, ...M }) => V && V.scale[M[A]] ? V.scale[M[A]] : null).style("stroke-dasharray", "2, 2").attr("stroke-width", p.highlightStrokeWidth + "px").style("fill-opacity", 0.1).style("fill", ({ color: V, labelMapsTo: A, ...M }) => V && V.scale[M[A]] ? V.scale[M[A]] : null) : F.selectAll("rect.highlight-bar").transition().call(
        (V) => p.services.transitions.setupTransition({
          transition: V,
          name: "highlight-bar-update",
          animate: e
        })
      ).attr("x", m).attr("width", Math.max(b - m, 0)).attr("y", ({ highlightEndMapsTo: V, ...A }) => _(A[V])).attr(
        "height",
        ({ highlightStartMapsTo: V, highlightEndMapsTo: A, ...M }) => Math.max(_(M[V]) - _(M[A]), 0)
      ).style("stroke", ({ color: V, labelMapsTo: A, ...M }) => V && V.scale[M[A]] ? V.scale[M[A]] : null).style("stroke-dasharray", "2, 2").attr("stroke-width", p.highlightStrokeWidth + "px").style("fill-opacity", 0.1).style("fill", ({ color: V, labelMapsTo: A, ...M }) => V && V.scale[M[A]] ? V.scale[M[A]] : null);
    });
  }
}
class dc extends ir {
  getItems(e) {
    if (e.detail.items)
      return e.detail.items;
    const t = e.detail.data;
    if (!t.length || !t[0])
      return [];
    const s = this.getOptions(), { cartesianScales: n } = this.services, a = n.getDomainIdentifier(), i = n.isDualAxes(), { groupMapsTo: o } = s.data, l = n.getDomainLabel();
    let c = n.getRangeLabel();
    const d = t[0][a];
    let p;
    if (t.length === 1) {
      const h = t[0], u = n.getRangeIdentifier(h);
      if (i) {
        const m = n.getRangeAxisPosition({
          datum: h,
          groups: [h[o]]
        });
        c = n.getScaleLabel(m);
      }
      const g = h[u];
      p = [
        {
          label: l,
          value: d
        },
        ...Array.isArray(g) && g.length === 2 ? [
          {
            label: "Start",
            value: g[0]
          },
          {
            label: "End",
            value: g[1]
          }
        ] : [
          {
            label: c,
            value: h[u]
          }
        ]
      ], e.detail.additionalItems && e.detail.additionalItems.forEach(
        (m) => p.push({
          label: m.label,
          value: m.value
        })
      ), p.push({
        label: s.tooltip.groupLabel,
        value: h[o],
        color: this.model.getFillColor(h[o]),
        class: this.model.getColorClassName({
          classNameTypes: [$.TOOLTIP],
          dataGroupName: h[o]
        })
      });
    } else if (t.length > 1 && (p = [
      {
        label: l,
        value: d
      }
    ], p = p.concat(
      t.map((h) => {
        const u = h[n.getRangeIdentifier(h)];
        return {
          label: h[o],
          value: Array.isArray(u) && u.length === 2 ? `${u[0]} - ${u[1]}` : u,
          color: this.model.getFillColor(h[o]),
          class: this.model.getColorClassName({
            classNameTypes: [$.TOOLTIP],
            dataGroupName: h[o]
          })
        };
      }).sort((h, u) => u.value - h.value)
    ), !i && y(s, "tooltip", "showTotal") === !0)) {
      const h = n.getRangeIdentifier();
      p.push({
        label: Q(s, "tooltip.totalLabel") || "Total",
        value: t.reduce(
          (u, g) => u + g[h],
          0
        ),
        bold: !0
      });
    }
    return p;
  }
}
class hc extends z {
  constructor() {
    super(...arguments), this.type = "alluvial", this.renderType = H.SVG, this.gradient_id = "gradient-id-" + Math.floor(Math.random() * 99999999999);
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    const t = this.getComponentContainer({ withinChartClip: !0 });
    t.html("");
    const { width: s, height: n } = E.getSVGElementSize(t, {
      useAttrs: !0
    });
    if (s < 1 || n < 1)
      return;
    const a = this.model.getOptions(), i = this.model.getDisplayData(), o = y(
      this.getOptions(),
      "color",
      "gradient",
      "enabled"
    );
    let l = pe.minNodePadding;
    a.alluvial.nodePadding > pe.minNodePadding && (l = a.alluvial.nodePadding);
    const c = y(a, "alluvial", "nodeAlignment");
    let d = Gn;
    c === ue.LEFT ? d = Nn : c === ue.RIGHT && (d = Hn);
    const p = Bn().nodeId((v) => v.name).nodeWidth(pe.nodeWidth).nodePadding(l).nodeAlign(d).extent([
      [2, 30],
      [s - 2, n]
    ]);
    this.graph = p({
      nodes: a.alluvial.nodes.map((v) => Object.assign({}, v)),
      links: i.map((v) => Object.assign({}, v))
    }), this.graph.nodes = this.graph.nodes.filter((v) => v.value !== 0);
    const h = {};
    this.graph.nodes.forEach((v) => {
      const S = v.x0;
      v.category && (h[S] = v == null ? void 0 : v.category);
    }), t.append("g").classed("header-arrows", !0).selectAll("g").data(Object.keys(h)).join("g").attr("transform", (v) => `translate(${v}, 0)`).append("text").attr(
      "id",
      (v, S) => this.services.domUtils.generateElementIDString(`alluvial-category-${S}`)
    ).style("font-size", "14px").text((v) => h[v] ? h[v] : "").attr("y", 20).attr("x", (v, S) => {
      const O = this.services.domUtils.generateElementIDString(
        `alluvial-category-${S}`
      ), { width: L } = E.getSVGElementSize(x(`text#${O}`), { useBBox: !0 });
      let w = 0;
      return v + w >= L && (w = -L + 4), w;
    });
    const g = t.append("g").attr("fill", "none").selectAll("g").data(this.graph.links);
    if (g.exit().remove(), o) {
      const v = y(this.getOptions(), "color", "scale");
      v && g.enter().append("linearGradient").attr("id", (S) => `${this.gradient_id}-link-${S.index}`).attr("gradientUnits", "userSpaceOnUse").call(
        (S) => S.append("stop").attr("offset", "0%").attr("stop-color", (O) => v[O.source.name])
      ).call(
        (S) => S.append("stop").attr("offset", "100%").attr("stop-color", (O) => v[O.target.name])
      ), g.exit().remove();
    }
    g.enter().append("path").classed("link", !0).attr("d", $n()).attr(
      "id",
      (v) => this.services.domUtils.generateElementIDString(`alluvial-line-${v.index}`)
    ).attr("class", (v) => a.alluvial.monochrome ? this.model.getColorClassName({
      classNameTypes: [$.STROKE],
      dataGroupName: 0,
      originalClassName: "link"
    }) : this.model.getColorClassName({
      classNameTypes: [$.STROKE],
      dataGroupName: v.source.index,
      originalClassName: "link"
    })).style("stroke", (v) => o ? `url(#${this.gradient_id}-link-${v.index})` : this.model.getFillColor(v.source.name)).attr("stroke-width", (v) => Math.max(1, v.width)).style("stroke-opacity", pe.opacity.default).attr(
      "aria-label",
      (v) => `${v.source.name} → ${v.target.name} (${v.value}${a.alluvial.units ? " " + a.alluvial.units : ""})`
    );
    const m = t.append("g").selectAll("g").data(this.graph.nodes).enter().append("g").attr(
      "id",
      (v) => this.services.domUtils.generateElementIDString(`alluvial-node-${v.index}`)
    ).classed("node-group", !0).attr("transform", (v) => `translate(${v.x0}, ${v.y0})`);
    m.append("rect").classed("node", !0).attr("height", (v) => v.y1 - v.y0).attr("width", (v) => v.x1 - v.x0).attr("fill", "black");
    const b = m.append("g").attr(
      "id",
      (v) => this.services.domUtils.generateElementIDString(`alluvial-node-title-${v.index}`)
    );
    b.append("text").attr(
      "id",
      (v) => this.services.domUtils.generateElementIDString(`alluvial-node-text-${v.index}`)
    ).attr("class", "node-text").style("font-size", "12px").attr("text-anchor", "start").attr("fill", "white").attr("x", 4).attr("dy", 13).text((v) => `${v.name} (${v.value})`).attr("aria-label", (v) => `${v.name} (${v.value})`), b.append("rect").classed("node-text-bg", !0).attr("width", (v, S) => {
      const O = this.services.domUtils.generateElementIDString(
        `alluvial-node-text-${S}`
      ), { width: L } = E.getSVGElementSize(x(`text#${O}`), { useBBox: !0 });
      return L + 8;
    }).attr("height", 18).attr("stroke-width", 2).lower(), b.attr("transform", (v, S) => {
      const O = this.services.domUtils.generateElementIDString(
        `alluvial-node-text-${S}`
      ), { width: L } = E.getSVGElementSize(x(`text#${O}`), { useBBox: !0 }), w = (v.y1 - v.y0) / 2 - 9;
      let T = v.x1 - v.x0;
      return v.x1 >= L ? T = T - (L + 16) : T += 4, `translate(${T}, ${w})`;
    }), this.addLineEventListener(), this.addNodeEventListener();
  }
  addLineEventListener() {
    const e = this.getOptions(), t = this, s = gt((n, a = "mouseover") => {
      const i = t.parent.selectAll("path.link").transition().call(
        (o) => t.services.transitions.setupTransition({
          transition: o,
          name: "alluvial-links-mouse-highlight"
        })
      );
      a === "mouseout" ? (x(n).lower(), i.style("stroke-opacity", pe.opacity.default)) : i.style("stroke-opacity", function() {
        return n === this ? (x(this).raise(), pe.opacity.selected) : pe.opacity.unfocus;
      });
    }, 33);
    this.parent.selectAll("path.link").on("mouseover", function(n, a) {
      const i = x(this);
      s(this, "mouseover"), i.classed("link-hovered", !0);
      const o = getComputedStyle(this).getPropertyValue("stroke");
      t.services.events.dispatchEvent(f.Alluvial.LINE_MOUSEOVER, {
        event: n,
        element: i,
        datum: a
      }), t.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: n,
        hoveredElement: i,
        items: [
          {
            label: a.target.name,
            value: a.value + (e.alluvial.units ? ` ${e.alluvial.units}` : ""),
            color: o,
            labelIcon: t.getRightArrowIcon()
          }
        ]
      });
    }).on("mousemove", function(n, a) {
      t.services.events.dispatchEvent(f.Alluvial.LINE_MOUSEMOVE, {
        event: n,
        element: x(this),
        datum: a
      }), t.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: n
      });
    }).on("click", function(n, a) {
      t.services.events.dispatchEvent(f.Alluvial.LINE_CLICK, {
        event: n,
        element: x(this),
        datum: a
      });
    }).on("mouseout", function(n, a) {
      const i = x(this);
      s(this, "mouseout"), i.classed("link-hovered", !1), t.services.events.dispatchEvent(f.Alluvial.LINE_MOUSEOUT, {
        event: n,
        element: i,
        datum: a
      }), t.services.events.dispatchEvent(f.Tooltip.HIDE, {
        event: n,
        hoveredElement: i
      });
    });
  }
  addNodeEventListener() {
    const e = this, t = gt((s = [], n = "mouseover") => {
      if (n === "mouseout" || s.length === 0) {
        e.parent.selectAll("path.link").classed("link-hovered", !1).data(this.graph.links, (i) => i.index).order().style("stroke-opacity", pe.opacity.default);
        return;
      }
      e.parent.selectAll("path.link").transition().call(
        (i) => this.services.transitions.setupTransition({
          transition: i,
          name: "alluvial-link-mouse-highlight"
        })
      ).style("stroke-opacity", function(i) {
        return s.some((o) => o === i.index) ? (x(this).classed("link-hovered", !0).raise(), pe.opacity.selected) : pe.opacity.unfocus;
      });
    }, 66);
    e.parent.selectAll(".node-group").on("mouseover", function(s, n) {
      const a = x(this), i = [];
      if (e.traverse({ link: "sourceLinks", node: "target" }, n, i), e.traverse({ link: "targetLinks", node: "source" }, n, i), i.length) {
        const o = Pe(a.attr("transform"));
        if (a.attr("transform", `translate(${o.x - 2}, ${o.y})`), a.classed("node-hovered", !0).selectAll("rect.node").attr("width", 8), n.x0 - 2 === 0) {
          const c = e.services.domUtils.generateElementIDString(
            `alluvial-node-title-${n.index}`
          ), d = e.parent.select(`g#${c}`), p = Pe(d.attr("transform"));
          d.attr("transform", `translate(${p.x + 4},${p.y})`);
        }
        const l = e.services.domUtils.generateElementIDString(
          `alluvial-node-text-${n.index}`
        );
        e.parent.select(`text#${l}`).style("font-weight", "bold"), t(i, "mouseover"), e.services.events.dispatchEvent(f.Alluvial.NODE_MOUSEOVER, {
          event: s,
          element: a,
          datum: n
        });
      }
    }).on("mousemove", function(s, n) {
      e.services.events.dispatchEvent(f.Alluvial.NODE_MOUSEMOVE, {
        event: s,
        element: x(this),
        datum: n
      }), e.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: s
      });
    }).on("click", function(s, n) {
      e.services.events.dispatchEvent(f.Alluvial.NODE_CLICK, {
        event: s,
        element: x(this),
        datum: n
      });
    }).on("mouseout", function(s, n) {
      const a = x(this), i = Pe(a.attr("transform"));
      if (a.classed("node-hovered", !1).attr("transform", `translate(${i.x + 2}, ${i.y})`).select("rect.node").attr("width", pe.nodeWidth), n.x0 - 2 === 0) {
        const l = e.services.domUtils.generateElementIDString(
          `alluvial-node-title-${n.index}`
        ), c = e.parent.select(`g#${l}`), d = Pe(c.attr("transform"));
        c.attr("transform", `translate(${d.x - 4},${d.y})`);
      }
      const o = e.services.domUtils.generateElementIDString(
        `alluvial-node-text-${n.index}`
      );
      e.parent.select(`text#${o}`).style("font-weight", "normal"), t([], "mouseout"), e.services.events.dispatchEvent(f.Alluvial.NODE_MOUSEOUT, {
        event: s,
        element: a,
        datum: n
      }), e.services.events.dispatchEvent(f.Tooltip.HIDE, {
        hoveredElement: a
      });
    });
  }
  // Traverse graph and get all connected links to node
  traverse(e, t, s = []) {
    t[e.link].map((a) => (s.push(a.index), a[e.node])).forEach((a) => this.traverse(e, a, s));
  }
  getRightArrowIcon() {
    return `
		<svg xmlns="http://www.w3.org/2000/svg" class="arrow-right" width="32" height="32" viewBox="0 0 32 32">
			<polygon points="18 6 16.57 7.393 24.15 15 4 15 4 17 24.15 17 16.57 24.573 18 26 28 16 18 6"/>
			<rect width="32" height="32"/>
		</svg>`;
  }
  // Remove event listeners
  destroy() {
    this.parent.selectAll("path.line,.node-group").on("mouseover", null).on("mousemove", null).on("click", null).on("mouseout", null);
  }
}
class uc extends z {
  constructor() {
    super(...arguments), this.type = "grid", this.renderType = H.SVG;
  }
  render(e = !0) {
    const t = y(this.getOptions(), "grid", "x", "enabled"), s = y(this.getOptions(), "grid", "y", "enabled");
    this.drawBackdrop(t, s), !(!t && !s) && (t && (E.appendOrSelect(this.backdrop, "g.x.grid"), this.drawXGrid(e)), s && (E.appendOrSelect(this.backdrop, "g.y.grid"), this.drawYGrid(e)));
  }
  drawXGrid(e) {
    const t = this.parent, s = this.backdrop.attr("height"), n = this.services.cartesianScales.getMainXScale(), a = Dt(n).tickSizeInner(-s).tickSizeOuter(0);
    if (y(this.getOptions(), "grid", "x", "alignWithAxisTicks")) {
      const l = this.services.cartesianScales.getDomainAxisPosition(), c = y(this.getOptions(), "axes", l, "ticks", "values");
      c && a.tickValues(c);
    } else {
      const l = y(this.getOptions(), "grid", "x", "numberOfTicks");
      a.ticks(l);
    }
    const o = t.select(".x.grid").attr("transform", `translate(${-this.backdrop.attr("x")}, ${s})`);
    e ? o.transition().call(
      (l) => this.services.transitions.setupTransition({
        transition: l,
        name: "grid-update",
        animate: e
      })
    ).call(a) : o.call(a), this.cleanGrid(o);
  }
  drawYGrid(e) {
    const t = this.parent, s = this.backdrop.attr("width"), n = this.services.cartesianScales.getMainYScale(), a = fs(n).tickSizeInner(-s).tickSizeOuter(0);
    if (y(this.getOptions(), "grid", "y", "alignWithAxisTicks")) {
      const l = this.services.cartesianScales.getRangeAxisPosition(), c = y(this.getOptions(), "axes", l, "ticks", "values");
      c && a.tickValues(c);
    } else {
      const l = y(this.getOptions(), "grid", "y", "numberOfTicks");
      a.ticks(l);
    }
    const o = t.select(".y.grid").attr("transform", `translate(0, ${-this.backdrop.attr("y")})`);
    e ? o.transition().call(
      (l) => this.services.transitions.setupTransition({
        transition: l,
        name: "grid-update",
        animate: e
      })
    ).call(a) : o.call(a), this.cleanGrid(o);
  }
  /**
   * Returns the threshold for the gridline tooltips based on the mouse location.
   * Calculated based on the mouse position between the two closest gridlines or edges of chart.
   */
  getGridlineThreshold(e) {
    const t = this.parent, s = t.selectAll(".x.grid .tick").nodes().sort((d, p) => Number(ge(d).tx) - Number(ge(p).tx));
    let n = -1;
    if (!s.length)
      return;
    s.forEach((d) => {
      e[0] >= +ge(d).tx && n++;
    });
    const a = n + 1 < s.length ? n + 1 : s.length, i = s[n], o = s[a];
    let l;
    if (!i)
      l = +ge(o).tx;
    else if (o)
      l = +ge(o).tx - +ge(i).tx;
    else {
      const d = t.select("rect.chart-grid-backdrop").node();
      l = E.getSVGElementSize(d).width - +ge(i).tx;
    }
    const { threshold: c } = this.getOptions().tooltip.gridline;
    return l * c;
  }
  /**
   * Returns the active gridlines based on the gridline threshold and mouse position.
   * @param position mouse positon
   */
  getActiveGridline(e) {
    const t = y(this.getOptions, "tooltip", "gridline", "threshold"), s = t || this.getGridlineThreshold(e);
    return this.parent.selectAll(".x.grid .tick").filter(function() {
      const i = ge(this), o = {
        min: Number(i.tx) - s,
        max: Number(i.tx) + s
      };
      return o.min <= e[0] && e[0] <= o.max;
    });
  }
  drawBackdrop(e, t) {
    const s = this.parent, n = this.services.cartesianScales.getMainXScale(), a = this.services.cartesianScales.getMainYScale(), [i, o] = n.range(), [l, c] = a.range();
    this.backdrop = E.appendOrSelect(s, "svg.chart-grid-backdrop");
    const d = E.appendOrSelect(
      this.backdrop,
      e || t ? "rect.chart-grid-backdrop.stroked" : "rect.chart-grid-backdrop"
    );
    this.backdrop.merge(d).attr("x", i).attr("y", c).attr("width", Math.abs(o - i)).attr("height", Math.abs(l - c)).lower(), d.attr("width", "100%").attr("height", "100%");
  }
  cleanGrid(e) {
    e.selectAll("text").remove(), e.select(".domain").remove();
  }
}
class pc extends z {
  constructor() {
    super(...arguments), this.type = "area", this.renderType = H.SVG, this.gradient_id = "gradient-id-" + Math.floor(Math.random() * 99999999999), this.handleLegendOnHover = (e) => {
      const { hoveredElement: t } = e.detail;
      this.parent.selectAll("path.area").transition("legend-hover-area").call(
        (s) => this.services.transitions.setupTransition({
          transition: s,
          name: "legend-hover-area"
        })
      ).attr("opacity", (s) => s.name !== t.datum().name ? fe.opacity.unselected : fe.opacity.selected);
    }, this.handleLegendMouseOut = () => {
      this.parent.selectAll("path.area").transition("legend-mouseout-area").call(
        (e) => this.services.transitions.setupTransition({
          transition: e,
          name: "legend-mouseout-area"
        })
      ).attr("opacity", fe.opacity.selected);
    };
  }
  init() {
    const e = this.services.events;
    e.addEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.addEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
  render(e = !0) {
    const t = this.getComponentContainer({ withinChartClip: !0 }), s = this.getOptions();
    let n = [0, 0];
    const { cartesianScales: a } = this.services, i = a.getOrientation(), o = kt().curve(this.services.curves.getD3Curve()).defined((w) => {
      const T = a.getRangeIdentifier(), k = w[T];
      return k != null;
    }), l = this.model.getGroupedData(this.configs.groups), c = y(s, "bounds"), d = c && l && l.length === 1;
    !d && c && console.warn(
      `Bounds can only be shown when having 1 single datagroup, you've supplied ${l.length}`
    );
    let p = 0;
    const h = (w, T) => {
      y(s, "axes", w, "includeZero") === !1 && T[0] > 0 && T[1] > 0 && (p = T[0]);
    }, u = (w) => d ? a.getBoundedScaledValues(w)[0] : a.getRangeValue(p), g = (w) => d ? a.getBoundedScaledValues(w)[1] : a.getRangeValue(w);
    i === le.VERTICAL ? (n = a.getMainYScale().domain(), h(a.getMainYAxisPosition(), n), o.x((w) => a.getDomainValue(w)).y0((w) => u(w)).y1((w) => g(w))) : (n = a.getMainXScale().domain(), h(a.getMainXAxisPosition(), n), o.x0((w) => u(w)).x1((w) => g(w)).y((w) => a.getDomainValue(w)));
    const m = y(s, "color", "gradient", "enabled"), b = l && l.length === 1 && m;
    l.length > 1 && m && console.error("Gradients can only be enabled when having 1 single dataset");
    const v = t.selectAll("path.area").data(l, (w) => w.name), S = x(this.services.domUtils.getMainContainer());
    if (v.exit().attr("opacity", 0).remove(), !l.length)
      return;
    if (b) {
      const w = S.select(
        `path.${this.model.getColorClassName({
          classNameTypes: [$.STROKE],
          dataGroupName: l[0].name
        })}`
      ).node();
      let T;
      if (w)
        T = getComputedStyle(w, null).getPropertyValue(
          "stroke"
        );
      else {
        const k = y(this.model.getOptions(), "color", "scale");
        if (k !== null) {
          const _ = Object.keys(k);
          T = k[_[0]];
        }
      }
      Zt.appendOrUpdateLinearGradient({
        svg: this.parent,
        id: this.services.domUtils.generateElementIDString(
          `${l[0].name.replace(" ", "")}_${this.gradient_id}`
        ),
        x1: "0%",
        x2: "0%",
        y1: "0%",
        y2: "100%",
        stops: Zt.getStops(n, T)
      });
    } else
      this.parent.selectAll("defs linearGradient").empty() || this.parent.selectAll("defs linearGradient").each(function() {
        this.parentNode.remove();
      });
    const O = this, L = v.enter().append("path");
    b ? L.merge(v).style(
      "fill",
      (w) => `url(#${this.services.domUtils.generateElementIDString(
        `${w.name.replace(" ", "")}_${this.gradient_id}`
      )})`
    ).attr("class", "area").attr(
      "class",
      (w) => this.model.getColorClassName({
        classNameTypes: [$.FILL],
        dataGroupName: w.name,
        originalClassName: "area"
      })
    ).attr("d", (w) => {
      const { data: T } = w;
      return o(T);
    }) : (L.attr("opacity", 0).merge(v).attr("class", "area").attr(
      "class",
      (w) => this.model.getColorClassName({
        classNameTypes: [$.FILL, $.STROKE],
        dataGroupName: w.name,
        originalClassName: "area"
      })
    ).style("fill", (w) => O.model.getFillColor(w.name)).transition().call(
      (w) => this.services.transitions.setupTransition({
        transition: w,
        name: "area-update-enter",
        animate: e
      })
    ).attr("opacity", d ? 1 : fe.opacity.selected).attr("d", (w) => {
      const { data: T } = w;
      return o(T);
    }), d && L.attr("fill-opacity", fe.opacity.selected).style("stroke", (w) => O.model.getStrokeColor(w.name)).style("stroke-dasharray", "2, 2").attr("stroke-width", 0.7 + "px"));
  }
  destroy() {
    const e = this.services.events;
    e.removeEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.removeEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
}
class gc extends z {
  constructor() {
    super(...arguments), this.type = "line", this.renderType = H.SVG, this.handleLegendOnHover = (e) => {
      const { hoveredElement: t } = e.detail;
      this.parent.selectAll("path.line").transition("legend-hover-line").call(
        (s) => this.services.transitions.setupTransition({
          transition: s,
          name: "legend-hover-line"
        })
      ).attr("opacity", (s) => s.name !== t.datum().name ? me.opacity.unselected : me.opacity.selected);
    }, this.handleLegendMouseOut = () => {
      this.parent.selectAll("path.line").transition("legend-mouseout-line").call(
        (e) => this.services.transitions.setupTransition({
          transition: e,
          name: "legend-mouseout-line"
        })
      ).attr("opacity", me.opacity.selected);
    };
  }
  init() {
    const { events: e } = this.services;
    e.addEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.addEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
  render(e = !0) {
    const t = this.getComponentContainer({ withinChartClip: !0 }), { cartesianScales: s, curves: n } = this.services, a = (g) => s.getDomainValue(g), i = (g) => s.getRangeValue(g), [o, l] = ve(
      a,
      i,
      s.getOrientation()
    ), c = this.getOptions(), d = It().x(o).y(l).curve(n.getD3Curve()).defined((g) => {
      const m = s.getRangeIdentifier(g), b = g[m];
      return b != null;
    });
    let p = [];
    if (this.configs.stacked) {
      const g = Object.keys(c.axes).some((v) => c.axes[v].percentage), { groupMapsTo: m } = c.data;
      p = this.model.getStackedData({
        groups: this.configs.groups,
        percentage: g
      }).map((v) => {
        const S = this.services.cartesianScales.getDomainIdentifier(v), O = this.services.cartesianScales.getRangeIdentifier(v);
        return {
          name: y(v, 0, m),
          data: v.map((L) => ({
            [S]: L.data.sharedStackKey,
            [m]: L[m],
            [O]: L[1]
          })),
          hidden: !Na(v, (L) => L[0] !== L[1])
        };
      });
    } else
      p = this.model.getGroupedData(this.configs.groups);
    const h = t.selectAll("path.line").data(p, (g) => g.name);
    h.exit().attr("opacity", 0).remove(), h.enter().append("path").classed("line", !0).attr("opacity", 0).merge(h).data(p, (g) => g.name).attr(
      "class",
      (g) => this.model.getColorClassName({
        classNameTypes: [$.STROKE],
        dataGroupName: g.name,
        originalClassName: "line"
      })
    ).style("stroke", (g) => this.model.getStrokeColor(g.name)).attr("role", U.GRAPHICS_SYMBOL).attr("aria-roledescription", "line").attr("aria-label", (g) => {
      const { data: m } = g;
      return m.map((b) => {
        const v = this.services.cartesianScales.getRangeIdentifier(b);
        return b[v];
      }).join(",");
    }).transition().call(
      (g) => this.services.transitions.setupTransition({
        transition: g,
        name: "line-update-enter",
        animate: e
      })
    ).attr("opacity", (g) => g.hidden ? 0 : 1).attr("d", (g) => {
      const { data: m } = g;
      return d(m);
    });
  }
  destroy() {
    const e = this.services.events;
    e.removeEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.removeEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
}
const cs = 5;
function or(r, e) {
  return r > e - cs && r < e + cs;
}
class js extends z {
  constructor() {
    super(...arguments), this.type = "ruler", this.renderType = H.SVG, this.isXGridEnabled = y(this.getOptions(), "grid", "x", "enabled"), this.isYGridEnabled = y(this.getOptions(), "grid", "y", "enabled"), this.isEventListenerAdded = !1;
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    const t = y(this.getOptions(), "ruler", "enabled");
    this.drawBackdrop(), t && !this.isEventListenerAdded ? this.addBackdropEventListeners() : !t && this.isEventListenerAdded && this.removeBackdropEventListeners();
  }
  removeBackdropEventListeners() {
    this.isEventListenerAdded = !1, this.backdrop.on("mousemove mouseover mouseout", null);
  }
  formatTooltipData(e) {
    return e;
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  showRuler(e, [t, s]) {
    const n = this.parent, a = this.services.cartesianScales.getOrientation(), i = this.model.getDisplayData(), o = this.services.cartesianScales.getRangeScale(), [l, c] = o.range(), d = a === le.HORIZONTAL ? s : t, p = E.appendOrSelect(n, "g.ruler").attr("aria-label", "ruler"), h = E.appendOrSelect(p, "line.ruler-line"), u = n.selectAll("[role=graphics-symbol]"), g = i.map((b) => ({
      domainValue: this.services.cartesianScales.getDomainValue(b),
      originalData: b
    })).filter((b) => or(b.domainValue, d));
    if (this.pointsWithinLine && g.length === this.pointsWithinLine.length && g.map((b) => b.domainValue).join() === this.pointsWithinLine.map((b) => b.domainValue).join())
      return this.pointsWithinLine = g, this.services.events.dispatchEvent(f.Tooltip.MOVE, {
        mousePosition: [t, s]
      });
    this.pointsWithinLine = g;
    const m = this.pointsWithinLine.reduce((b, v) => {
      if (b.length === 0)
        return b.push(v), b;
      const S = b[0].domainValue, O = Math.abs(d - v.domainValue), L = Math.abs(d - S);
      return O > L || (O < L ? b = [v] : b.push(v)), b;
    }, []);
    if (m.length > 0) {
      const b = m.map((L) => L.originalData).filter((L) => {
        const w = this.services.cartesianScales.getRangeIdentifier(L), T = L[w];
        return T != null;
      }), v = m.map(
        (L) => L.domainValue
      ), S = u.filter((L) => {
        const w = this.services.cartesianScales.getDomainValue(L);
        return v.includes(w);
      });
      this.elementsToHighlight && this.elementsToHighlight.size() > 0 && !Ns(this.elementsToHighlight, S) && this.hideRuler(), S.dispatch("mouseover"), this.elementsToHighlight = S, this.services.events.dispatchEvent(f.Tooltip.SHOW, {
        mousePosition: [t, s],
        hoveredElement: h,
        data: this.formatTooltipData(b)
      }), p.attr("opacity", 1);
      const O = m[0];
      a === "horizontal" ? h.attr("x1", c).attr("x2", l).attr("y1", O.domainValue).attr("y2", O.domainValue) : h.attr("y1", c).attr("y2", l).attr("x1", O.domainValue).attr("x2", O.domainValue);
    } else
      this.hideRuler();
  }
  hideRuler() {
    const e = this.parent, t = E.appendOrSelect(e, "g.ruler");
    e.selectAll("[role=graphics-symbol]").dispatch("mouseout"), this.services.events.dispatchEvent(f.Tooltip.HIDE), t.attr("opacity", 0);
  }
  /**
   * Adds the listener on the X grid to trigger multiple point tooltips along the x axis.
   */
  addBackdropEventListeners() {
    this.isEventListenerAdded = !0;
    const e = this, t = this.services.domUtils.getHolder(), s = this.model.getDisplayData();
    let n = function(a) {
      const i = qe(a, e.parent.node());
      e.showRuler(a, i);
    };
    if (s.length > 100) {
      const a = s.length % 50 * 12.5;
      n = Mn(
        function(i) {
          const { mousePosition: o } = this;
          e.showRuler(i, o);
        },
        a,
        t
      );
    }
    this.backdrop.on("mousemove mouseover", n).on("mouseout", this.hideRuler.bind(this));
  }
  drawBackdrop() {
    const e = this.parent;
    this.backdrop = E.appendOrSelect(e, "svg.chart-grid-backdrop");
  }
}
class Vt extends z {
  constructor() {
    super(...arguments), this.type = "scatter", this.renderType = H.SVG, this.handleChartHolderOnHover = () => {
      if (!this.parent)
        throw new Error("Parent not defined");
      this.parent.selectAll("circle.dot").transition("chart-holder-hover-scatter").call(
        (e) => {
          var t;
          return (t = this.services.transitions) == null ? void 0 : t.setupTransition({
            transition: e,
            name: "chart-holder-hover-scatter"
          });
        }
      ).attr("opacity", 1);
    }, this.handleChartHolderOnMouseOut = () => {
      if (!this.parent)
        throw new Error("Parent not defined");
      this.parent.selectAll("circle.dot").transition("chart-holder-mouseout-scatter").call(
        (e) => {
          var t;
          return (t = this.services.transitions) == null ? void 0 : t.setupTransition({
            transition: e,
            name: "chart-holder-mouseout-scatter"
          });
        }
      ).attr("opacity", 0);
    }, this.handleLegendOnHover = (e) => {
      const { hoveredElement: t } = e.detail, { groupMapsTo: s } = this.getOptions().data;
      if (!this.parent)
        throw new Error("Parent not defined");
      this.parent.selectAll("circle.dot").transition("legend-hover-scatter").call(
        (n) => {
          var a;
          return (a = this.services.transitions) == null ? void 0 : a.setupTransition({
            transition: n,
            name: "legend-hover-scatter"
          });
        }
      ).attr("opacity", (n) => n[s] !== t.datum().name ? 0.3 : 1);
    }, this.handleLegendMouseOut = () => {
      if (!this.parent)
        throw new Error("Parent not defined");
      this.parent.selectAll("circle.dot").transition("legend-mouseout-scatter").call(
        (e) => {
          var t;
          return (t = this.services.transitions) == null ? void 0 : t.setupTransition({
            transition: e,
            name: "legend-mouseout-scatter"
          });
        }
      ).attr("opacity", 1);
    };
  }
  init() {
    const { events: e } = this.services;
    if (!e)
      throw new Error("Services events are undefined.");
    e.addEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.addEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
    const { fadeInOnChartHolderMouseover: t } = this.configs;
    t && (e.addEventListener(f.Chart.MOUSEOVER, this.handleChartHolderOnHover), e.addEventListener(f.Chart.MOUSEOUT, this.handleChartHolderOnMouseOut));
  }
  filterBasedOnZoomDomain(e) {
    const { cartesianScales: t } = this.services;
    if (!t)
      throw new Error("Services cartesianScales are undefined.");
    const s = t.getDomainIdentifier(e), n = this.model.get("zoomDomain");
    return n !== void 0 ? e.filter(
      (a) => a[s].getTime() >= n[0].getTime() && a[s].getTime() <= n[1].getTime()
    ) : e;
  }
  getScatterData() {
    const e = this.getOptions(), { stacked: t } = this.configs;
    let s;
    if (t) {
      const n = Object.keys(e.axes).some((a) => e.axes[a].percentage);
      s = this.model.getStackedData({
        groups: this.configs.groups,
        percentage: n
      });
    } else {
      const { cartesianScales: n } = this.services;
      if (!n)
        throw new Error("Services cartesianScales are undefined.");
      s = this.model.getDisplayData(this.configs.groups).filter((a) => {
        const i = n.getRangeIdentifier(a);
        return a[i] !== void 0 && a[i] !== null;
      });
    }
    return this.filterBasedOnZoomDomain(s);
  }
  render(e) {
    if (!(y(this.getOptions(), "points", "enabled") || y(this.getOptions(), "bubble", "enabled")))
      return;
    const s = this.getComponentContainer({ withinChartClip: !0 }), n = this.getOptions(), { groupMapsTo: a } = n.data, { cartesianScales: i } = this.services;
    if (!i)
      throw new Error("Services cartesianScales are undefined.");
    const o = i.getDomainIdentifier(), l = s.selectAll("circle.dot").data(
      this.getScatterData(),
      (p) => `${p[a]}-${p[o]}`
    );
    l.exit().attr("opacity", 0).remove();
    const d = l.enter().append("circle").classed("dot", !0).attr("opacity", 0).merge(l);
    this.styleCircles(d, e), this.addEventListeners();
  }
  // A value is an anomaly if is above all defined domain and range thresholds
  isDatapointThresholdAnomaly(e) {
    const { handleThresholds: t } = this.configs;
    if (!t)
      return !1;
    const { cartesianScales: s } = this.services;
    if (!s)
      throw new Error("Cartesian scales service is undefined");
    const n = s.getOrientation(), [a, i] = ve(
      s.getHighestDomainThreshold(),
      s.getHighestRangeThreshold(),
      n
    ), [o, l] = ve(
      (p) => s.getDomainValue(p),
      (p) => s.getRangeValue(p),
      n
    ), c = o(e), d = l(e);
    return i && a ? d <= i.scaleValue && c >= a.scaleValue : i ? d <= i.scaleValue : a ? c >= a.scaleValue : !1;
  }
  styleCircles(e, t) {
    const s = this.getOptions(), { filled: n, fillOpacity: a } = s.points, { cartesianScales: i } = this.services;
    if (!i)
      throw new Error("Cartesian scales service is undefined");
    const { groupMapsTo: o } = s.data, l = (u) => i.getDomainValue(u), c = (u) => i.getRangeValue(u), [d, p] = ve(
      l,
      c,
      i.getOrientation()
    ), { fadeInOnChartHolderMouseover: h } = this.configs;
    e.raise().classed("dot", !0).attr("class", (u) => {
      const g = i.getDomainIdentifier(u), b = this.model.getIsFilled(u[o], u[g], u, n) ? [$.FILL, $.STROKE] : [$.STROKE];
      return this.model.getColorClassName({
        classNameTypes: b,
        dataGroupName: u[o],
        originalClassName: "dot"
      }) || "";
    }).classed("threshold-anomaly", (u) => this.isDatapointThresholdAnomaly(u)).classed("filled", (u) => {
      const g = i.getDomainIdentifier(u);
      return this.model.getIsFilled(u[o], u[g], u, n);
    }).classed("unfilled", (u) => {
      const g = i.getDomainIdentifier(u);
      return !this.model.getIsFilled(u[o], u[g], u, n);
    }).transition().call(
      (u) => {
        var g;
        return (g = this.services.transitions) == null ? void 0 : g.setupTransition({
          transition: u,
          name: "scatter-update-enter",
          animate: t
        });
      }
    ).attr("cx", d).attr("cy", p).attr("r", s.points.radius).style("fill", (u) => {
      const g = i.getDomainIdentifier(u);
      if (this.model.getIsFilled(u[o], u[g], u, n))
        return this.model.getFillColor(u[o], u[g], u);
    }).style("stroke", (u) => {
      const g = i.getDomainIdentifier(u);
      return this.model.getStrokeColor(u[o], u[g], u);
    }).attr("fill-opacity", n ? a : 1).attr("opacity", h ? 0 : 1).attr("role", U.GRAPHICS_SYMBOL).attr("aria-roledescription", "point").attr("aria-label", (u) => {
      const g = i.getRangeIdentifier(u);
      return u[g];
    }), this.addEventListeners();
  }
  // Extended in bubble graphs
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getTooltipAdditionalItems(e) {
    return null;
  }
  addEventListeners() {
    const e = this, { groupMapsTo: t } = e.getOptions().data;
    if (!this.parent)
      throw new Error("Parent not defined");
    this.parent.selectAll("circle").on("mouseover", function(s, n) {
      var i, o;
      const a = x(this);
      a.classed("hovered", !0).attr(
        "class",
        (l) => e.model.getColorClassName({
          classNameTypes: [$.FILL],
          dataGroupName: l[t],
          originalClassName: a.attr("class")
        })
      ).style("fill", (l) => {
        var d;
        const c = (d = e.services.cartesianScales) == null ? void 0 : d.getDomainIdentifier(l);
        return e.model.getFillColor(l[t], l[c], l);
      }).classed("unfilled", !1), (i = e.services.events) == null || i.dispatchEvent(f.Tooltip.SHOW, {
        event: s,
        hoveredElement: a,
        data: [n],
        additionalItems: e.getTooltipAdditionalItems(n)
      }), (o = e.services.events) == null || o.dispatchEvent(f.Scatter.SCATTER_MOUSEOVER, {
        event: s,
        element: a,
        datum: n
      });
    }).on("mousemove", function(s, n) {
      var i, o;
      const a = x(this);
      (i = e.services.events) == null || i.dispatchEvent(f.Scatter.SCATTER_MOUSEMOVE, {
        event: s,
        element: a,
        datum: n
      }), (o = e.services.events) == null || o.dispatchEvent(f.Tooltip.MOVE, {
        event: s
      });
    }).on("click", function(s, n) {
      var a;
      (a = e.services.events) == null || a.dispatchEvent(f.Scatter.SCATTER_CLICK, {
        event: s,
        element: x(this),
        datum: n
      });
    }).on("mouseout", function(s, n) {
      var i, o, l;
      const a = x(this);
      if (a.classed("hovered", !1), !e.configs.filled) {
        const { filled: c } = e.getOptions().points, d = (i = e.services.cartesianScales) == null ? void 0 : i.getDomainIdentifier(n), p = e.model.getIsFilled(
          n[t],
          n[d],
          n,
          c
        );
        a.classed("unfilled", !p).style("fill", (h) => p || c ? e.model.getFillColor(h[t], h[d], h) : null);
      }
      (o = e.services.events) == null || o.dispatchEvent(f.Scatter.SCATTER_MOUSEOUT, {
        event: s,
        element: a,
        datum: n
      }), (l = e.services.events) == null || l.dispatchEvent(f.Tooltip.HIDE, {
        hoveredElement: a
      });
    });
  }
  destroy() {
    var t;
    (t = this.parent) == null || t.selectAll("circle").on("mousemove", null).on("mouseout", null);
    const { events: e } = this.services;
    if (!e)
      throw new Error("Services events undefined");
    e.removeEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.removeEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut), e.removeEventListener(f.Chart.MOUSEOVER, this.handleChartHolderOnHover), e.removeEventListener(f.Chart.MOUSEOUT, this.handleChartHolderOnMouseOut);
  }
}
class Zs extends z {
  constructor(e, t, s) {
    super(e, t, s), this.type = "axes", this.renderType = H.SVG, this.truncation = {
      [P.LEFT]: !1,
      [P.RIGHT]: !1,
      [P.TOP]: !1,
      [P.BOTTOM]: !1
    }, s && (this.configs = s), this.margins = this.configs.margins;
  }
  render(e = !0) {
    const { position: t } = this.configs, s = this.getOptions(), n = y(s, "axes", t, "visible"), a = this.getComponentContainer(), { width: i, height: o } = E.getSVGElementSize(a, {
      useAttrs: !0
    }), l = E.appendOrSelect(a, `g.axis.${t}`);
    let c, d;
    if (t === P.BOTTOM || t === P.TOP ? (c = this.configs.axes[P.LEFT] ? this.margins.left : 0, d = this.configs.axes[P.RIGHT] ? i - this.margins.right : i) : (c = o - this.margins.bottom, d = this.margins.top), !this.services.cartesianScales)
      throw new Error("Services cartesianScales undefineds");
    const p = this.services.cartesianScales.getScaleByPosition(t);
    this.scaleType === te.LABELS || this.scaleType === te.LABELS_RATIO ? p.rangeRound([c, d]) : p.range([c, d]);
    let h;
    switch (t) {
      case P.LEFT:
        h = fs;
        break;
      case P.BOTTOM:
        h = Dt;
        break;
      case P.RIGHT:
        h = qs;
        break;
      case P.TOP:
        h = Ys;
        break;
    }
    l.attr("aria-label", `${t} axis`);
    const u = !l.select("g.ticks").empty();
    let g = E.appendOrSelect(l, "g.ticks");
    u || (g.attr("role", `${U.GRAPHICS_OBJECT} ${U.GROUP}`), g.attr("aria-label", `${t} ticks`));
    const m = E.appendOrSelect(l, "g.ticks.invisible").style("opacity", "0").style("pointer-events", "none").attr("aria-hidden", !0).attr("aria-label", `invisible ${t} ticks`), b = y(s, "axes", t), v = this.scaleType === te.TIME || b.scaleType === te.TIME, S = t === P.LEFT || t === P.RIGHT, O = this.model.get("zoomDomain");
    if (O && v && !S && p.domain(O), !n) {
      g.attr("aria-hidden", !0);
      return;
    }
    const L = y(b, "scaleType"), w = y(s, "data", "loading"), T = y(b, "ticks", "number"), k = y(b, "ticks", "values"), _ = y(b, "truncation", "type"), F = y(b, "truncation", "threshold"), V = y(b, "truncation", "numCharacter"), A = T !== null, M = y(s, "timeScale"), G = E.appendOrSelect(m, "g.tick"), D = E.appendOrSelect(G, "text").text("0"), X = E.getSVGElementSize(D.node(), {
      useBBox: !0
    }).height;
    G.remove();
    const re = this.scaleType || b.scaleType || te.LINEAR, W = h(p).tickSizeOuter(0);
    if (p.ticks) {
      let B;
      if (A ? B = T : (B = W.ticks.number, S && (B = this.getNumberOfFittingTicks(
        o,
        X,
        W.ticks.verticalSpaceRatio
      ))), p.ticks().length === 1 && p.ticks()[0] === 0 && (B = 0), W.ticks(B), v)
        if (!p.ticks(B).length)
          W.tickValues([]);
        else {
          const j = y(s, "timeScale", "addSpaceOnEdges"), q = y(s, "axes", t, "domain"), K = p.copy();
          j && !q && K.nice(B);
          const oe = K.ticks(B);
          j && oe.length > 2 && !q && (oe.splice(oe.length - 1, 1), oe.splice(0, 1)), W.tickValues(oe);
        }
    }
    let N;
    const ae = y(b, "ticks", "formatter");
    if (v) {
      const B = ht(
        W.tickValues(),
        y(s, "timeScale", "timeInterval")
      );
      ae === null ? N = (j, q) => ut(j, q, W.tickValues(), B, M) : N = (j, q) => {
        const K = ut(
          j,
          q,
          W.tickValues(),
          B,
          M
        );
        return ae(j, q, K);
      };
    } else
      ae === null ? re === te.LINEAR && (N = (B) => B.toLocaleString()) : N = ae;
    W.tickFormat(N);
    const [Qe, et] = this.services.cartesianScales.getScaleByPosition(t).domain();
    let Re;
    if (k) {
      if (v)
        k.forEach((B, j) => {
          B.getTime === void 0 && (k[j] = new Date(B));
        }), Re = k.filter((B) => {
          const j = B.getTime();
          return j >= new Date(Qe).getTime() && j <= new Date(et).getTime();
        });
      else if (L === te.LABELS) {
        const B = this.services.cartesianScales.getScaleByPosition(t).domain();
        Re = k.filter((j) => B.includes(j));
      } else
        Re = k.filter(
          (B) => B >= Qe && B <= et
        );
      W.tickValues(Re);
    }
    switch (t) {
      case P.LEFT:
        g.attr("transform", `translate(${this.margins.left}, 0)`);
        break;
      case P.BOTTOM:
        g.attr("transform", `translate(0, ${o - this.margins.bottom})`);
        break;
      case P.RIGHT:
        g.attr("transform", `translate(${i - this.margins.right}, 0)`);
        break;
      case P.TOP:
        g.attr("transform", `translate(0, ${this.margins.top})`);
        break;
    }
    const Gt = this.model.isDataEmpty();
    if (b.title) {
      const B = E.appendOrSelect(l, "text.axis-title").html(
        Gt || w ? "" : b.title
      ), j = y(b, "titleOrientation");
      let q;
      switch (t) {
        case P.LEFT:
          j === Wt.RIGHT ? B.attr("transform", "rotate(90)").attr("y", 0).attr("x", p.range()[0] / 2).attr("dy", "-0.5em").style("text-anchor", "middle") : B.attr("transform", "rotate(-90)").attr("y", 0).attr("x", -(p.range()[0] / 2)).attr("dy", "0.75em").style("text-anchor", "middle");
          break;
        case P.BOTTOM:
          B.attr(
            "transform",
            `translate(${this.margins.left / 2 + p.range()[1] / 2}, ${o + 4})`
          ).style("text-anchor", "middle");
          break;
        case P.RIGHT:
          j === Wt.LEFT ? B.attr("transform", "rotate(-90)").attr("y", i).attr("x", -(p.range()[0] / 2)).style("text-anchor", "middle") : B.attr("transform", "rotate(90)").attr("y", -i).attr("x", p.range()[0] / 2).attr("dy", "0.75em").style("text-anchor", "middle");
          break;
        case P.TOP:
          ({ height: q } = E.getSVGElementSize(B, {
            useBBox: !0
          })), B.attr(
            "transform",
            `translate(${this.margins.left / 2 + p.range()[1] / 2}, ${q / 2})`
          ).style("text-anchor", "middle");
          break;
      }
    }
    if (v) {
      const B = ht(
        W.tickValues(),
        y(s, "timeScale", "timeInterval")
      ), j = M.showDayName, q = g;
      e && (g = g.transition().call(
        (oe) => this.services.transitions.setupTransition({
          transition: oe,
          name: "axis-update",
          animate: e
        })
      )), g = g.call(W), q.selectAll(".tick").data(W.tickValues(), p).order().select("text").style("font-weight", (oe, Ge) => An(oe, Ge, W.tickValues(), B, j) ? "bold" : "normal");
    } else
      !e || !u ? g = g.call(W) : g = g.transition().call(
        (B) => this.services.transitions.setupTransition({
          transition: B,
          name: "axis-update",
          animate: e
        })
      ).call(W);
    if (m.call(W), t === P.BOTTOM || t === P.TOP) {
      let B = !1;
      const j = y(b, "ticks", "rotation");
      if (j === st.ALWAYS)
        B = !0;
      else if (j === st.NEVER)
        B = !1;
      else if (!j || j === st.AUTO)
        if (p.step)
          B = m.selectAll("g.tick text").nodes().some(
            (K) => E.getSVGElementSize(K, {
              useBBox: !0
            }).width >= p.step()
          );
        else {
          B = !1;
          const q = m.append("text").text("A"), K = E.getSVGElementSize(q.node(), {
            useBBox: !0
          }).width;
          let oe;
          m.selectAll("g.tick").each(function() {
            const Ge = x(this), C = parseFloat(y(ge(this), "tx"));
            C !== null && oe + Ge.text().length * K * 0.8 >= C && (B = !0), oe = C;
          }), q.remove();
        }
      B ? (A || (W.ticks(
        this.getNumberOfFittingTicks(i, X, W.ticks.horizontalSpaceRatio)
      ), m.call(W), g.call(W)), l.selectAll("g.ticks g.tick text").attr("transform", "rotate(-45)").attr("text-anchor", t === P.TOP ? "start" : "end")) : l.selectAll("g.ticks g.tick text").attr("transform", null).attr("text-anchor", null);
    }
    if (w ? l.attr("opacity", 0) : l.attr("opacity", 1), g.selectAll("g.tick").attr("aria-label", (B) => B), m.selectAll("g.tick").attr("aria-label", (B) => B), _ !== ke.NONE && L === te.LABELS && !k) {
      const B = this.services.cartesianScales.getScaleDomain(t);
      if (B.length > 0) {
        const j = a.select(`g.axis.${t} g.ticks g.tick`).html();
        l.selectAll("g.ticks g.tick").html(j);
        const q = this;
        l.selectAll("g.tick text").data(B).text(function(K) {
          return K.length > F ? (q.truncation[t] = !0, $e(K, _, V)) : K;
        }), this.getInvisibleAxisRef().selectAll("g.tick text").data(B).text(function(K) {
          return K.length > F ? $e(K, _, V) : K;
        }), l.selectAll("g.ticks").html(this.getInvisibleAxisRef().html()), l.selectAll("g.tick text").data(B);
      }
    }
    this.addEventListeners();
  }
  addEventListeners() {
    const e = this.getComponentContainer(), { position: t } = this.configs, s = E.appendOrSelect(e, `g.axis.${t}`), n = this.getOptions(), a = y(n, "axes", t), i = y(a, "scaleType"), o = y(a, "truncation", "threshold"), l = this;
    s.selectAll("g.tick text").on("mouseover", function(c, d) {
      l.services.events.dispatchEvent(f.Axis.LABEL_MOUSEOVER, {
        event: c,
        element: x(this),
        datum: d
      }), i === te.LABELS && d.length > o && l.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: c,
        hoveredElement: x(this),
        content: d
      });
    }).on("mousemove", function(c, d) {
      l.services.events.dispatchEvent(f.Axis.LABEL_MOUSEMOVE, {
        event: c,
        element: x(this),
        datum: d
      }), i === te.LABELS && d.length > o && l.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: c
      });
    }).on("click", function(c, d) {
      l.services.events.dispatchEvent(f.Axis.LABEL_CLICK, {
        event: c,
        element: x(this),
        datum: d
      });
    }).on("mouseout", function(c, d) {
      l.services.events.dispatchEvent(f.Axis.LABEL_MOUSEOUT, {
        event: c,
        element: x(this),
        datum: d
      }), i === te.LABELS && l.services.events.dispatchEvent(f.Tooltip.HIDE);
    });
  }
  getInvisibleAxisRef() {
    const { position: e } = this.configs;
    return this.getComponentContainer().select(`g.axis.${e} g.ticks.invisible`);
  }
  getTitleRef() {
    const { position: e } = this.configs;
    return this.getComponentContainer().select(`g.axis.${e} text.axis-title`);
  }
  getNumberOfFittingTicks(e, t, s) {
    const n = Math.floor(e / (t * s));
    return Gs(n, 2, pt.ticks.number);
  }
  destroy() {
    const e = this.getComponentContainer(), { position: t } = this.configs;
    E.appendOrSelect(e, `g.axis.${t}`).selectAll("g.tick text").on("mouseover", null).on("mousemove", null).on("mouseout", null);
  }
}
class lr extends Zs {
  constructor(e, t, s) {
    super(e, t, s);
  }
  render(e = !0) {
    super.render(e), super.destroy();
    const t = this.configs.position, s = this.getComponentContainer(), n = E.appendOrSelect(s, `g.axis.${t}`), a = this;
    n.selectAll("g.tick").each(function(i, o) {
      const l = x(this);
      l.classed("tick-hover", !0).attr("tabindex", o === 0 ? 0 : -1);
      const c = l.select("text"), { width: d, height: p } = E.getSVGElementSize(c, {
        useBBox: !0
      }), h = E.appendOrSelect(l, "rect.axis-holder");
      let u = 0, g = 0;
      switch (t) {
        case P.LEFT:
          u = -d + Number(c.attr("x")), g = -(p / 2);
          break;
        case P.RIGHT:
          u = Math.abs(Number(c.attr("x"))), g = -(p / 2);
          break;
        case P.TOP:
          u = -(d / 2), g = -p + Number(c.attr("y")) / 2, a.truncation[t] && (u = 0, h.attr("transform", "rotate(-45)"));
          break;
        case P.BOTTOM:
          u = -(d / 2), g = p / 2 - 2, a.truncation[t] && (u = -d, h.attr("transform", "rotate(-45)"));
          break;
      }
      h.attr("x", u - pt.hover.rectanglePadding).attr("y", g).attr("width", d + pt.hover.rectanglePadding * 2).attr("height", p).lower();
    }), this.addEventListeners();
  }
  addEventListeners() {
    const e = this.getComponentContainer(), { position: t } = this.configs, s = E.appendOrSelect(e, `g.axis.${t}`), n = this.getOptions(), a = y(n, "axes", t), i = y(a, "scaleType"), o = y(a, "truncation", "threshold"), l = this;
    s.selectAll("g.tick.tick-hover").on("mouseover", function(c) {
      const d = x(this).select("text"), p = d.datum();
      l.services.events.dispatchEvent(f.Axis.LABEL_MOUSEOVER, {
        event: c,
        element: d,
        datum: p
      }), i === te.LABELS && p.length > o && l.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: c,
        element: d,
        datum: p
      });
    }).on("mousemove", function(c) {
      const d = x(this).select("text"), p = d.datum();
      l.services.events.dispatchEvent(f.Axis.LABEL_MOUSEMOVE, {
        event: c,
        element: d,
        datum: p
      }), l.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: c
      });
    }).on("click", function(c) {
      l.services.events.dispatchEvent(f.Axis.LABEL_CLICK, {
        event: c,
        element: x(this).select("text"),
        datum: x(this).select("text").datum()
      });
    }).on("mouseout", function(c) {
      l.services.events.dispatchEvent(f.Axis.LABEL_MOUSEOUT, {
        event: c,
        element: x(this).select("text"),
        datum: x(this).select("text").datum()
      }), i === te.LABELS && l.services.events.dispatchEvent(f.Tooltip.HIDE);
    }).on("focus", function(c) {
      const d = { clientX: 0, clientY: 0 };
      if (c.target) {
        c.target.focus();
        const p = c.target.getBoundingClientRect();
        d.clientX = p.x, d.clientY = p.y;
      }
      l.services.events.dispatchEvent(f.Axis.LABEL_FOCUS, {
        event: { ...c, ...d },
        element: x(this),
        datum: x(this).select("text").datum()
      });
    }).on("blur", function(c) {
      l.services.events.dispatchEvent(f.Axis.LABEL_BLUR, {
        event: c,
        element: x(this),
        datum: x(this).select("text").datum()
      });
    }).on("keydown", function(c) {
      c.key && c.key === "Escape" && (l.services.events.dispatchEvent(f.Tooltip.HIDE), l.services.events.dispatchEvent(f.Axis.LABEL_BLUR, {
        event: c,
        element: x(this),
        datum: x(this).select("text").datum()
      })), t === P.LEFT || t === P.RIGHT ? c.key && c.key === "ArrowUp" ? l.goNext(this, c) : c.key && c.key === "ArrowDown" && l.goPrevious(this, c) : c.key && c.key === "ArrowLeft" ? l.goPrevious(this, c) : c.key && c.key === "ArrowRight" && l.goNext(this, c);
    });
  }
  // Focus on the next HTML element sibling
  goNext(e, t) {
    e.nextElementSibling && e.nextElementSibling.tagName !== "path" && e.nextElementSibling.dispatchEvent(new Event("focus")), t.preventDefault();
  }
  // Focus on the previous HTML element sibling
  goPrevious(e, t) {
    e.previousElementSibling && e.previousElementSibling.tagName !== "path" && e.previousElementSibling.dispatchEvent(new Event("focus")), t.preventDefault();
  }
  destroy() {
    const e = this.getComponentContainer(), { position: t } = this.configs;
    E.appendOrSelect(e, `g.axis.${t}`).selectAll("g.tick.tick-hover").on("mouseover", null).on("mousemove", null).on("mouseout", null).on("focus", null).on("blur", null);
  }
}
class mc extends z {
  constructor() {
    super(...arguments), this.type = "2D-axes", this.renderType = H.SVG, this.children = {}, this.thresholds = [], this.margins = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
  }
  render(e = !1) {
    const t = {}, s = Object.keys(P), n = y(this.getOptions(), "axes");
    s.forEach((o) => {
      n[P[o]] && (t[P[o]] = !0);
    }), this.configs.axes = t, s.forEach((o) => {
      const l = P[o];
      if (this.configs.axes[l] && !this.children[l]) {
        const c = {
          position: l,
          axes: this.configs.axes,
          margins: this.margins
        }, d = this.model.axisFlavor === Rn.DEFAULT ? new Zs(this.model, this.services, c) : new lr(this.model, this.services, c);
        d.setModel(this.model), d.setServices(this.services), d.setParent(this.parent), this.children[l] = d;
      }
    }), Object.keys(this.children).forEach((o) => {
      this.children[o].render(e);
    });
    const a = {};
    Object.keys(this.children).forEach((o) => {
      const l = this.children[o], c = l.configs.position, d = l.getInvisibleAxisRef(), { width: p, height: h } = E.getSVGElementSize(d, { useBBox: !0 });
      let u;
      switch (l.getTitleRef().empty() ? u = 0 : (u = E.getSVGElementSize(l.getTitleRef(), {
        useBBox: !0
      }).height, (c === P.LEFT || c === P.RIGHT) && (u += 5)), c) {
        case P.TOP:
          a.top = h + u;
          break;
        case P.BOTTOM:
          a.bottom = h + u;
          break;
        case P.LEFT:
          a.left = p + u;
          break;
        case P.RIGHT:
          a.right = p + u;
          break;
      }
    }), this.services.events.dispatchEvent(f.Axis.RENDER_COMPLETE), Object.keys(a).some((o) => this.margins[o] !== a[o]) && (this.margins = Object.assign(this.margins, a), this.model.set({ axesMargins: this.margins }, { skipUpdate: !0 }), this.services.events.dispatchEvent(f.ZoomBar.UPDATE), Object.keys(this.children).forEach((o) => {
      const l = this.children[o];
      l.margins = this.margins;
    }), this.render(!0));
  }
}
class cr extends z {
  constructor() {
    super(...arguments), this.type = "skeleton";
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    const t = y(this.getOptions(), "data", "loading");
    t ? this.renderSkeleton(t) : this.removeSkeleton();
  }
  renderSkeleton(e) {
    if (this.configs.skeleton === Ne.GRID)
      this.renderGridSkeleton(e);
    else if (this.configs.skeleton === Ne.VERT_OR_HORIZ)
      this.renderVertOrHorizSkeleton(e);
    else if (this.configs.skeleton === Ne.PIE)
      this.renderPieSkeleton(e);
    else if (this.configs.skeleton === Ne.DONUT)
      this.renderDonutSkeleton(e);
    else
      throw new Error(`"${this.configs.skeleton}" is not a valid Skeleton type.`);
  }
  renderGridSkeleton(e) {
    this.setScales(), this.drawBackdrop(e), this.drawXGrid(e), this.drawYGrid(e), e && this.setShimmerEffect("shimmer-lines");
  }
  renderVertOrHorizSkeleton(e) {
    const t = this.services.cartesianScales.getOrientation();
    this.setScales(), this.drawBackdrop(e), t === le.VERTICAL && this.drawYGrid(e), t === le.HORIZONTAL && this.drawXGrid(e), this.setShimmerEffect("shimmer-lines");
  }
  renderPieSkeleton(e) {
    const t = this.computeOuterRadius(), s = 0;
    this.drawRing(t, s, e), e && this.setShimmerEffect("shimmer-areas");
  }
  renderDonutSkeleton(e) {
    const t = this.computeOuterRadius(), s = this.computeInnerRadius();
    this.drawRing(t, s, e), e && this.setShimmerEffect("shimmer-areas");
  }
  setScales() {
    const e = this.services.cartesianScales.getMainXScale().range(), t = this.services.cartesianScales.getMainYScale().range();
    this.xScale = Oe().domain([0, 1]).range(e), this.yScale = Oe().domain([0, 1]).range(t);
  }
  drawBackdrop(e) {
    const t = this.parent, { width: s, height: n } = E.getSVGElementSize(t, {
      useAttrs: !0
    });
    this.backdrop = E.appendOrSelect(t, "svg.chart-skeleton.DAII").attr("width", s).attr("height", n);
    const a = E.appendOrSelect(this.backdrop, "rect.chart-skeleton-backdrop");
    a.attr("width", "100%").attr("height", "100%");
    const [i] = this.xScale.range(), [, o] = this.yScale.range();
    this.backdrop.merge(a).attr("x", i).attr("y", o), a.classed("shimmer-effect-lines", e).classed("empty-state-lines", !e).style(
      "stroke",
      e ? `url(#${this.services.domUtils.generateElementIDString("shimmer-lines")})` : null
    );
  }
  drawXGrid(e) {
    const t = +this.backdrop.attr("width"), s = y(this.getOptions(), "grid", "x", "numberOfTicks"), n = this.xScale.ticks(s).map((o) => o * t), a = E.appendOrSelect(this.backdrop, "g.x.skeleton"), i = a.selectAll("line").data(n);
    i.enter().append("line").merge(i).attr("x1", (o) => o).attr("x2", (o) => o).attr("y1", 0).attr("y2", "100%"), a.selectAll("line").classed("shimmer-effect-lines", e).classed("empty-state-lines", !e).style(
      "stroke",
      e ? `url(#${this.services.domUtils.generateElementIDString("shimmer-lines")})` : null
    );
  }
  drawYGrid(e) {
    const t = +this.backdrop.attr("height"), s = this.backdrop.attr("width"), n = y(this.getOptions(), "grid", "y", "numberOfTicks"), a = this.xScale.ticks(n).map((l) => l * t), i = E.appendOrSelect(this.backdrop, "g.y.skeleton"), o = i.selectAll("line").data(a);
    o.enter().append("line").merge(o).attr("x1", 0).attr("x2", s).attr("y1", (l) => l).attr("y2", (l) => l), i.selectAll("line").classed("shimmer-effect-lines", e).classed("empty-state-lines", !e).style(
      "stroke",
      e ? `url(#${this.services.domUtils.generateElementIDString("shimmer-lines")})` : null
    );
  }
  drawRing(e, t, s = !0) {
    const n = this.parent, { width: a, height: i } = E.getSVGElementSize(n, {
      useAttrs: !0
    }), o = E.appendOrSelect(n, "svg.chart-skeleton").attr("width", a).attr("height", i), l = t === 0 ? "pie" : "donut", c = y(this.getOptions(), l, "alignment");
    E.appendOrSelect(o, "rect.chart-skeleton-area-container").attr("width", a).attr("height", i).attr("fill", "none");
    const d = Be().innerRadius(t).outerRadius(e).startAngle(0).endAngle(Math.PI * 2), p = e + Math.abs(Z.radiusOffset), h = e + (Math.min(a, i) - e * 2) / 2, u = E.appendOrSelect(o, "path").attr("class", "skeleton-area-shape").attr("transform", `translate(${p}, ${h})`).attr("d", d).classed("shimmer-effect-areas", s).classed("empty-state-areas", !s).style(
      "fill",
      s ? `url(#${this.services.domUtils.generateElementIDString("shimmer-areas")})` : null
    );
    let g = e + Z.xOffset;
    c === ue.CENTER ? g = a / 2 : c === ue.RIGHT && (g = a - e - Z.xOffset);
    const m = e + Z.yOffset;
    u.attr("transform", `translate(${g}, ${m})`);
  }
  // same logic in pie
  computeOuterRadius() {
    const { width: e, height: t } = E.getSVGElementSize(this.parent, {
      useAttrs: !0
    });
    return Math.min(e, t) / 2 + Z.radiusOffset;
  }
  // same logic in donut
  computeInnerRadius() {
    return this.computeOuterRadius() * (3 / 4);
  }
  setShimmerEffect(e) {
    const a = "stop-bg-shimmer", i = "stop-shimmer", o = this.parent.select(".chart-skeleton"), { width: l } = E.getSVGElementSize(this.parent, {
      useAttrs: !0
    }), c = 0, d = l, p = E.appendOrSelect(o, "defs").lower(), h = E.appendOrSelect(p, "linearGradient").attr("id", this.services.domUtils.generateElementIDString(e)).attr("class", e).attr("x1", c - 3 * 0.2 * l).attr("x2", d).attr("y1", 0).attr("y2", 0).attr("gradientUnits", "userSpaceOnUse").attr("gradientTransform", "translate(0, 0)"), u = `
			<stop class="${a}" offset="${c}"></stop>
			<stop class="${i}" offset="${c + 0.2}"></stop>
			<stop class="${a}" offset="${c + 2 * 0.2}"></stop>
		`;
    h.html(u), g();
    function g() {
      h.attr("gradientTransform", `translate(${c - 3 * 0.2 * l}, 0)`).transition().duration(2e3).delay(1e3).ease(Ks).attr("gradientTransform", `translate(${d + 3 * 0.2 * l}, 0)`).on("end", g);
    }
  }
  removeSkeleton() {
    this.parent.select(".chart-skeleton").remove();
  }
}
class fc extends z {
  constructor() {
    super(...arguments), this.type = "boxplot", this.renderType = H.SVG;
  }
  render(e) {
    const t = this.getComponentContainer({ withinChartClip: !0 }), s = this.getOptions(), { groupMapsTo: n } = s.data, a = this.model.getDataGroupNames(), i = this.services.cartesianScales.getMainXScale(), o = this.services.cartesianScales.getMainYScale(), [l, c] = i.range(), [d, p] = o.range(), h = c - l, u = d - p;
    if (h === 0)
      return;
    const { cartesianScales: g } = this.services, m = g.getOrientation(), b = m === le.VERTICAL, [v, S] = ve(
      (A) => this.services.cartesianScales.getDomainValue(A),
      (A) => this.services.cartesianScales.getRangeValue(A),
      m
    ), O = Math.floor((b ? h : u) / a.length), L = Math.min(O / 2, 16), w = this.model.getBoxplotData(), T = t.selectAll(".box-group").data(w);
    T.exit().remove();
    const k = T.enter().append("g").attr("class", "box-group"), _ = T.merge(k);
    k.append("path").merge(T.select("path.vertical-line.start")).attr(
      "class",
      () => this.model.getColorClassName({
        classNameTypes: [$.STROKE],
        originalClassName: "vertical-line start"
      })
    ).attr("stroke-width", ce.strokeWidth.default).attr("fill", "none").transition().call(
      (A) => this.services.transitions.setupTransition({
        transition: A,
        name: "boxplot-update-verticalstartline",
        animate: e
      })
    ).attr("d", (A) => {
      const M = g.getDomainValue(A[n]), G = M, D = g.getRangeValue(A.whiskers.min), X = g.getRangeValue(A.quartiles.q_25);
      return ie({ x0: M, x1: G, y0: D, y1: X }, m);
    }), k.append("path").merge(T.select("path.vertical-line.end")).attr(
      "class",
      () => this.model.getColorClassName({
        classNameTypes: [$.STROKE],
        originalClassName: "vertical-line end"
      })
    ).attr("stroke-width", ce.strokeWidth.default).attr("fill", "none").transition().call(
      (A) => this.services.transitions.setupTransition({
        transition: A,
        name: "boxplot-update-verticalendline",
        animate: e
      })
    ).attr("d", (A) => {
      const M = g.getDomainValue(A[n]), G = M, D = g.getRangeValue(A.whiskers.max), X = g.getRangeValue(A.quartiles.q_75);
      return ie({ x0: M, x1: G, y0: D, y1: X }, m);
    }), k.append("path").merge(T.select("path.box")).attr(
      "class",
      () => this.model.getColorClassName({
        classNameTypes: [$.FILL, $.STROKE],
        originalClassName: "box"
      })
    ).attr("fill-opacity", ce.box.opacity.default).attr("stroke-width", ce.strokeWidth.default).attr("role", U.GRAPHICS_SYMBOL).attr("aria-roledescription", "box").attr("aria-label", (A) => A[n]).transition().call(
      (A) => this.services.transitions.setupTransition({
        transition: A,
        name: "boxplot-update-quartiles",
        animate: e
      })
    ).attr("d", (A) => {
      const M = g.getDomainValue(A[n]) - L / 2, G = M + L, D = g.getRangeValue(
        Math[b ? "max" : "min"](A.quartiles.q_75, A.quartiles.q_25)
      ), X = D + Math.abs(
        g.getRangeValue(A.quartiles.q_75) - g.getRangeValue(A.quartiles.q_25)
      );
      return ie({ x0: M, x1: G, y0: D, y1: X }, m);
    }), k.append("path").merge(T.select("path.highlight-area")).attr("class", "highlight-area").attr("opacity", 0).attr("d", (A) => {
      const M = g.getDomainValue(A[n]) - L / 2, G = M + L, D = g.getRangeValue(A.whiskers.min), X = g.getRangeValue(A.whiskers.max);
      return ie({ x0: M, x1: G, y0: D, y1: X }, m);
    }), k.append("path").merge(T.select("path.whisker.start")).attr(
      "class",
      () => this.model.getColorClassName({
        classNameTypes: [$.STROKE],
        originalClassName: "whisker start"
      })
    ).attr("stroke-width", ce.strokeWidth.thicker).attr("fill", "none").transition().call(
      (A) => this.services.transitions.setupTransition({
        transition: A,
        name: "boxplot-update-startingwhisker",
        animate: e
      })
    ).attr("d", (A) => {
      const M = g.getDomainValue(A[n]) - L / 4, G = M + L / 2, D = g.getRangeValue(A.whiskers.min), X = g.getRangeValue(A.whiskers.min);
      return ie({ x0: M, x1: G, y0: D, y1: X }, m);
    }), k.append("path").merge(T.select("path.median")).attr("fill", "none").attr(
      "class",
      () => this.model.getColorClassName({
        classNameTypes: [$.STROKE],
        originalClassName: "median"
      })
    ).attr("stroke-width", 2).transition().call(
      (A) => this.services.transitions.setupTransition({
        transition: A,
        name: "boxplot-update-median",
        animate: e
      })
    ).attr("d", (A) => {
      const M = g.getDomainValue(A[n]) - L / 2, G = M + L, D = g.getRangeValue(A.quartiles.q_50);
      return ie({ x0: M, x1: G, y0: D, y1: D }, m);
    }), k.append("path").merge(T.select("path.whisker.end")).attr(
      "class",
      () => this.model.getColorClassName({
        classNameTypes: [$.STROKE],
        originalClassName: "whisker end"
      })
    ).attr("stroke-width", ce.strokeWidth.thicker).attr("fill", "none").transition().call(
      (A) => this.services.transitions.setupTransition({
        transition: A,
        name: "boxplot-update-endingwhisker",
        animate: e
      })
    ).attr("d", (A) => {
      const M = g.getDomainValue(A[n]) - L / 4, G = M + L / 2, D = g.getRangeValue(A.whiskers.max), X = g.getRangeValue(A.whiskers.max);
      return ie({ x0: M, x1: G, y0: D, y1: X }, m);
    });
    const F = _.selectAll("circle.outlier").data(
      (A) => A.outliers.map((M) => ({
        min: A.whiskers.min,
        max: A.whiskers.max,
        [n]: A[n],
        value: M
      }))
    );
    F.exit().remove();
    const V = F.enter().append("circle");
    F.merge(V).attr("r", ce.circle.radius).attr(
      "class",
      () => this.model.getColorClassName({
        classNameTypes: [$.FILL, $.STROKE],
        originalClassName: "outlier"
      })
    ).attr("fill-opacity", ce.circle.opacity.default).attr("cx", v).transition().call(
      (A) => this.services.transitions.setupTransition({
        transition: A,
        name: "boxplot-update-circles",
        animate: e
      })
    ).attr("cy", S), this.addBoxEventListeners(), this.addCircleEventListeners();
  }
  addBoxEventListeners() {
    const e = this, t = this.getOptions(), { groupMapsTo: s } = t.data;
    this.parent.selectAll("path.highlight-area").on("mouseover", function(n, a) {
      const i = x(this);
      x(this.parentNode).select("path.box").classed("hovered", !0).attr("fill-opacity", ce.box.opacity.hovered), e.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: n,
        hoveredElement: i,
        items: [
          {
            label: t.tooltip.groupLabel,
            value: a[s],
            class: e.model.getColorClassName({
              classNameTypes: [$.TOOLTIP]
            })
          },
          {
            label: "Minimum",
            value: a.whiskers.min
          },
          {
            label: "Q1",
            value: a.quartiles.q_25
          },
          {
            label: "Median",
            value: a.quartiles.q_50
          },
          {
            label: "Q3",
            value: a.quartiles.q_75
          },
          {
            label: "Maximum",
            value: a.whiskers.max
          },
          {
            label: "IQR",
            value: a.quartiles.q_75 - a.quartiles.q_25
          }
        ]
      }), e.services.events.dispatchEvent(f.Boxplot.BOX_MOUSEOVER, {
        event: n,
        element: i,
        datum: a
      });
    }).on("mousemove", function(n, a) {
      const i = x(this);
      e.services.events.dispatchEvent(f.Boxplot.BOX_MOUSEMOVE, {
        event: n,
        element: i,
        datum: a
      }), e.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: n
      });
    }).on("click", function(n, a) {
      e.services.events.dispatchEvent(f.Boxplot.BOX_CLICK, {
        event: n,
        element: x(this),
        datum: a
      });
    }).on("mouseout", function(n, a) {
      const i = x(this);
      x(this.parentNode).select("path.box").classed("hovered", !1).attr("fill-opacity", ce.box.opacity.default), e.services.events.dispatchEvent(f.Boxplot.BOX_MOUSEOUT, {
        event: n,
        element: i,
        datum: a
      }), e.services.events.dispatchEvent(f.Tooltip.HIDE, {
        hoveredElement: i
      });
    });
  }
  addCircleEventListeners() {
    const e = this, t = this.getOptions(), { groupMapsTo: s } = t.data, n = this.services.cartesianScales.getRangeIdentifier();
    this.parent.selectAll("circle").on("mouseover", function(a, i) {
      const o = x(this);
      o.classed("hovered", !0).attr("fill-opacity", ce.circle.opacity.hovered).classed("unfilled", !1), e.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: a,
        hoveredElement: o,
        items: [
          {
            label: t.tooltip.groupLabel,
            value: i[s],
            class: e.model.getColorClassName({
              classNameTypes: [$.TOOLTIP]
            })
          },
          {
            label: "Outlier",
            value: i[n]
          }
        ]
      }), e.services.events.dispatchEvent(f.Boxplot.OUTLIER_MOUSEOVER, {
        event: a,
        element: o,
        datum: i
      });
    }).on("mousemove", function(a, i) {
      const o = x(this);
      e.services.events.dispatchEvent(f.Boxplot.OUTLIER_MOUSEMOVE, {
        event: a,
        element: o,
        datum: i
      }), e.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: a
      });
    }).on("click", function(a, i) {
      e.services.events.dispatchEvent(f.Boxplot.OUTLIER_CLICK, {
        event: a,
        element: x(this),
        datum: i
      });
    }).on("mouseout", function(a, i) {
      const o = x(this);
      o.classed("hovered", !1).attr("fill-opacity", ce.circle.opacity.default), e.services.events.dispatchEvent(f.Boxplot.OUTLIER_MOUSEOUT, {
        event: a,
        element: o,
        datum: i
      }), e.services.events.dispatchEvent(f.Tooltip.HIDE, {
        hoveredElement: o
      });
    });
  }
}
class vc extends z {
  constructor() {
    super(...arguments), this.type = "zero-line", this.renderType = H.SVG;
  }
  render(e) {
    const t = this.services.cartesianScales.getRangeAxisPosition({
      groups: this.configs.groups
    }), s = this.services.cartesianScales.getScaleByPosition(t), [n, a] = s.domain(), i = n > 0 && a < 0 || n < 0 && a > 0, o = this.getComponentContainer();
    if (!i) {
      o.selectAll("line.domain").remove();
      return;
    }
    const [l, c] = this.services.cartesianScales.getDomainScale().range();
    let d = +s(0) + 0.5;
    d || (d = s.range()[0]);
    const p = Cn(
      {
        x0: l,
        x1: c,
        y0: d,
        y1: d
      },
      this.services.cartesianScales.getOrientation()
    );
    E.appendOrSelect(o, "line.domain").transition().call(
      (u) => this.services.transitions.setupTransition({
        transition: u,
        name: "zero-line-update",
        animate: e
      })
    ).attr("y1", p.y0).attr("y2", p.y1).attr("x1", p.x0).attr("x2", p.x1);
  }
}
class yc extends Vt {
  constructor() {
    super(...arguments), this.type = "bubble", this.renderType = H.SVG;
  }
  getRadiusScale(e) {
    const t = this.getOptions(), { radiusMapsTo: s } = t.bubble, n = e.data(), a = n.map((c) => c[s]).filter((c) => c), i = E.getHTMLElementSize(this.services.domUtils.getMainContainer()), o = a.length > 0, l = o ? Ke(a) : [1, 1];
    return Oe().domain(l).range(o ? t.bubble.radiusRange(i, n) : [4, 4]);
  }
  styleCircles(e, t) {
    const s = this.getOptions(), { radiusMapsTo: n } = s.bubble, a = this.getRadiusScale(e), { groupMapsTo: i } = s.data, { cartesianScales: o } = this.services, l = (h) => o.getDomainValue(h), c = (h) => o.getRangeValue(h), [d, p] = ve(
      l,
      c,
      o.getOrientation()
    );
    e.raise().classed("dot", !0).attr("role", U.GRAPHICS_SYMBOL).attr("aria-label", (h) => {
      const u = o.getRangeIdentifier(h);
      return h[u];
    }).transition().call(
      (h) => this.services.transitions.setupTransition({
        transition: h,
        name: "bubble-update-enter",
        animate: t
      })
    ).attr("cx", d).attr("cy", p).attr("r", (h) => a(h[n] || 1)).attr(
      "class",
      (h) => this.model.getColorClassName({
        classNameTypes: [$.FILL, $.STROKE],
        dataGroupName: h[i],
        originalClassName: "dot"
      })
    ).style("fill", (h) => {
      const u = this.services.cartesianScales.getDomainIdentifier(h);
      return this.model.getFillColor(h[i], h[u], h);
    }).style("stroke", (h) => {
      const u = this.services.cartesianScales.getDomainIdentifier(h);
      return this.model.getStrokeColor(h[i], h[u], h);
    }).attr("fill-opacity", s.bubble.fillOpacity).attr("opacity", 1);
  }
  getTooltipAdditionalItems(e) {
    const t = y(this.getOptions(), "bubble");
    return [
      {
        label: y(t, "radiusLabel"),
        value: e[y(t, "radiusMapsTo")]
      }
    ];
  }
}
class bc extends z {
  constructor() {
    super(...arguments), this.type = "bullet", this.renderType = H.SVG, this.handleLegendOnHover = (e) => {
      const { hoveredElement: t } = e.detail, { groupMapsTo: s } = this.getOptions().data;
      this.parent.selectAll("path.bar").transition("legend-hover-simple-bar").call(
        (n) => this.services.transitions.setupTransition({
          transition: n,
          name: "legend-hover-simple-bar"
        })
      ).attr("opacity", (n) => n[s] !== t.datum().name ? 0.3 : 1);
    }, this.handleLegendMouseOut = () => {
      this.parent.selectAll("path.bar").transition("legend-mouseout-simple-bar").call(
        (e) => this.services.transitions.setupTransition({
          transition: e,
          name: "legend-mouseout-simple-bar"
        })
      ).attr("opacity", 1);
    };
  }
  init() {
    const e = this.services.events;
    e.addEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.addEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
  render(e) {
    const t = this.getOptions(), { groupMapsTo: s } = t.data, n = this.getComponentContainer({ withinChartClip: !0 }), a = this.model.getDisplayData(this.configs.groups), i = this.services.cartesianScales.getRangeScale(), o = this.services.cartesianScales.getRangeIdentifier(), [l, c] = i.range(), [, d] = i.domain(), p = () => {
      const m = [];
      a.forEach((S) => {
        S.ranges ? S.ranges.forEach((O, L) => {
          O != null && O < d && m.push({
            datum: S,
            value: O,
            order: L + 1
          });
        }) : m.push({
          datum: S,
          order: 1
        });
      });
      const b = E.appendOrSelect(n, "g.range-boxes").selectAll("path.range-box").data(m, (S) => `${S[s]}-${S.order}`);
      b.exit().attr("opacity", 0).remove(), b.enter().append("path").attr("opacity", 0).merge(b).attr("class", (S) => `range-box order-${S.order}`).transition().call(
        (S) => this.services.transitions.setupTransition({
          transition: S,
          name: "bullet-range-box-update-enter",
          animate: e
        })
      ).attr("d", (S) => {
        let L, w, T, k;
        return S.order === 1 ? (L = this.services.cartesianScales.getDomainValue(S.datum) - 16 / 2, w = L + 16, T = c - 2, k = l + 1) : (L = this.services.cartesianScales.getDomainValue(S.datum) - 16 / 2, w = L + 16, T = this.services.cartesianScales.getRangeValue(S.value), k = c), ie(
          { x0: L, x1: w, y0: T, y1: k },
          this.services.cartesianScales.getOrientation()
        );
      }).attr("opacity", 1);
    }, h = () => {
      const m = E.appendOrSelect(n, "g.bars").selectAll("path.bar").data(a, (v) => v[s]);
      m.exit().attr("opacity", 0).remove(), m.enter().append("path").attr("opacity", 0).merge(m).classed("bar", !0).transition().call(
        (v) => this.services.transitions.setupTransition({
          transition: v,
          name: "bullet-bar-update-enter",
          animate: e
        })
      ).attr(
        "class",
        (v) => this.model.getColorClassName({
          classNameTypes: [$.FILL],
          dataGroupName: v[s],
          originalClassName: "bar"
        })
      ).style("fill", (v) => this.model.getFillColor(v[s])).attr("d", (v) => {
        const O = this.services.cartesianScales.getDomainValue(v) - 4, L = O + 8, w = this.services.cartesianScales.getRangeValue(0) + 1, T = this.services.cartesianScales.getRangeValue(v);
        return ie(
          { x0: O, x1: L, y0: w, y1: T },
          this.services.cartesianScales.getOrientation()
        );
      }).attr("opacity", 1).attr("role", U.GRAPHICS_SYMBOL).attr("aria-roledescription", "bar").attr("aria-label", (v) => v.value);
    }, u = () => {
      const m = E.appendOrSelect(n, "g.markers").selectAll("path.marker").data(
        a.filter((v) => y(v, "marker") !== null),
        (v) => v[s]
      );
      m.exit().attr("opacity", 0).remove(), m.enter().append("path").attr("opacity", 0).merge(m).classed("marker", !0).transition().call(
        (v) => this.services.transitions.setupTransition({
          transition: v,
          name: "bullet-marker-update-enter",
          animate: e
        })
      ).attr("d", (v) => {
        const O = this.services.cartesianScales.getDomainValue(v) - 12, L = O + 24, w = this.services.cartesianScales.getRangeValue(v.marker);
        return ie(
          { x0: O, x1: L, y0: w, y1: w },
          this.services.cartesianScales.getOrientation()
        );
      }).attr("opacity", 1);
    }, g = () => {
      let m = [];
      a.filter((S) => y(S, "marker") !== null).forEach((S) => {
        const O = S.marker, L = S[o];
        m = m.concat([
          { datum: S, value: O * 0.25, barValue: L },
          { datum: S, value: O * 0.5, barValue: L },
          { datum: S, value: O * 0.75, barValue: L }
        ]);
      });
      const b = E.appendOrSelect(n, "g.quartiles").selectAll("path.quartile").data(m, (S) => S[s]);
      b.exit().attr("opacity", 0).remove(), b.enter().append("path").attr("opacity", 0).merge(b).attr("class", (S) => `quartile ${S.value <= S.barValue ? "over-bar" : ""}`).transition().call(
        (S) => this.services.transitions.setupTransition({
          transition: S,
          name: "bullet-quartile-update-enter",
          animate: e
        })
      ).attr("d", ({ datum: S, value: O }) => {
        let L = 4;
        S.ranges && S.ranges.indexOf(O) !== -1 && (L = 8);
        const w = this.services.cartesianScales.getDomainValue(S) - L / 2, T = w + L, k = this.services.cartesianScales.getRangeValue(O);
        return ie(
          { x0: w, x1: T, y0: k, y1: k },
          this.services.cartesianScales.getOrientation()
        );
      }).attr("opacity", 1);
    };
    p(), h(), u(), g(), this.addEventListeners();
  }
  addEventListeners() {
    const e = this, t = this.getOptions(), { groupMapsTo: s } = t.data, n = this.services.cartesianScales.getRangeIdentifier();
    this.parent.selectAll("path.bar").on("mouseover", function(a, i) {
      const o = x(this);
      o.classed("hovered", !0), e.services.events.dispatchEvent(f.Bar.BAR_MOUSEOVER, {
        event: a,
        element: o,
        datum: i
      });
      const l = y(t, "bullet", "performanceAreaTitles"), c = e.model.getMatchingRangeIndexForDatapoint(i);
      e.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: a,
        hoveredElement: o,
        items: [
          {
            label: t.tooltip.groupLabel || "Group",
            value: i[s],
            class: e.model.getColorClassName({
              classNameTypes: [$.TOOLTIP],
              dataGroupName: i[s]
            })
          },
          {
            label: "Value",
            value: i[n]
          },
          {
            label: "Target",
            value: i.marker
          },
          {
            label: "Percentage",
            value: `${Math.floor(i[n] / i.marker * 100)}%`
          },
          {
            label: "Performance",
            value: l[c]
          }
        ]
      });
    }).on("mousemove", function(a, i) {
      e.services.events.dispatchEvent(f.Bar.BAR_MOUSEMOVE, {
        event: a,
        element: x(this),
        datum: i
      }), e.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: a
      });
    }).on("click", function(a, i) {
      e.services.events.dispatchEvent(f.Bar.BAR_CLICK, {
        event: a,
        element: x(this),
        datum: i
      });
    }).on("mouseout", function(a, i) {
      const o = x(this);
      o.classed("hovered", !1), e.services.events.dispatchEvent(f.Bar.BAR_MOUSEOUT, {
        event: a,
        element: o,
        datum: i
      }), e.services.events.dispatchEvent(f.Tooltip.HIDE, {
        hoveredElement: o
      });
    });
  }
  destroy() {
    this.parent.selectAll("path.bar").on("mouseover", null).on("mousemove", null).on("mouseout", null);
    const e = this.services.events;
    e.removeEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.removeEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
}
function dr(r) {
  return r;
}
function hr(r) {
  if (r == null)
    return dr;
  var e, t, s = r.scale[0], n = r.scale[1], a = r.translate[0], i = r.translate[1];
  return function(o, l) {
    l || (e = t = 0);
    var c = 2, d = o.length, p = new Array(d);
    for (p[0] = (e += o[0]) * s + a, p[1] = (t += o[1]) * n + i; c < d; )
      p[c] = o[c], ++c;
    return p;
  };
}
function ur(r, e) {
  for (var t, s = r.length, n = s - e; n < --s; )
    t = r[n], r[n++] = r[s], r[s] = t;
}
function pr(r, e) {
  return typeof e == "string" && (e = r.objects[e]), e.type === "GeometryCollection" ? { type: "FeatureCollection", features: e.geometries.map(function(t) {
    return ds(r, t);
  }) } : ds(r, e);
}
function ds(r, e) {
  var t = e.id, s = e.bbox, n = e.properties == null ? {} : e.properties, a = Bt(r, e);
  return t == null && s == null ? { type: "Feature", properties: n, geometry: a } : s == null ? { type: "Feature", id: t, properties: n, geometry: a } : { type: "Feature", id: t, bbox: s, properties: n, geometry: a };
}
function Bt(r, e) {
  var t = hr(r.transform), s = r.arcs;
  function n(d, p) {
    p.length && p.pop();
    for (var h = s[d < 0 ? ~d : d], u = 0, g = h.length; u < g; ++u)
      p.push(t(h[u], u));
    d < 0 && ur(p, g);
  }
  function a(d) {
    return t(d);
  }
  function i(d) {
    for (var p = [], h = 0, u = d.length; h < u; ++h)
      n(d[h], p);
    return p.length < 2 && p.push(p[0]), p;
  }
  function o(d) {
    for (var p = i(d); p.length < 4; )
      p.push(p[0]);
    return p;
  }
  function l(d) {
    return d.map(o);
  }
  function c(d) {
    var p = d.type, h;
    switch (p) {
      case "GeometryCollection":
        return { type: p, geometries: d.geometries.map(c) };
      case "Point":
        h = a(d.coordinates);
        break;
      case "MultiPoint":
        h = d.coordinates.map(a);
        break;
      case "LineString":
        h = i(d.arcs);
        break;
      case "MultiLineString":
        h = d.arcs.map(i);
        break;
      case "Polygon":
        h = l(d.arcs);
        break;
      case "MultiPolygon":
        h = d.arcs.map(l);
        break;
      default:
        return null;
    }
    return { type: p, coordinates: h };
  }
  return c(e);
}
function gr(r, e) {
  var t = {}, s = {}, n = {}, a = [], i = -1;
  e.forEach(function(c, d) {
    var p = r.arcs[c < 0 ? ~c : c], h;
    p.length < 3 && !p[1][0] && !p[1][1] && (h = e[++i], e[i] = c, e[d] = h);
  }), e.forEach(function(c) {
    var d = o(c), p = d[0], h = d[1], u, g;
    if (u = n[p])
      if (delete n[u.end], u.push(c), u.end = h, g = s[h]) {
        delete s[g.start];
        var m = g === u ? u : u.concat(g);
        s[m.start = u.start] = n[m.end = g.end] = m;
      } else
        s[u.start] = n[u.end] = u;
    else if (u = s[h])
      if (delete s[u.start], u.unshift(c), u.start = p, g = n[p]) {
        delete n[g.end];
        var b = g === u ? u : g.concat(u);
        s[b.start = g.start] = n[b.end = u.end] = b;
      } else
        s[u.start] = n[u.end] = u;
    else
      u = [c], s[u.start = p] = n[u.end = h] = u;
  });
  function o(c) {
    var d = r.arcs[c < 0 ? ~c : c], p = d[0], h;
    return r.transform ? (h = [0, 0], d.forEach(function(u) {
      h[0] += u[0], h[1] += u[1];
    })) : h = d[d.length - 1], c < 0 ? [h, p] : [p, h];
  }
  function l(c, d) {
    for (var p in c) {
      var h = c[p];
      delete d[h.start], delete h.start, delete h.end, h.forEach(function(u) {
        t[u < 0 ? ~u : u] = 1;
      }), a.push(h);
    }
  }
  return l(n, s), l(s, n), e.forEach(function(c) {
    t[c < 0 ? ~c : c] || a.push([c]);
  }), a;
}
function mr(r) {
  for (var e = -1, t = r.length, s, n = r[t - 1], a = 0; ++e < t; )
    s = n, n = r[e], a += s[0] * n[1] - s[1] * n[0];
  return Math.abs(a);
}
function fr(r) {
  return Bt(r, vr.apply(this, arguments));
}
function vr(r, e) {
  var t = {}, s = [], n = [];
  e.forEach(a);
  function a(l) {
    switch (l.type) {
      case "GeometryCollection":
        l.geometries.forEach(a);
        break;
      case "Polygon":
        i(l.arcs);
        break;
      case "MultiPolygon":
        l.arcs.forEach(i);
        break;
    }
  }
  function i(l) {
    l.forEach(function(c) {
      c.forEach(function(d) {
        (t[d = d < 0 ? ~d : d] || (t[d] = [])).push(l);
      });
    }), s.push(l);
  }
  function o(l) {
    return mr(Bt(r, { type: "Polygon", arcs: [l] }).coordinates[0]);
  }
  return s.forEach(function(l) {
    if (!l._) {
      var c = [], d = [l];
      for (l._ = 1, n.push(c); l = d.pop(); )
        c.push(l), l.forEach(function(p) {
          p.forEach(function(h) {
            t[h < 0 ? ~h : h].forEach(function(u) {
              u._ || (u._ = 1, d.push(u));
            });
          });
        });
    }
  }), s.forEach(function(l) {
    delete l._;
  }), {
    type: "MultiPolygon",
    arcs: n.map(function(l) {
      var c = [], d;
      if (l.forEach(function(m) {
        m.forEach(function(b) {
          b.forEach(function(v) {
            t[v < 0 ? ~v : v].length < 2 && c.push(v);
          });
        });
      }), c = gr(r, c), (d = c.length) > 1)
        for (var p = 1, h = o(c[0]), u, g; p < d; ++p)
          (u = o(c[p])) > h && (g = c[0], c[0] = c[p], c[p] = g, h = u);
      return c;
    }).filter(function(l) {
      return l.length > 0;
    })
  };
}
class Ec extends js {
  constructor() {
    super(...arguments), this.type = "ruler-binned", this.renderType = H.SVG;
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  showRuler(e, [t, s]) {
    const n = this.parent, a = this.model.getOptions(), { cartesianScales: i } = this.services, o = i.getOrientation(), l = i.getRangeScale(), [c, d] = l.range(), p = i.getDomainScale(), h = p.invert(
      o === le.VERTICAL ? t : s
    ), u = E.appendOrSelect(n, "g.ruler").attr("aria-label", "ruler"), g = E.appendOrSelect(u, "line.ruler-line"), b = n.selectAll("[role=graphics-symbol]").filter((v) => {
      if (parseFloat(Q(v, "data.x0")) <= h && parseFloat(Q(v, "data.x1")) >= h)
        return !0;
    });
    if (b.size() > 0) {
      this.elementsToHighlight && this.elementsToHighlight.size() > 0 && !Ns(this.elementsToHighlight, b) && this.hideRuler(), b.dispatch("mouseover"), this.elementsToHighlight = b;
      const v = x(b.nodes()[0]).datum(), S = parseFloat(Q(v, "data.x0")), O = parseFloat(Q(v, "data.x1")), L = this.model.getActiveDataGroupNames(), w = L.reverse().map((k) => ({
        label: k,
        value: Q(v, `data.${k}`),
        class: this.model.getColorClassName({
          classNameTypes: [$.TOOLTIP],
          dataGroupName: k
        })
      })).filter((k) => k.value !== 0);
      if (w.length > 0) {
        this.services.events.dispatchEvent(f.Tooltip.SHOW, {
          mousePosition: [t, s],
          hoveredElement: g,
          items: [
            {
              label: Q(a, "bins.rangeLabel") || "Range",
              value: `${S} – ${O}`
            },
            ...w,
            ...y(a, "tooltip", "showTotal") === !0 ? [
              {
                label: Q(a, "tooltip.totalLabel") || "Total",
                value: L.reduce(
                  (_, F) => _ + parseFloat(Q(v, `data.${F}`)),
                  0
                )
              }
            ] : []
          ]
        }), u.attr("opacity", 1);
        const k = p((S + O) / 2);
        o === "horizontal" ? g.attr("x1", d).attr("x2", c).attr("y1", k).attr("y2", k) : g.attr("y1", d).attr("y2", c).attr("x1", k).attr("x2", k);
      } else
        this.hideRuler();
    } else
      this.hideRuler();
  }
}
class Sc extends js {
  formatTooltipData(e) {
    return e.reverse();
  }
}
const xc = (r, e) => {
  const t = r.x, s = r.y, n = e.x, a = e.y, i = Rt();
  return i.moveTo(t, s), i.lineTo(n, a), i.toString();
}, Oc = (r, e, t = 0.5) => {
  const s = r.x, n = r.y, a = e.x, i = e.y, o = Rt();
  return o.moveTo(s, n), o.lineTo(s + (a - s) * t, n), o.lineTo(s + (a - s) * t, i), o.lineTo(a, i), o.toString();
}, Tc = (r, e, t, s, n, a) => {
  const i = r.x, o = r.y, l = e.x, c = e.y, d = Rt();
  return d.moveTo(i, o), d.bezierCurveTo(t, s, n, a, l, c), d.toString();
}, Lc = {
  d: "M7 0v8L0 4z",
  height: 8,
  width: 7.5,
  id: "arrowLeft"
}, wc = {
  d: "M0 0v8l7-4z",
  height: 8,
  width: 7.5,
  id: "arrowRight"
}, Mc = {
  d: "M5.32 9.513a4.75 4.75 0 100-9.5 4.75 4.75 0 000 9.5z",
  height: 10,
  width: 10,
  id: "circle"
}, Ac = {
  d: "M5.03517654-1e-7l4.99999996 5-4.99999996 5-5-5L2.4517844 2.58339204z",
  height: 10,
  width: 10,
  id: "diamond"
}, Cc = {
  d: "M0 .44974747h8v8H0v-3.6830331z",
  height: 9,
  width: 8,
  id: "square"
}, kc = {
  d: "M0 0h1.5v8H0z",
  height: 8,
  width: 2,
  id: "tee"
};
class Ic extends nr {
  constructor(e, t, s) {
    super(e, t, s), this.type = "color-legend", this.renderType = H.SVG, this.gradient_id = `gradient-id-${Math.floor(Math.random() * 99999999999)}`, this.handleAxisCompleteEvent = () => {
      const n = this.getComponentContainer(), { width: a } = E.getSVGElementSize(n, {
        useAttrs: !0
      }), i = y(this.getOptions(), "data", "loading");
      if (a > J.color.barWidth && !i) {
        const o = y(this.getOptions(), "heatmap", "colorLegend", "title"), { cartesianScales: l } = this.services, d = l.getMainXScale().range();
        if (d[0] > 1 && (n.select("g.legend").attr("transform", `translate(${d[0]}, 0)`), o)) {
          const { width: p } = E.getSVGElementSize(
            n.select("g.legend-title").select("text"),
            { useBBox: !0 }
          ), h = d[0] - p - 9;
          h > 1 ? n.select("g.legend-title").attr("transform", `translate(${h}, 0)`) : (n.select("g.legend").attr("transform", `translate(${d[0]}, 16)`), n.select("g.legend-title").attr("transform", `translate(${d[0]}, 0)`));
        }
      } else
        n.select("g.legend-title").attr("transform", "translate(0, 0)");
    }, this.chartType = s.chartType;
  }
  init() {
    this.chartType === "heatmap" && this.services.events.addEventListener(
      f.Axis.RENDER_COMPLETE,
      this.handleAxisCompleteEvent
    );
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    const t = this.getOptions(), s = this.getComponentContainer(), { width: n } = E.getSVGElementSize(s, {
      useAttrs: !0
    }), a = y(t, "color", "gradient", "colors"), i = y(
      t,
      this.chartType,
      "colorLegend",
      "type"
    );
    let o = y(t, "color", "pairing", "option");
    const l = y(t, "heatmap", "colorLegend", "title");
    if (y(this.getOptions(), "data", "loading")) {
      s.html("");
      return;
    }
    const d = !Ts(a), p = kn(this.model.getDisplayData()), h = !(n <= J.color.barWidth), u = h ? J.color.barWidth : n, g = E.appendOrSelect(s, "g.legend"), m = E.appendOrSelect(g, "g.legend-axis");
    if (l) {
      const _ = E.appendOrSelect(s, "g.legend-title");
      E.appendOrSelect(_, "text").text(l).attr("dy", "0.7em"), g.attr("transform", "translate(0, 16)");
    }
    const b = p[0] < 0 && p[1] > 0 ? "diverge" : "mono";
    (o < 1 && o > 4 && b === "mono" || o < 1 && o > 2 && b === "diverge") && (o = 1);
    let v = [];
    const S = b === "diverge" ? 17 : 11;
    if (d)
      v = a;
    else
      for (let _ = 1; _ < S + 1; _++)
        v.push(
          i === nt.LINEAR ? `stop-color-${b}-${o}-${_}` : `fill-${b}-${o}-${_}`
        );
    const O = vs(p[0], p[1]), L = Js(O, 3), w = Oe().domain(p).range([0, u]), T = Dt(w).tickSize(0).tickValues(L);
    let k;
    switch (i) {
      case nt.LINEAR:
        this.drawLinear(v, g, u);
        break;
      case nt.QUANTIZE:
        k = this.drawQuantize(
          v,
          b,
          d,
          g,
          u
        ), w.range([k, u]);
        break;
      default:
        throw Error("Entered color legend type is not supported.");
    }
    m.attr("transform", `translate(0,${J.color.axisYTranslation})`).call(T), m.select(".domain").remove(), m.select("g.tick:last-of-type text").style("text-anchor", h ? "middle" : "end"), m.select("g.tick:first-of-type text").style(
      "text-anchor",
      h && this.chartType !== "choropleth" ? "middle" : "start"
    );
  }
  // Renders gradient legend
  drawLinear(e, t, s) {
    const n = 100 / (e.length - 1);
    E.appendOrSelect(t, "linearGradient").attr("id", `${this.gradient_id}-legend`).selectAll("stop").data(e).enter().append("stop").attr("offset", (o, l) => `${l * n}%`).attr("class", (o, l) => e[l]).attr("stop-color", (o) => o), E.appendOrSelect(t, "rect").attr("width", s).attr("height", J.color.barHeight).style("fill", `url(#${this.gradient_id}-legend)`);
  }
  /**
   * Renders quantized legend
   * @returns number (range start)
   */
  drawQuantize(e, t, s, n, a) {
    !s && t === "diverge" && e.splice(e.length / 2, 1);
    const i = _t().domain(e).range([0, a]);
    return E.appendOrSelect(n, "g.quantized-rect").selectAll("rect").data(i.domain()).join("rect").attr("x", (l) => i(l)).attr("y", 0).attr("width", Math.max(0, i.bandwidth() - 1)).attr("height", J.color.barHeight).attr("class", (l) => l).attr("fill", (l) => l), (!s && t) === "mono" ? i.bandwidth() - 1 : 0;
  }
  destroy() {
    this.chartType === "heatmap" && this.services.events.removeEventListener(
      f.Axis.RENDER_COMPLETE,
      this.handleAxisCompleteEvent
    );
  }
}
class Dc extends sr {
  constructor() {
    super(...arguments), this.type = "meter-title", this.renderType = H.SVG;
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    const t = y(this.model.getDisplayData(), 0), s = this.getOptions(), n = this.getComponentContainer(), { groupMapsTo: a } = s.data;
    if (y(s, "meter", "proportional"))
      this.displayTotal(), this.displayBreakdownTitle();
    else {
      const c = n.selectAll("text.meter-title").data([t[a]]);
      c.enter().append("text").classed("meter-title", !0).merge(c).attr("x", 0).attr("y", "1em").text((d) => d), c.exit().remove(), this.appendPercentage();
    }
    this.displayStatus();
    const o = this.getMaxTitleWidth(), l = E.appendOrSelect(n, "text.meter-title");
    o > 0 && l.node().getComputedTextLength() > o && this.truncateTitle(l, o);
  }
  displayBreakdownTitle() {
    const e = this.getComponentContainer(), t = this.getOptions(), s = this.model.getMaximumDomain(this.model.getDisplayData()), n = y(t, "meter", "proportional", "total"), a = y(t, "meter", "proportional", "unit") ? y(t, "meter", "proportional", "unit") : "";
    let i;
    if (s === n)
      i = null;
    else {
      const d = n !== null ? n - s : s, p = y(t, "meter", "proportional", "breakdownFormatter");
      i = p !== null ? p({
        datasetsTotal: s,
        total: n
      }) : `${s} ${a} used (${d} ${a} available)`;
    }
    const o = e.selectAll("text.proportional-meter-title").data([i]);
    o.enter().append("text").classed("proportional-meter-title", !0).merge(o).attr("x", 0).attr("y", "1em").text((d) => d), o.exit().remove();
    const l = this.getMaxTitleWidth(), c = E.appendOrSelect(e, "text.proportional-meter-title");
    l > 0 && c.node().getComputedTextLength() > l && this.truncateTitle(c, l);
  }
  // show the total for prop meter
  displayTotal() {
    const e = this.getComponentContainer(), t = this.getOptions(), s = y(t, "meter", "proportional", "total"), n = s ? y(t, "meter", "proportional", "total") : this.model.getMaximumDomain(this.model.getDisplayData()), a = y(t, "meter", "proportional", "unit") ? y(t, "meter", "proportional", "unit") : "", i = y(t, "meter", "proportional", "totalFormatter"), o = i !== null ? i(n) : `${s} ${a} total`, l = E.getHTMLElementSize(this.services.domUtils.getMainContainer()), c = l.width ? l.width : this.parent.node().getAttribute("width"), d = e.selectAll("text.proportional-meter-total").data([o]);
    d.enter().append("text").classed("proportional-meter-total", !0).merge(d).attr(
      "x",
      this.model.getStatus() && typeof c != "string" ? c - se.total.paddingRight : c
    ).attr("y", "1em").attr("text-anchor", "end").text((p) => p), d.exit().remove();
  }
  /**
   * Appends the corresponding status based on the value and the peak.
   */
  displayStatus() {
    const e = this, t = this.getComponentContainer(), s = E.getHTMLElementSize(this.services.domUtils.getMainContainer()), n = s.width ? s.width : 0, a = this.model.getStatus(), i = se.status.indicatorSize / 2, o = E.appendOrSelect(t, "g.status-indicator").attr("class", a !== null ? `status-indicator status--${a}` : "").attr("transform", `translate(${n - i}, 0)`), l = a ? [a] : [], c = o.selectAll("circle.status").data(l);
    c.enter().append("circle").merge(c).attr("class", "status").attr("r", i).attr("cx", 0).attr("cy", 8);
    const d = o.selectAll("path.innerFill").data(l);
    d.enter().append("path").merge(d).attr("d", e.getStatusIconPathString(a)).attr("transform", `translate(-${i}, 0)`).attr("class", "innerFill"), d.exit().remove(), c.exit().remove();
  }
  /**
   * Appends the associated percentage to the end of the title
   */
  appendPercentage() {
    const e = y(this.model.getDisplayData(), 0, "value"), t = this.getComponentContainer(), s = E.appendOrSelect(t, "text.meter-title"), n = y(this.getOptions(), "meter", "statusBar", "percentageIndicator", "enabled") === !0 ? [e] : [], a = t.selectAll("text.percent-value").data(n), i = se.statusBar.paddingRight;
    a.enter().append("text").classed("percent-value", !0).merge(a).text((o) => `${o}%`).attr("x", +s.attr("x") + s.node().getComputedTextLength() + i).attr("y", s.attr("y")), a.exit().remove();
  }
  /**
   * Uses the parent class truncate logic
   * @param title d3 selection of title element that will be truncated
   * @param titlestring the original string that needs truncation
   * @param maxWidth the max width the title can take
   */
  truncateTitle(e, t) {
    super.truncateTitle(e, t);
    const s = E.appendOrSelect(this.parent, "tspan"), n = se.statusBar.paddingRight, a = Math.ceil(s.node().getComputedTextLength());
    E.appendOrSelect(this.parent, "text.percent-value").attr(
      "x",
      +e.attr("x") + e.node().getComputedTextLength() + a + n
    );
  }
  // computes the maximum space a title can take
  getMaxTitleWidth() {
    const e = E.getHTMLElementSize(this.services.domUtils.getMainContainer()), t = y(this.getOptions(), "meter", "proportional"), s = e.width ? e.width : this.parent.node().getBoundingClientRect().width;
    if (t !== null) {
      const n = E.appendOrSelect(this.parent, "text.proportional-meter-total").node(), a = E.getSVGElementSize(n, {
        useBBox: !0
      }).width;
      return s - a - se.total.paddingLeft;
    } else {
      const n = E.appendOrSelect(this.parent, "text.percent-value"), a = se.statusBar.paddingRight, i = n.node().getComputedTextLength(), o = E.appendOrSelect(this.parent, "g.status-indicator").node(), l = E.getSVGElementSize(o, { useBBox: !0 }).width + se.status.paddingLeft;
      return s - i - a - l;
    }
  }
  /**
   * Get the associated status icon for the data
   * @param status the active status for the meter chart
   */
  getStatusIconPathString(e) {
    switch (e) {
      case at.SUCCESS:
        return "M6.875 11.3125 3.75 8.1875 4.74375 7.25 6.875 9.34375 11.50625 4.75 12.5 5.7375 Z";
      case at.DANGER:
        return "M10.7 11.5 4.5 5.3 5.3 4.5 11.5 10.7 Z";
      case at.WARNING:
        return "M7.9375,11.125 C7.41973305,11.125 7,11.544733 7,12.0625 C7,12.580267 7.41973305,13 7.9375,13 C8.45526695,13 8.875,12.580267 8.875,12.0625 C8.875,11.544733 8.45526695,11.125 7.9375,11.125 M7.3125, 3 8.5625, 3 8.5625, 9.875 7.3125, 9.875, 7.3125, 3 Z";
    }
  }
}
class $t extends z {
  // Gets the correct width for bars based on options & configurations
  getBarWidth() {
    const e = this.getOptions();
    if (e.bars.width)
      return e.bars.width;
    const t = this.model.getDisplayData().length, s = this.services.cartesianScales.getMainXScale(), n = E.getSVGElementSize(this.parent, {
      useAttrs: !0
    }).width;
    if (!s.step) {
      const a = y(e, "bars", "spacingFactor");
      return Math.min(e.bars.maxWidth, n * a / t);
    }
    return Math.min(e.bars.maxWidth, s.step() / 2);
  }
  isOutsideZoomedDomain(e, t) {
    if (this.model.getDisplayData().length <= 1)
      return !1;
    const n = this.model.get("zoomDomain");
    if (n !== void 0) {
      const a = this.services.cartesianScales.getDomainScale();
      return e < a(n[0]) || t > a(n[1]);
    }
    return !1;
  }
}
class Rc extends z {
  constructor() {
    super(...arguments), this.type = "circle-pack", this.renderType = H.SVG, this.handleLegendOnHover = (e) => {
      const { hoveredElement: t } = e.detail;
      this.parent.selectAll("circle.node").transition("legend-hover-circlepack").call(
        (s) => this.services.transitions.setupTransition({
          transition: s,
          name: "legend-hover-circlepack"
        })
      ).attr("opacity", (s) => s.data.dataGroupName === t.datum().name ? 1 : _e.circles.fillOpacity);
    }, this.handleLegendMouseOut = () => {
      this.parent.selectAll("circle.node").transition("legend-mouseout-circlepack").call(
        (e) => this.services.transitions.setupTransition({
          transition: e,
          name: "legend-mouseout-circlepack"
        })
      ).attr("opacity", 1);
    };
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    const t = this.getComponentContainer({ withinChartClip: !0 }), { width: s, height: n } = E.getSVGElementSize(this.parent, {
      useAttrs: !0
    });
    if (s < 1 || n < 1)
      return;
    let a = this.model.getDisplayData();
    const i = this.model.hasParentNode(), o = this.model.getHierarchyLevel(), l = this.getOptions(), c = y(l, "canvasZoom", "enabled");
    i && y(a, 0, "children") && (a = y(a, 0, "children"));
    const d = Pt({ children: a }).sum((m) => m.value).sort((m, b) => b.value - m.value), h = Qs().size([s, n]).padding((m) => m.depth >= 1 ? _e.padding.children + 3 : _e.padding.mainGroup + 3)(d).descendants().splice(1).filter((m) => m.depth <= o), u = t.selectAll("circle.node").data(h);
    u.exit().attr("width", 0).attr("height", 0).remove();
    const g = u.enter().append("circle").classed("node", !0);
    g.merge(u).attr("class", (m) => {
      const b = c && o === 3 ? this.getZoomClass(m) : "";
      return this.model.getColorClassName({
        classNameTypes: [$.FILL, $.STROKE],
        dataGroupName: m.data.dataGroupName,
        originalClassName: m.children ? `node ${b}` : `node node-leaf ${b}`
      });
    }).style("fill", (m) => this.model.getFillColor(m.data.dataGroupName)).style("stroke", (m) => this.model.getFillColor(m.data.dataGroupName)).attr("cx", (m) => m.x).attr("cy", (m) => m.y).transition("circlepack-leaf-update-enter").call(
      (m) => this.services.transitions.setupTransition({
        transition: m,
        name: "circlepack-leaf-update-enter"
      })
    ).attr("r", (m) => m.r).attr("opacity", 1).attr("fill-opacity", _e.circles.fillOpacity), c === !0 && this.focal && (this.services.canvasZoom.zoomIn(this.focal, g, tt), this.setBackgroundListeners()), i || this.addLegendListeners(), this.addEventListeners();
  }
  // turn off the highlight class on children circles
  unhighlightChildren(e) {
    const t = e.map((s) => s.data);
    this.parent.selectAll("circle.node").filter((s) => t.some((n) => n === s.data) && s.depth > 1).style("stroke", (s) => this.model.getFillColor(s.data.dataGroupName));
  }
  // highlight the children circles with a stroke
  highlightChildren(e) {
    const t = e.map((s) => s.data);
    this.parent.selectAll("circle.node").filter((s) => t.some((n) => n === s.data) && s.depth > 1).style("stroke", _e.circles.hover.stroke);
  }
  getZoomClass(e) {
    return this.model.getHierarchyLevel() === 3 && this.focal && (e.data === this.focal.data || this.focal.children.some((t) => t.data === e.data)) ? "focal" : "non-focal";
  }
  addLegendListeners() {
    const { events: e } = this.services;
    e.addEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.addEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
  removeBackgroundListeners() {
    x(this.services.domUtils.getMainContainer()).on("click", () => null);
  }
  setBackgroundListeners() {
    const e = x(this.services.domUtils.getMainContainer()), t = this, s = this.parent.selectAll("circle.node"), n = y(Os, "canvasZoomSettings");
    e.on("click", () => {
      t.focal = null, t.model.updateHierarchyLevel(2), e.classed("zoomed-in", !1), t.services.canvasZoom.zoomOut(s, n);
    });
  }
  // Zoom icon to be appended to the label in the tooltip
  getZoomIcon() {
    return `
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10">
			<polygon points="5.93 3.71 4.45 3.71 4.45 2.23 3.71 2.23 3.71 3.71 2.23 3.71 2.23 4.45 3.71 4.45 3.71 5.93 4.45 5.93 4.45 4.45 5.93 4.45 5.93 3.71"/>
			<path d="M7.2,6.67a4,4,0,0,0,1-2.59A4.08,4.08,0,1,0,4.07,8.15h0a4,4,0,0,0,2.59-1L9.48,10,10,9.48Zm-3.12.77A3.34,3.34,0,1,1,7.41,4.08,3.34,3.34,0,0,1,4.08,7.44Z"/>
		</svg>`;
  }
  // add event listeners for tooltip on the circles
  addEventListeners() {
    const e = this;
    this.parent.selectAll("circle.node").on("mouseover", function(t, s) {
      const n = x(this);
      n.classed("hovered", !0);
      const a = e.model.getHierarchyLevel(), i = a > 2 && !n.classed("focal"), o = y(e.model.getOptions(), "canvasZoom", "enabled");
      let l = !1;
      if (!i) {
        let c = [], d = [], p = null;
        if (s.children) {
          s.depth > 1 && o && (l = !0, n.classed("clickable", !0)), c = s.children.map((g) => {
            if (g !== null)
              return typeof g.data.value == "number" ? {
                label: g.data.name,
                value: g.data.value
              } : {
                label: g.data.name,
                labelIcon: o && a <= 2 ? e.getZoomIcon() : null,
                value: g.value
              };
          });
          const u = e.model.getOptions();
          d = [
            {
              label: Q(u, "tooltip.totalLabel") || "Total",
              value: s.value,
              bold: !0
            }
          ], e.highlightChildren(s.children);
        } else
          p = s.value;
        const h = getComputedStyle(this, null).getPropertyValue("fill");
        e.services.events.dispatchEvent(f.Tooltip.SHOW, {
          event: t,
          hoveredElement: n,
          items: [
            {
              color: h,
              label: s.data.name,
              labelIcon: l && o && a <= 2 ? e.getZoomIcon() : null,
              value: p
            },
            ...c,
            ...d
          ]
        });
      }
      e.services.events.dispatchEvent(f.CirclePack.CIRCLE_MOUSEOVER, {
        event: t,
        element: n,
        datum: s
      });
    }).on("mousemove", function(t, s) {
      const n = x(this);
      e.services.events.dispatchEvent(f.CirclePack.CIRCLE_MOUSEMOVE, {
        event: t,
        element: n,
        datum: s
      }), e.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: t
      });
    }).on("mouseout", function(t, s) {
      const n = x(this);
      n.classed("hovered", !1), s.children && e.unhighlightChildren(s.children), e.services.events.dispatchEvent(f.CirclePack.CIRCLE_MOUSEOUT, {
        event: t,
        element: n,
        datum: s
      }), e.services.events.dispatchEvent(f.Tooltip.HIDE, {
        hoveredElement: n
      });
    }).on("click", function(t, s) {
      const n = x(this), a = n.classed("non-focal"), i = y(e.model.getOptions(), "canvasZoom", "enabled");
      if (i && e.model.getHierarchyLevel() > 2) {
        const o = e.parent.selectAll("circle.node");
        x(e.services.domUtils.getMainContainer()).classed("zoomed-in", !1), e.focal = null, e.model.updateHierarchyLevel(2), e.services.canvasZoom.zoomOut(o, tt);
      } else if (s.depth === 2 && s.children && !a && i) {
        const o = e.parent.selectAll("circle.node");
        x(e.services.domUtils.getMainContainer()).classed("zoomed-in", !0), e.focal = s, e.model.updateHierarchyLevel(3), e.services.canvasZoom.zoomIn(s, o, tt), t.stopPropagation();
      }
      e.services.events.dispatchEvent(f.CirclePack.CIRCLE_CLICK, {
        event: t,
        element: n,
        datum: s
      });
    });
  }
  destroy() {
    this.parent.selectAll("circle.node").on("mouseover", null).on("mousemove", null).on("mouseout", null).on("click", null);
    const e = this.services.events;
    e.removeEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.removeEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut), this.removeBackgroundListeners();
  }
}
function yr(r, e) {
  const t = tn(this._current, r);
  return (s) => (this._current = t(s), e(this._current));
}
class br extends z {
  constructor() {
    super(...arguments), this.type = "pie", this.renderType = H.SVG, this.handleLegendOnHover = (e) => {
      const { hoveredElement: t } = e.detail, { groupMapsTo: s } = this.getOptions().data;
      this.parent.selectAll("path.slice").transition("legend-hover-bar").call(
        (n) => this.services.transitions.setupTransition({
          transition: n,
          name: "legend-hover-bar"
        })
      ).attr(
        "opacity",
        (n) => n.data[s] !== t.datum().name ? 0.3 : 1
      );
    }, this.handleLegendMouseOut = () => {
      this.parent.selectAll("path.slice").transition("legend-mouseout-bar").call(
        (e) => this.services.transitions.setupTransition({
          transition: e,
          name: "legend-mouseout-bar"
        })
      ).attr("opacity", 1);
    };
  }
  init() {
    const e = this.services.events;
    e.addEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.addEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
  getInnerRadius() {
    return Z.innerRadius;
  }
  render(e = !0) {
    const t = this, s = this.getComponentContainer(), n = this.getOptions(), { groupMapsTo: a } = n.data, { valueMapsTo: i } = n.pie, o = this.model.getDisplayData().filter((M) => M[i] > 0), l = this.computeRadius();
    this.arc = Be().innerRadius(this.getInnerRadius()).outerRadius(l), this.hoverArc = Be().innerRadius(this.getInnerRadius()).outerRadius(l + Z.hoverArc.outerRadiusOffset);
    const d = en().value((M) => M[i]).sort(y(n, "pie", "sortFunction")).padAngle(Z.padAngle)(o), h = E.appendOrSelect(s, "g.slices").attr("role", U.GROUP).attr("data-name", "slices").selectAll("path.slice").data(d, (M) => M.data[a]);
    h.exit().attr("opacity", 0).remove(), h.enter().append("path").classed("slice", !0).attr("opacity", 0).merge(h).attr(
      "class",
      (M) => this.model.getColorClassName({
        classNameTypes: [$.FILL],
        dataGroupName: M.data[a],
        originalClassName: "slice"
      })
    ).style("fill", (M) => t.model.getFillColor(M.data[a])).attr("d", this.arc).transition().call(
      (M) => this.services.transitions.setupTransition({
        transition: M,
        name: "pie_slice_enter_update",
        animate: e
      })
    ).attr("opacity", 1).attr("role", U.GRAPHICS_SYMBOL).attr("aria-roledescription", "slice").attr(
      "aria-label",
      (M) => `${M[i]}, ${zt(M.data[i], o, i) + "%"}`
    ).attrTween("d", function(M) {
      return yr.bind(this)(M, t.arc);
    });
    const m = n.pie.labels.enabled, b = m ? d.filter((M) => M.data[i] > 0) : [], S = E.appendOrSelect(s, "g.labels").attr("role", U.GROUP).attr("data-name", "labels").selectAll("text.pie-label").data(b, (M) => M.data[a]);
    S.exit().attr("opacity", 0).remove();
    const O = S.enter().append("text").classed("pie-label", !0), L = [];
    O.merge(S).style("text-anchor", "middle").text((M) => n.pie.labels.formatter ? n.pie.labels.formatter(M) : zt(M.data[i], o, i) + "%").datum(function(M) {
      const G = l + 7, D = (M.endAngle - M.startAngle) / 2 + M.startAngle, X = D / Math.PI * 180, re = this.getComputedTextLength();
      return M.textOffsetX = re / 2, M.textOffsetY = X > 90 && X < 270 ? 10 : 0, M.xPosition = (M.textOffsetX + G) * Math.sin(D), M.yPosition = (M.textOffsetY + G) * -Math.cos(D), M;
    }).attr("transform", function(M, G) {
      const D = b.length, X = (M.endAngle - M.startAngle) * (180 / Math.PI);
      if (G >= D - 2 && X < Z.callout.minSliceDegree) {
        let re, W;
        return M.index === D - 1 ? (re = M.xPosition + Z.callout.offsetX + Z.callout.textMargin + M.textOffsetX, W = M.yPosition - Z.callout.offsetY, M.direction = it.RIGHT, L.push(M)) : (re = M.xPosition - Z.callout.offsetX - M.textOffsetX - Z.callout.textMargin, W = M.yPosition - Z.callout.offsetY, M.direction = it.LEFT, L.push(M)), `translate(${re}, ${W})`;
      }
      return `translate(${M.xPosition}, ${M.yPosition})`;
    }), this.renderCallouts(L);
    const w = y(n, "donut") ? "donut" : "pie", T = y(n, w, "alignment"), { width: k } = E.getSVGElementSize(this.getParent(), {
      useAttrs: !0
    }), _ = m ? Z.xOffset : 0, F = m ? Z.yOffset : 0;
    let V = l + _;
    T === ue.CENTER ? V = k / 2 : T === ue.RIGHT && (V = k - l - Z.xOffset);
    let A = l + F;
    L.length > 0 && (A += Z.yOffsetCallout), s.attr("x", V + 7).attr("y", A), this.addEventListeners();
  }
  renderCallouts(e) {
    const t = E.appendOrSelect(this.getComponentContainer(), "g.callouts").attr("role", U.GROUP).attr("data-name", "callouts"), s = t.selectAll("g.callout").data(e);
    s.exit().remove();
    const n = s.enter().append("g").classed("callout", !0).attr("role", U.GROUP).attr("aria-roledescription", "label callout");
    n.merge(s).datum(function(o) {
      const { xPosition: l, yPosition: c, direction: d } = o;
      return d === it.RIGHT ? (o.startPos = {
        x: l,
        y: c + o.textOffsetY
      }, o.endPos = {
        x: l + Z.callout.offsetX,
        y: c - Z.callout.offsetY + o.textOffsetY
      }, o.intersectPointX = o.endPos.x - Z.callout.horizontalLineLength) : (o.startPos = {
        x: l,
        y: c + o.textOffsetY
      }, o.endPos = {
        x: l - Z.callout.offsetX,
        y: c - Z.callout.offsetY + o.textOffsetY
      }, o.intersectPointX = o.endPos.x + Z.callout.horizontalLineLength), o;
    }), n.append("line").classed("vertical-line", !0).merge(t.selectAll("line.vertical-line")).datum(function() {
      return x(this.parentNode).datum();
    }).style("stroke-width", "1px").attr("x1", (o) => o.startPos.x).attr("y1", (o) => o.startPos.y).attr("x2", (o) => o.intersectPointX).attr("y2", (o) => o.endPos.y), n.append("line").classed("horizontal-line", !0).merge(t.selectAll("line.horizontal-line")).datum(function() {
      return x(this.parentNode).datum();
    }).style("stroke-width", "1px").attr("x1", (o) => o.intersectPointX).attr("y1", (o) => o.endPos.y).attr("x2", (o) => o.endPos.x).attr("y2", (o) => o.endPos.y);
  }
  addEventListeners() {
    const e = this;
    this.parent.selectAll("path.slice").on("mouseover", function(t, s) {
      const n = x(this);
      n.classed("hovered", !0).transition("pie_slice_mouseover").call(
        (o) => e.services.transitions.setupTransition({
          transition: o,
          name: "pie_slice_mouseover"
        })
      ).attr("d", e.hoverArc), e.services.events.dispatchEvent(f.Pie.SLICE_MOUSEOVER, {
        event: t,
        element: x(this),
        datum: s
      });
      const { groupMapsTo: a } = e.getOptions().data, { valueMapsTo: i } = e.getOptions().pie;
      e.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: t,
        hoveredElement: n,
        items: [
          {
            label: s.data[a],
            value: s.data[i]
          }
        ]
      });
    }).on("mousemove", function(t, s) {
      const n = x(this);
      e.services.events.dispatchEvent(f.Pie.SLICE_MOUSEMOVE, {
        event: t,
        element: n,
        datum: s
      }), e.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: t
      });
    }).on("click", function(t, s) {
      e.services.events.dispatchEvent(f.Pie.SLICE_CLICK, {
        event: t,
        element: x(this),
        datum: s
      });
    }).on("mouseout", function(t, s) {
      const n = x(this);
      n.classed("hovered", !1).transition("pie_slice_mouseout").call(
        (a) => e.services.transitions.setupTransition({
          transition: a,
          name: "pie_slice_mouseout"
        })
      ).attr("d", e.arc), e.services.events.dispatchEvent(f.Pie.SLICE_MOUSEOUT, {
        event: t,
        element: n,
        datum: s
      }), e.services.events.dispatchEvent(f.Tooltip.HIDE, {
        hoveredElement: n
      });
    });
  }
  // Helper functions
  computeRadius() {
    const { width: e, height: t } = E.getSVGElementSize(this.parent, {
      useAttrs: !0
    }), s = this.getOptions(), n = Math.min(e, t) / 2;
    return s.pie.labels.enabled ? n + Z.radiusOffset : n;
  }
}
class _c extends br {
  constructor() {
    super(...arguments), this.type = "donut", this.renderType = H.SVG;
  }
  render(e = !0) {
    super.render(e);
    const t = this;
    if (this.model.isDataEmpty()) {
      this.getComponentContainer().select("g.center").remove();
      return;
    }
    const s = E.appendOrSelect(this.getComponentContainer(), "g.center"), n = this.getOptions(), a = this.computeRadius(), i = y(n, "donut", "center", "label");
    E.appendOrSelect(s, "text.donut-figure").attr("text-anchor", "middle").style("dominant-baseline", () => i === null || i === "" ? "central" : "initial").style("font-size", () => n.donut.center.numberFontSize(a)).transition().call(
      (o) => this.services.transitions.setupTransition({
        transition: o,
        name: "donut-figure-enter-update",
        animate: e
      })
    ).tween("text", function() {
      return t.centerNumberTween(x(this));
    }), i !== null && i !== "" && E.appendOrSelect(s, "text.donut-title").attr("text-anchor", "middle").style("font-size", () => n.donut.center.titleFontSize(a)).attr("y", n.donut.center.titleYPosition(a)).text(i);
  }
  getInnerRadius() {
    return this.computeRadius() * (3 / 4);
  }
  centerNumberTween(e) {
    const t = this.getOptions();
    let s = y(t, "donut", "center", "number");
    s === null && (s = this.model.getDisplayData().reduce((o, l) => o + l[t.pie.valueMapsTo], 0));
    const n = parseInt(e.text().replace(/[, ]+/g, ""), 10) || 0;
    let a;
    n % 1 === 0 && s % 1 === 0 ? a = sn : a = vs;
    const i = a(n, s);
    return (o) => {
      const { numberFormatter: l } = t.donut.center;
      e.text(l(i(o)));
    };
  }
}
const hs = "4,10 8,6 12,10", us = "12,6 8,10 4,6";
class Pc extends z {
  constructor() {
    super(...arguments), this.type = "gauge", this.renderType = H.SVG;
  }
  getValue() {
    var s;
    return ((s = this.model.getData().find((n) => n.group === "value")) == null ? void 0 : s.value) ?? null;
  }
  getValueRatio() {
    return Gs(this.getValue(), 0, 100) / 100;
  }
  getDelta() {
    var s;
    return ((s = this.model.getData().find((n) => n.group === "delta")) == null ? void 0 : s.value) ?? null;
  }
  getArcRatio() {
    const e = this.getOptions();
    return y(e, "gauge", "type") === He.FULL ? 1 : 0.5;
  }
  getArcSize() {
    return this.getArcRatio() * Math.PI * 2;
  }
  getStartAngle() {
    const e = this.getArcSize();
    return e === 2 * Math.PI ? 0 : -e / 2;
  }
  // use provided arrow direction or default to using the delta
  getArrow(e) {
    const t = this.getOptions();
    switch (y(t, "gauge", "deltaArrow", "direction")) {
      case jt.UP:
        return hs;
      case jt.DOWN:
        return us;
      default:
        return e > 0 ? hs : us;
    }
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    const t = this.getComponentContainer().attr("width", "100%").attr("height", "100%"), s = this.getOptions(), n = this.getValue(), a = this.getValueRatio(), i = this.getArcSize(), o = this.getStartAngle(), l = a * i, c = o + l, d = o + i, p = this.computeRadius(), h = this.getInnerRadius();
    this.backgroundArc = Be().innerRadius(h).outerRadius(p).startAngle(c).endAngle(d), this.arc = Be().innerRadius(h).outerRadius(p).startAngle(o).endAngle(c), E.appendOrSelect(t, "path.arc-background").attr("d", this.backgroundArc);
    const u = t.selectAll("path.arc-foreground").data([n]);
    u.enter().append("path").merge(u).attr(
      "class",
      this.model.getColorClassName({
        classNameTypes: [$.FILL],
        dataGroupName: "value",
        originalClassName: "arc-foreground"
      })
    ).style("fill", () => y(this.getOptions(), "color", "scale", "value")).attr("d", this.arc).attr("role", U.GRAPHICS_SYMBOL).attr("aria-roledescription", "value").attr("aria-label", (S) => S), this.drawValueNumber(), this.drawDelta(), u.exit().remove();
    const m = y(s, "gauge", "alignment"), { width: b } = E.getSVGElementSize(this.getParent(), {
      useAttrs: !0
    });
    let v = p;
    m === ue.CENTER ? v = b / 2 : m === ue.RIGHT && (v = b - p), t.attr("x", v).attr("y", p), this.addEventListeners();
  }
  /**
   * draws the value number associated with the Gauge component in the center
   */
  drawValueNumber() {
    const e = this.getComponentContainer(), t = this.getOptions(), s = y(t, "gauge", "type"), n = this.getValue(), a = this.getDelta(), i = this.computeRadius(), o = y(t, "gauge", "valueFontSize"), l = y(t, "gauge", "deltaFontSize"), c = y(t, "gauge", "numberSpacing"), d = y(t, "gauge", "showPercentageSymbol");
    let p = 0;
    s === He.FULL && !a ? p = l(i) : s === He.SEMI && a && (p = -(l(i) + c));
    const h = E.appendOrSelect(e, "g.gauge-numbers").attr(
      "transform",
      `translate(0, ${p})`
    ), u = o(i), g = E.appendOrSelect(h, "g.gauge-value-number"), m = y(t, "gauge", "numberFormatter"), b = g.selectAll("text.gauge-value-number").data([n]);
    b.enter().append("text").attr("class", "gauge-value-number").merge(b).style("font-size", `${u}px`).attr("text-anchor", "middle").text((k) => m(k));
    const { width: v } = E.getSVGElementSize(
      E.appendOrSelect(e, "text.gauge-value-number"),
      { useBBox: !0 }
    ), S = u / 2, O = d ? "%" : "", L = E.appendOrSelect(g, "text.gauge-value-symbol").style("font-size", `${S}px`).attr("x", v / 2).text(O), { width: w, height: T } = E.getSVGElementSize(L, {
      useBBox: !0
    });
    L.attr("y", `-${T / 2}px`), g.attr("transform", `translate(-${w / 2}, 0)`);
  }
  /**
   * adds the delta number for the gauge
   */
  drawDelta() {
    const e = this, t = this.getComponentContainer(), s = this.getOptions(), n = this.getDelta();
    if (n) {
      const a = this.computeRadius(), i = n ? y(s, "gauge", "deltaFontSize") : () => 0, o = n ? y(s, "gauge", "numberFormatter") : () => null, l = y(s, "gauge", "deltaArrow", "size"), c = y(s, "gauge", "numberSpacing"), d = y(s, "gauge", "showPercentageSymbol"), p = E.appendOrSelect(t, "g.gauge-numbers"), h = E.appendOrSelect(p, "g.gauge-delta").attr(
        "transform",
        `translate(0, ${i(a) + c})`
      ), u = E.appendOrSelect(h, "text.gauge-delta-number"), g = d ? "%" : "";
      u.data(n === null ? [] : [n]), u.enter().append("text").classed("gauge-delta-number", !0).merge(u).attr("text-anchor", "middle").style("font-size", `${i(a)}px`).text((S) => `${o(S)}${g}`);
      const { width: m } = E.getSVGElementSize(
        E.appendOrSelect(t, ".gauge-delta-number"),
        { useBBox: !0 }
      ), b = y(s, "gauge", "deltaArrow", "enabled"), v = h.selectAll("svg.gauge-delta-arrow").data(n !== null && b ? [n] : []);
      v.enter().append("svg").merge(v).attr("class", "gauge-delta-arrow").attr("x", -l(a) - m / 2).attr("y", -l(a) / 2 - i(a) * 0.35).attr("width", l(a)).attr("height", l(a)).attr("viewBox", "0 0 16 16").each(function() {
        const S = x(this);
        E.appendOrSelect(S, "rect.gauge-delta-arrow-backdrop").attr("width", "16").attr("height", "16").attr("fill", "none");
        const O = y(s, "gauge", "status");
        E.appendOrSelect(S, "polygon.gauge-delta-arrow").attr("class", O !== null ? `gauge-delta-arrow status--${O}` : "").attr("points", e.getArrow(n));
      }), v.exit().remove(), u.exit().remove();
    } else {
      const a = t.select("g.gauge-delta");
      a.empty() || a.remove();
    }
  }
  getInnerRadius() {
    const e = this.computeRadius(), t = y(this.getOptions(), "gauge", "arcWidth");
    return e - t;
  }
  addEventListeners() {
    const e = this;
    this.parent.selectAll("path.arc-foreground").on("mouseover", function(t, s) {
      e.services.events.dispatchEvent(f.Gauge.ARC_MOUSEOVER, {
        event: t,
        element: x(this),
        datum: s
      });
    }).on("mousemove", function(t, s) {
      const n = x(this);
      e.services.events.dispatchEvent(f.Gauge.ARC_MOUSEMOVE, {
        event: t,
        element: n,
        datum: s
      });
    }).on("click", function(t, s) {
      e.services.events.dispatchEvent(f.Gauge.ARC_CLICK, {
        event: t,
        element: x(this),
        datum: s
      });
    }).on("mouseout", function(t, s) {
      const n = x(this);
      e.services.events.dispatchEvent(f.Gauge.ARC_MOUSEOUT, {
        event: t,
        element: n,
        datum: s
      });
    });
  }
  // Helper functions
  computeRadius() {
    const e = this.getOptions(), t = y(e, "gauge", "type"), { width: s, height: n } = E.getSVGElementSize(this.parent, {
      useAttrs: !0
    });
    return t === He.SEMI ? Math.min(s / 2, n) : Math.min(s / 2, n / 2);
  }
}
class Vc extends $t {
  constructor() {
    super(...arguments), this.type = "grouped-bar", this.renderType = H.SVG, this.padding = 5, this.defaultStepFactor = 70, this.handleLegendOnHover = (e) => {
      const { hoveredElement: t } = e.detail, { groupMapsTo: s } = this.getOptions().data;
      this.parent.selectAll("path.bar").transition("legend-hover-bar").call(
        (n) => this.services.transitions.setupTransition({
          transition: n,
          name: "legend-hover-bar"
        })
      ).attr("opacity", (n) => n[s] !== t.datum().name ? 0.3 : 1);
    }, this.handleLegendMouseOut = () => {
      this.parent.selectAll("path.bar").transition("legend-mouseout-bar").call(
        (e) => this.services.transitions.setupTransition({
          transition: e,
          name: "legend-mouseout-bar"
        })
      ).attr("opacity", 1);
    };
  }
  init() {
    const e = this.services.events;
    e.addEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.addEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
  render(e) {
    const t = this.model.getDisplayData(this.configs.groups), s = this.getOptions(), { groupMapsTo: n } = s.data;
    this.setGroupScale();
    const a = this.getComponentContainer({ withinChartClip: !0 }), i = In(
      t.map((h) => {
        const u = this.services.cartesianScales.getDomainIdentifier(h);
        return h[u] && typeof h[u].toString == "function" ? h[u].toString() : h[u];
      })
    ), o = a.selectAll("g.bars").data(i, (h) => h);
    o.exit().attr("opacity", 0).remove();
    const c = o.enter().append("g").classed("bars", !0).attr("role", U.GROUP).attr("data-name", "bars").merge(o);
    c.transition().call(
      (h) => this.services.transitions.setupTransition({
        transition: h,
        name: "bar-group-update-enter",
        animate: e
      })
    ).attr("transform", (h) => {
      const g = this.services.cartesianScales.getDomainValue(h) - this.getGroupWidth() / 2;
      return this.services.cartesianScales.getOrientation() === le.VERTICAL ? `translate(${g}, 0)` : `translate(0, ${g})`;
    });
    const d = c.selectAll("path.bar").data(
      (h) => this.getDataCorrespondingToLabel(h),
      (h) => h[n]
    );
    d.exit().attr("opacity", 0).remove(), d.enter().append("path").attr("opacity", 0).merge(d).classed("bar", !0).transition().call(
      (h) => this.services.transitions.setupTransition({
        transition: h,
        name: "bar-update-enter",
        animate: e
      })
    ).attr(
      "class",
      (h) => this.model.getColorClassName({
        classNameTypes: [$.FILL],
        dataGroupName: h[n],
        originalClassName: "bar"
      })
    ).style("fill", (h) => this.model.getFillColor(h[n])).attr("d", (h) => {
      const u = this.groupScale(h[n]), g = this.getBarWidth(), m = u, b = u + g, v = this.services.cartesianScales.getRangeAxisPosition({ datum: h }), S = this.services.cartesianScales.getValueThroughAxisPosition(v, 0), O = this.services.cartesianScales.getRangeValue(h), L = this.services.cartesianScales.getDomainValue(h) - g / 2, w = L + g;
      if (!this.isOutsideZoomedDomain(L, w))
        return ie(
          { x0: m, x1: b, y0: S, y1: O },
          this.services.cartesianScales.getOrientation()
        );
    }).attr("opacity", 1).attr("role", U.GRAPHICS_SYMBOL).attr("aria-roledescription", "bar").attr("aria-label", (h) => h.value), this.addEventListeners();
  }
  addEventListeners() {
    const e = this;
    this.parent.selectAll("path.bar").on("mouseover", function(t, s) {
      const n = x(this);
      n.classed("hovered", !0), e.services.events.dispatchEvent(f.Bar.BAR_MOUSEOVER, {
        event: t,
        element: n,
        datum: s
      }), e.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: t,
        hoveredElement: n,
        data: [s]
      });
    }).on("mousemove", function(t, s) {
      const n = x(this);
      e.services.events.dispatchEvent(f.Bar.BAR_MOUSEMOVE, {
        event: t,
        element: n,
        datum: s
      }), e.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: t
      });
    }).on("click", function(t, s) {
      e.services.events.dispatchEvent(f.Bar.BAR_CLICK, {
        event: t,
        element: x(this),
        datum: s
      });
    }).on("mouseout", function(t, s) {
      const n = x(this);
      n.classed("hovered", !1), e.services.events.dispatchEvent(f.Bar.BAR_MOUSEOUT, {
        event: t,
        element: n,
        datum: s
      }), e.services.events.dispatchEvent(f.Tooltip.HIDE, {
        hoveredElement: n
      });
    });
  }
  destroy() {
    this.parent.selectAll("path.bar").on("mouseover", null).on("mousemove", null).on("mouseout", null);
    const e = this.services.events;
    e.removeEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.removeEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
  getDataCorrespondingToLabel(e) {
    return this.model.getDisplayData(this.configs.groups).filter((s) => {
      const n = this.services.cartesianScales.getDomainIdentifier(s);
      return s[n].toString() === e;
    });
  }
  getGroupWidth() {
    const e = this.model.getGroupedData(this.configs.groups), t = this.getTotalGroupPadding();
    return this.getBarWidth() * e.length + t;
  }
  getDomainScaleStep() {
    const e = this.services.cartesianScales.getDomainScale(), t = this.model.getGroupedData(this.configs.groups);
    let s = this.defaultStepFactor;
    if (typeof e.step == "function")
      s = e.step();
    else if (t.length > 0) {
      const n = t.find((a) => {
        var i;
        return ((i = a.data) == null ? void 0 : i.length) > 1;
      });
      if (n) {
        const a = this.services.cartesianScales.getDomainIdentifier(n.data[0]);
        s = Math.abs(
          e(n.data[1][a]) - e(n.data[0][a])
        );
      }
    }
    return s;
  }
  getTotalGroupPadding() {
    const e = this.model.getGroupedData(this.configs.groups);
    return e.length === 1 ? 0 : Math.min(5, 5 * (this.getDomainScaleStep() / this.defaultStepFactor)) * (e.length - 1);
  }
  // Gets the correct width for bars based on options & configurations
  getBarWidth() {
    const e = this.getOptions(), t = y(e, "bars", "width"), s = y(e, "bars", "maxWidth");
    if (t !== null && (s === null || t <= s))
      return t;
    const a = this.model.getGroupedData(this.configs.groups).length, i = this.getTotalGroupPadding();
    return Math.min(
      s,
      (this.getDomainScaleStep() - i) / a
    );
  }
  setGroupScale() {
    const e = this.model.getActiveDataGroupNames(this.configs.groups);
    this.groupScale = _t().domain(e).rangeRound([0, this.getGroupWidth()]);
  }
}
class Bc extends z {
  constructor() {
    super(...arguments), this.type = "heatmap", this.renderType = H.SVG, this.matrix = {}, this.xBandwidth = 0, this.yBandwidth = 0, this.translationUnits = {
      x: 0,
      y: 0
    }, this.handleAxisOnHover = (e) => {
      const { detail: t } = e, { datum: s } = t, n = this.model.getUniqueRanges(), a = this.model.getUniqueDomain(), i = this.services.cartesianScales.getDomainLabel(), o = this.services.cartesianScales.getRangeLabel(), l = this.services.cartesianScales.getMainXScale(), c = this.services.cartesianScales.getMainYScale();
      let d = "", p = null, h = null, u = null;
      this.matrix[s] !== void 0 ? (d = i, n.forEach((g) => {
        if (typeof this.matrix[s][g].value == "number") {
          const m = this.matrix[s][g].value;
          if (p === null) {
            p = m, h = m, u = m;
            return;
          }
          p += m, h = m < h ? m : h, u = m > u ? m : u;
        }
      })) : (d = o, a.forEach((g) => {
        if (typeof this.matrix[g][s].value == "number") {
          const m = this.matrix[g][s].value;
          if (p === null) {
            p = m, h = m, u = m;
            return;
          }
          p += m, h = m < h ? m : h, u = m > u ? m : u;
        }
      })), l(s) !== void 0 ? this.parent.select("g.multi-cell.column-highlight").classed("highlighter-hidden", !1).attr("transform", `translate(${l(s)}, ${dt(c.range())})`) : c(s) !== void 0 && this.parent.select("g.multi-cell.row-highlight").classed("highlighter-hidden", !1).attr("transform", `translate(${dt(l.range())},${c(s)})`), this.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: t.event,
        hoveredElement: x(e.detail.element),
        items: [
          {
            label: d,
            value: s,
            bold: !0
          },
          {
            label: "Min",
            value: h !== null ? h : "-"
          },
          {
            label: "Max",
            value: u !== null ? u : "-"
          },
          {
            label: "Average",
            value: p !== null ? p / a.length : "-"
          }
        ]
      });
    }, this.handleAxisMouseOut = (e) => {
      this.parent.selectAll("g.multi-cell").classed("highlighter-hidden", !0), this.services.events.dispatchEvent(f.Tooltip.HIDE, {
        event: e
      });
    };
  }
  init() {
    const e = this.services.events;
    e.addEventListener(f.Axis.LABEL_MOUSEOVER, this.handleAxisOnHover), e.addEventListener(f.Axis.LABEL_MOUSEOUT, this.handleAxisMouseOut), e.addEventListener(f.Axis.LABEL_FOCUS, this.handleAxisOnHover), e.addEventListener(f.Axis.LABEL_BLUR, this.handleAxisMouseOut);
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    const t = this.getComponentContainer({ withinChartClip: !0 });
    t.lower();
    const { cartesianScales: s } = this.services;
    if (this.matrix = this.model.getMatrix(), t.html(""), y(this.getOptions(), "data", "loading"))
      return;
    const n = s.getMainXScale(), a = s.getMainYScale(), i = s.getDomainIdentifier(), o = s.getRangeIdentifier(), l = this.model.getUniqueDomain(), c = this.model.getUniqueRanges(), d = this.model.getMatrixAsArray(), p = n.range(), h = a.range();
    this.xBandwidth = Math.abs((p[1] - p[0]) / l.length), this.yBandwidth = Math.abs((h[1] - h[0]) / c.length);
    const u = this.services.domUtils.generateElementIDString("heatmap-pattern-stripes");
    t.append("defs").append("pattern").attr("id", u).attr("width", 3).attr("height", 3).attr("patternUnits", "userSpaceOnUse").attr("patternTransform", "rotate(45)").append("rect").classed("pattern-fill", !0).attr("width", 0.5).attr("height", 8);
    const g = t.selectAll().data(d).enter().append("g").attr("class", (m) => `heat-${m.index}`).classed("cell", !0).attr(
      "transform",
      (m) => `translate(${n(m[i])}, ${a(m[o])})`
    ).append("rect").attr(
      "class",
      (m) => this.model.getColorClassName({
        value: m.value,
        originalClassName: `heat-${m.index}`
      })
    ).classed("heat", !0).classed("null-state", (m) => m.index === -1 || m.value === null).attr("width", this.xBandwidth).attr("height", this.yBandwidth).style("fill", (m) => m.index === -1 || m.value === null ? `url(#${u})` : this.model.getFillColor(Number(m.value))).attr("aria-label", (m) => m.value);
    this.createOuterBox("g.cell-highlight", this.xBandwidth, this.yBandwidth), this.createOuterBox(
      "g.multi-cell.column-highlight",
      this.xBandwidth,
      Math.abs(h[1] - h[0])
    ), this.createOuterBox(
      "g.multi-cell.row-highlight",
      Math.abs(p[1] - p[0]),
      this.yBandwidth
    ), this.determineDividerStatus() && (g.style("stroke-width", "1px"), this.parent.select("g.cell-highlight").classed("cell-2", !0)), this.addEventListener();
  }
  /**
   * Generates a box using lines to create a hover effect
   * The lines have drop shadow in their respective direction
   * @param parentTag - tag name
   * @param xBandwidth - X length
   * @param yBandwidth - y length
   */
  createOuterBox(e, t, s) {
    const n = E.appendOrSelect(this.parent, e).classed("shadows", !0).classed("highlighter-hidden", !0);
    E.appendOrSelect(n, "line.top").attr("x1", -1).attr("x2", t + 1), E.appendOrSelect(n, "line.left").attr("x1", 0).attr("y1", -1).attr("x2", 0).attr("y2", s + 1), E.appendOrSelect(n, "line.down").attr("x1", -1).attr("x2", t + 1).attr("y1", s).attr("y2", s), E.appendOrSelect(n, "line.right").attr("x1", t).attr("x2", t).attr("y1", -1).attr("y2", s + 1);
  }
  determineDividerStatus() {
    const e = y(this.getOptions(), "heatmap", "divider", "state");
    return e !== rt.OFF && (e === rt.AUTO && Ft.minCellDividerDimension <= this.xBandwidth && Ft.minCellDividerDimension <= this.yBandwidth || e === rt.ON);
  }
  addEventListener() {
    const e = this, { cartesianScales: t } = this.services, s = this.getOptions(), n = Q(s, "tooltip.totalLabel"), a = t.getDomainIdentifier(), i = t.getRangeIdentifier(), o = t.getDomainLabel(), l = t.getRangeLabel();
    this.parent.selectAll("g.cell").on("mouseover", function(c, d) {
      const p = x(this), h = p.select("rect.heat");
      if (!h.classed("null-state")) {
        const g = Pe(p.attr("transform"));
        e.parent.select("g.cell-highlight").attr(
          "transform",
          `translate(${g.x + e.translationUnits.x}, ${g.y + e.translationUnits.y})`
        ).classed("highlighter-hidden", !1), e.services.events.dispatchEvent(f.Heatmap.HEATMAP_MOUSEOVER, {
          event: c,
          element: h,
          datum: d
        }), e.services.events.dispatchEvent(f.Tooltip.SHOW, {
          event: c,
          items: [
            {
              label: o,
              value: d[a]
            },
            {
              label: l,
              value: d[i]
            },
            {
              label: n || "Total",
              value: d.value,
              color: h.style("fill")
            }
          ]
        });
      }
    }).on("mousemove", function(c, d) {
      e.services.events.dispatchEvent(f.Heatmap.HEATMAP_MOUSEMOVE, {
        event: c,
        element: x(this),
        datum: d
      }), e.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: c
      });
    }).on("click", function(c, d) {
      e.services.events.dispatchEvent(f.Heatmap.HEATMAP_CLICK, {
        event: c,
        element: x(this),
        datum: d
      });
    }).on("mouseout", function(c, d) {
      const h = x(this).select("rect.heat"), u = h.classed("null-state");
      e.parent.select("g.cell-highlight").classed("highlighter-hidden", !0), u || (e.services.events.dispatchEvent(f.Heatmap.HEATMAP_MOUSEOUT, {
        event: c,
        element: h,
        datum: d
      }), e.services.events.dispatchEvent(f.Tooltip.HIDE, {
        event: c,
        hoveredElement: h
      }));
    });
  }
  // Remove event listeners
  destroy() {
    this.parent.selectAll("rect.heat").on("mouseover", null).on("mousemove", null).on("click", null).on("mouseout", null);
    const e = this.services.events;
    e.removeEventListener(f.Legend.ITEM_HOVER, this.handleAxisOnHover), e.removeEventListener(f.Legend.ITEM_MOUSEOUT, this.handleAxisMouseOut);
  }
}
class $c extends z {
  constructor() {
    super(...arguments), this.type = "histogram", this.renderType = H.SVG, this.handleLegendOnHover = (e) => {
      const { hoveredElement: t } = e.detail, s = this.getOptions(), { groupMapsTo: n } = s.data;
      this.parent.selectAll("path.bar").transition("legend-hover-bar").call(
        (a) => this.services.transitions.setupTransition({
          transition: a,
          name: "legend-hover-bar"
        })
      ).attr("opacity", (a) => a[n] !== t.datum().name ? 0.3 : 1);
    }, this.handleLegendMouseOut = () => {
      this.parent.selectAll("path.bar").transition("legend-mouseout-bar").call(
        (e) => this.services.transitions.setupTransition({
          transition: e,
          name: "legend-mouseout-bar"
        })
      ).attr("opacity", 1);
    };
  }
  init() {
    const e = this.services.events;
    e.addEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.addEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
  render(e) {
    const t = this.getComponentContainer(), s = this.model.getOptions(), { groupIdentifier: n } = s, { groupMapsTo: a } = s.data, i = this.model.getBinnedStackedData(), o = this.services.cartesianScales.getMainXScale(), l = t.selectAll("g.bars").data(i, (d) => Q(d, `0.${a}`));
    l.exit().attr("opacity", 0).remove(), l.enter().append("g").classed("bars", !0).attr("role", U.GROUP);
    const c = t.selectAll("g.bars").selectAll("path.bar").data((d) => d);
    c.exit().remove(), c.enter().append("path").merge(c).classed("bar", !0).attr(n, (d, p) => p).transition().call(
      (d) => this.services.transitions.setupTransition({
        transition: d,
        name: "histogram-bar-update-enter",
        animate: e
      })
    ).attr(
      "class",
      (d) => this.model.getColorClassName({
        classNameTypes: [$.FILL],
        dataGroupName: d[a],
        originalClassName: "bar"
      })
    ).style("fill", (d) => this.model.getFillColor(d[a])).attr("d", (d) => {
      const p = Q(d, "data");
      if (!p)
        return;
      const h = o(p.x1) - o(p.x0) - 1, u = this.services.cartesianScales.getDomainValue(p.x0), g = u + h, m = this.services.cartesianScales.getRangeValue(d[0]);
      let b = this.services.cartesianScales.getRangeValue(d[1]);
      return Math.abs(b - m) > 0 && Math.abs(b - m) > s.bars.dividerSize && (this.services.cartesianScales.getOrientation() === le.VERTICAL ? b += 1 : b -= 1), ie(
        { x0: u, x1: g, y0: m, y1: b },
        this.services.cartesianScales.getOrientation()
      );
    }).attr("opacity", 1).attr("role", U.GRAPHICS_SYMBOL).attr("aria-roledescription", "bar").attr("aria-label", (d) => y(d, "data", d[a])), this.addEventListeners();
  }
  addEventListeners() {
    const e = this.model.getOptions(), { groupMapsTo: t } = e.data, s = this;
    this.parent.selectAll("path.bar").on("mouseover", function(n, a) {
      const i = x(this);
      i.classed("hovered", !0);
      const o = parseFloat(Q(a, "data.x0")), l = parseFloat(Q(a, "data.x1")), c = s.services.cartesianScales.getRangeAxisPosition(), d = s.services.cartesianScales.getScaleLabel(c);
      s.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: n,
        hoveredElement: i,
        items: [
          {
            label: Q(e, "bins.rangeLabel") || "Range",
            value: `${o} – ${l}`
          },
          {
            label: e.tooltip.groupLabel || "Group",
            value: a[t],
            class: s.model.getColorClassName({
              classNameTypes: [$.TOOLTIP],
              dataGroupName: a[t]
            })
          },
          {
            label: d,
            value: Q(a, `data.${a[t]}`)
          }
        ]
      });
    }).on("mousemove", function(n) {
      s.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: n
      });
    }).on("mouseout", function() {
      x(this).classed("hovered", !1), s.services.events.dispatchEvent(f.Tooltip.HIDE);
    });
  }
  destroy() {
    this.parent.selectAll("path.bar").on("mouseover", null).on("mousemove", null).on("mouseout", null);
    const e = this.services.events;
    e.removeEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.removeEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
}
class Gc extends Vt {
  constructor() {
    super(...arguments), this.type = "lollipop", this.renderType = H.SVG, this.handleScatterOnHover = (e) => {
      const t = e.detail, s = this.getOptions(), { groupMapsTo: n } = s.data;
      this.parent.selectAll("line.line").attr("stroke-width", (a) => a[n] !== t.datum[n] ? me.weight.unselected : me.weight.selected);
    }, this.handleScatterOnMouseOut = () => {
      this.parent.selectAll("line.line").attr("stroke-width", me.weight.unselected);
    }, this.handleLegendOnHover = (e) => {
      const { hoveredElement: t } = e.detail, s = this.getOptions(), { groupMapsTo: n } = s.data;
      this.parent.selectAll("line.line").transition("legend-hover-line").call(
        (a) => this.services.transitions.setupTransition({
          transition: a,
          name: "legend-hover-line"
        })
      ).attr("opacity", (a) => a[n] !== t.datum().name ? me.opacity.unselected : me.opacity.selected);
    }, this.handleLegendMouseOut = () => {
      this.parent.selectAll("line.line").transition("legend-mouseout-line").call(
        (e) => this.services.transitions.setupTransition({
          transition: e,
          name: "legend-mouseout-line"
        })
      ).attr("opacity", me.opacity.selected);
    };
  }
  init() {
    const { events: e } = this.services;
    e.addEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.addEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
  render(e) {
    const t = this.getComponentContainer({ withinChartClip: !0 }), s = this.model.getOptions(), { groupMapsTo: n } = s.data, { cartesianScales: a } = this.services, i = a.getMainXScale(), o = a.getMainYScale(), l = a.getDomainIdentifier(), c = (v) => a.getDomainValue(v), d = (v) => a.getRangeValue(v), p = a.getOrientation(), [h, u] = ve(
      c,
      d,
      p
    ), g = t.selectAll("line.line").data(
      this.getScatterData(),
      (v) => `${v[n]}-${v[l]}`
    );
    g.exit().attr("opacity", 0).remove();
    const b = g.enter().append("line").attr("opacity", 0).merge(g).classed("line", !0).attr(
      "class",
      (v) => this.model.getColorClassName({
        classNameTypes: [$.STROKE],
        dataGroupName: v[n],
        originalClassName: "line"
      })
    ).transition().call(
      (v) => this.services.transitions.setupTransition({
        transition: v,
        name: "lollipop-line-update-enter",
        animate: e
      })
    ).style("stroke", (v) => this.model.getFillColor(v[n], v[l], v)).attr("opacity", 1);
    p === le.HORIZONTAL ? b.attr("y1", u).attr("y2", u).attr("x1", i.range()[0]).attr("x2", (v) => h(v) - s.points.radius) : b.attr("x1", h).attr("x2", h).attr("y1", o.range()[0]).attr("y2", (v) => u(v) + s.points.radius), this.addScatterPointEventListeners();
  }
  // listen for when individual datapoints are hovered
  addScatterPointEventListeners() {
    this.services.events.addEventListener(
      f.Scatter.SCATTER_MOUSEOVER,
      this.handleScatterOnHover
    ), this.services.events.addEventListener(
      f.Scatter.SCATTER_MOUSEOUT,
      this.handleScatterOnMouseOut
    );
  }
  destroy() {
    const e = this.services.events;
    e.removeEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.removeEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut), e.removeEventListener(f.Scatter.SCATTER_MOUSEOVER, this.handleScatterOnHover), e.removeEventListener(
      f.Scatter.SCATTER_MOUSEOUT,
      this.handleScatterOnMouseOut
    );
  }
}
class Nc extends z {
  constructor() {
    super(...arguments), this.type = "meter", this.renderType = H.SVG;
  }
  getStackedBounds(e, t) {
    let s = 0;
    return e.map((a, i) => i !== 0 ? (s += t(a.value), {
      ...a,
      width: Math.abs(t(a.value) - se.dividerWidth),
      x: s - t(a.value)
    }) : (s = t(a.value), {
      ...a,
      width: Math.abs(t(a.value) - se.dividerWidth),
      x: 0
    }));
  }
  render(e = !0) {
    const t = this, s = this.getComponentContainer(), n = this.getOptions(), a = y(n, "meter", "proportional"), i = this.model.getDisplayData(), o = this.model.getStatus(), { width: l } = E.getSVGElementSize(s, {
      useAttrs: !0
    }), { groupMapsTo: c } = n.data;
    let d;
    if (y(n, "meter", "proportional") === null)
      d = 100;
    else {
      const O = y(n, "meter", "proportional", "total");
      d = O || this.model.getMaximumDomain(this.model.getDisplayData());
    }
    const p = Oe().domain([0, d]).range([0, l]), h = this.getStackedBounds(i, p), u = y(n, "meter", "height");
    E.appendOrSelect(s, "rect.container").attr("x", 0).attr("y", 0).attr("width", l).attr(
      "height",
      u || (a ? se.height.proportional : se.height.default)
    ), E.appendOrSelect(s, "line.rangeIndicator").attr("x1", l).attr("x2", l).attr("y1", 0).attr(
      "y2",
      u || (a ? se.height.proportional : se.height.default)
    );
    const g = s.selectAll("rect.value").data(h), m = o != null && !t.model.isUserProvidedColorScaleValid() && !a ? `value status--${o}` : "value";
    g.enter().append("rect").classed("value", !0).merge(g).attr("x", (O) => O.x).attr("y", 0).attr("height", () => {
      const O = y(n, "meter", "height");
      return O || (a ? se.height.proportional : se.height.default);
    }).attr(
      "class",
      (O) => this.model.getColorClassName({
        classNameTypes: [$.FILL],
        dataGroupName: O[c],
        originalClassName: m
      })
    ).transition().call(
      (O) => this.services.transitions.setupTransition({
        transition: O,
        name: "meter-bar-update",
        animate: e
      })
    ).attr("width", (O) => O.value > d ? p(d) : O.width).style("fill", (O) => t.model.getFillColor(O[c])).attr("role", U.GRAPHICS_SYMBOL).attr("aria-roledescription", "value").attr("aria-label", (O) => O.value), g.exit().remove();
    const b = y(n, "meter", "peak");
    let v = b;
    b !== null && (b > d ? v = d : b < i[0].value && (v = i[0].value > d ? d : i[0].value));
    const S = s.selectAll("line.peak").data(v == null ? [] : [v]);
    S.enter().append("line").classed("peak", !0).merge(S).attr("y1", 0).attr("y2", () => {
      const O = y(n, "meter", "height");
      return O || (a ? se.height.proportional : se.height.default);
    }).transition().call(
      (O) => this.services.transitions.setupTransition({
        transition: O,
        name: "peak-line-update",
        animate: e
      })
    ).attr("x1", (O) => p(O)).attr("x2", (O) => p(O)).attr("role", U.GRAPHICS_SYMBOL).attr("aria-roledescription", "peak").attr("aria-label", (O) => O), S.exit().remove(), this.services.domUtils.setSVGMaxHeight(), this.addEventListeners();
  }
  // add event listeners for tooltips on proportional meter bars
  addEventListeners() {
    const e = this.getOptions(), { groupMapsTo: t } = e.data, s = this, n = y(e, "meter", "proportional");
    this.parent.selectAll("rect.value").on("mouseover", function(a, i) {
      const o = x(this);
      s.services.events.dispatchEvent(f.Meter.METER_MOUSEOVER, {
        event: a,
        element: o,
        datum: i
      }), n && (o.classed("hovered", !0), s.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: a,
        hoveredElement: o,
        items: [
          {
            label: i[t],
            value: i.value
          }
        ]
      }));
    }).on("mousemove", function(a, i) {
      const o = x(this);
      s.services.events.dispatchEvent(f.Meter.METER_MOUSEMOVE, {
        event: a,
        element: o,
        datum: i
      }), n && s.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: a
      });
    }).on("click", function(a, i) {
      s.services.events.dispatchEvent(f.Meter.METER_CLICK, {
        event: a,
        element: x(this),
        datum: i
      });
    }).on("mouseout", function(a, i) {
      const o = x(this);
      s.services.events.dispatchEvent(f.Meter.METER_MOUSEOUT, {
        event: a,
        element: o,
        datum: i
      }), n && (o.classed("hovered", !1), s.services.events.dispatchEvent(f.Tooltip.HIDE, {
        hoveredElement: o
      }));
    });
  }
  destroy() {
    this.parent.selectAll("rect.value").on("mouseover", null).on("mousemove", null).on("mouseout", null).on("click", null);
  }
}
class Hc extends z {
  constructor() {
    super(...arguments), this.type = "radar", this.renderType = H.SVG, this.getLabelDimensions = (e) => {
      const t = E.appendOrSelect(this.getComponentContainer(), "g.tmp-tick"), s = E.appendOrSelect(t, "text").text(e), { width: n, height: a } = E.getSVGElementSize(s.node(), { useBBox: !0 });
      return t.remove(), { width: n, height: a };
    }, this.normalizeFlatData = (e) => {
      const t = this.getOptions(), { angle: s, value: n } = y(t, "radar", "axes"), a = y(t, "data", "groupMapsTo"), i = Ba(
        this.uniqueKeys.map((o) => this.uniqueGroups.map((l) => ({
          [s]: o,
          [a]: l,
          [n]: null
        })))
      );
      return Ie(i, e);
    }, this.normalizeGroupedData = (e) => {
      const t = this.getOptions(), { angle: s, value: n } = y(t, "radar", "axes"), a = y(t, "data", "groupMapsTo");
      return e.map(({ name: i, data: o }) => {
        const l = this.uniqueKeys.map((c) => ({
          [a]: i,
          [s]: c,
          [n]: null
        }));
        return { name: i, data: Ie(l, o) };
      });
    }, this.handleLegendOnHover = (e) => {
      const { hoveredElement: t } = e.detail;
      this.parent.selectAll("g.blobs path").transition("legend-hover-blob").call(
        (s) => this.services.transitions.setupTransition({
          transition: s,
          name: "legend-hover-blob"
        })
      ).style("fill-opacity", (s) => s.name !== t.datum().name ? Ee.opacity.unselected : Ee.opacity.selected).style("stroke-opacity", (s) => s.name !== t.datum().name ? Ee.opacity.unselected : 1);
    }, this.handleLegendMouseOut = () => {
      this.parent.selectAll("g.blobs path").transition("legend-mouseout-blob").call(
        (e) => this.services.transitions.setupTransition({
          transition: e,
          name: "legend-mouseout-blob"
        })
      ).style("fill-opacity", Ee.opacity.selected).style("stroke-opacity", 1);
    };
  }
  init() {
    const { events: e } = this.services;
    e.addEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.addEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
  render(e = !0) {
    const t = this.getComponentContainer(), { width: s, height: n } = E.getSVGElementSize(t, {
      useAttrs: !0
    }), a = this.model.getData(), i = this.model.getGroupedData(), o = this.getOptions(), l = y(o, "data", "groupMapsTo"), c = y(o, "radar", "axes", "value"), { angle: d, value: p } = y(o, "radar", "axes"), { xLabelPadding: h, yLabelPadding: u, yTicksNumber: g, minRange: m, xAxisRectHeight: b } = Ee;
    this.uniqueKeys = Array.from(new Set(a.map((C) => C[d]))), this.uniqueGroups = Array.from(new Set(a.map((C) => C[l]))), this.fullDataNormalized = this.normalizeFlatData(a), this.groupedDataNormalized = this.normalizeGroupedData(i);
    const S = 2 * (this.getLabelDimensions(this.uniqueKeys[0]).height + u), w = (Math.min(s, n) - S) / 2;
    if (w <= 0)
      return;
    const T = _t().domain(this.fullDataNormalized.map((C) => C[d])).range([0, 2 * Math.PI].map((C) => C - Math.PI / 2)), k = dt(this.fullDataNormalized.map((C) => C[p])), _ = Oe().domain([
      k >= 0 ? 0 : k,
      Nt(this.fullDataNormalized.map((C) => C[p]))
    ]).range([m, w]).nice(g), F = _.ticks(g), V = (C) => this.model.getFillColor(C), A = nn().angle((C) => T(C[d]) + Math.PI / 2).radius((C) => _(C[p])).curve(an), M = this.uniqueKeys.map((C) => {
      const I = this.getLabelDimensions(C).width, R = Pn(
        T(C),
        w
      );
      return I + R;
    }), D = {
      x: Nt(M) + h,
      y: n / 2
    }, re = E.appendOrSelect(t, "g.y-axes").attr("role", U.GROUP).selectAll("path").data(F, (C) => C), W = (C) => this.uniqueKeys.map((I) => ({ [d]: I, [p]: C }));
    re.join(
      (C) => C.append("path").attr("opacity", 0).attr("transform", `translate(${D.x}, ${D.y})`).attr("fill", "none").call(
        (I) => I.transition().call(
          (R) => this.services.transitions.setupTransition({
            transition: R,
            name: "radar_y_axes_enter",
            animate: e
          })
        ).attr("opacity", 1).attr("d", (R) => A(W(R)))
      ),
      (C) => C.call(
        (I) => I.transition().call(
          (R) => this.services.transitions.setupTransition({
            transition: R,
            name: "radar_y_axes_update",
            animate: e
          })
        ).attr("opacity", 1).attr("transform", `translate(${D.x}, ${D.y})`).attr("d", (R) => A(W(R)))
      ),
      (C) => C.call(
        (I) => I.transition().call(
          (R) => this.services.transitions.setupTransition({
            transition: R,
            name: "radar_y_axes_exit",
            animate: e
          })
        ).attr("d", (R) => A(W(R))).attr("opacity", 0).remove()
      )
    ), E.appendOrSelect(t, "g.x-axes").attr("role", U.GROUP).selectAll("line").data(this.uniqueKeys, (C) => C).join(
      (C) => C.append("line").attr("opacity", 0).attr("class", (I) => `x-axis-${we(I)}`).attr("stroke-dasharray", "0").attr("x1", (I) => Y(T(I), 0, D).x).attr("y1", (I) => Y(T(I), 0, D).y).attr("x2", (I) => Y(T(I), 0, D).x).attr("y2", (I) => Y(T(I), 0, D).y).call(
        (I) => I.transition().call(
          (R) => this.services.transitions.setupTransition({
            transition: R,
            name: "radar_x_axes_enter",
            animate: e
          })
        ).attr("opacity", 1).attr("x1", (R) => Y(T(R), _.range()[0], D).x).attr("y1", (R) => Y(T(R), _.range()[0], D).y).attr("x2", (R) => Y(T(R), _.range()[1], D).x).attr("y2", (R) => Y(T(R), _.range()[1], D).y)
      ),
      (C) => C.call(
        (I) => I.transition().call(
          (R) => this.services.transitions.setupTransition({
            transition: R,
            name: "radar_x_axes_update",
            animate: e
          })
        ).attr("opacity", 1).attr("x1", (R) => Y(T(R), _.range()[0], D).x).attr("y1", (R) => Y(T(R), _.range()[0], D).y).attr("x2", (R) => Y(T(R), _.range()[1], D).x).attr("y2", (R) => Y(T(R), _.range()[1], D).y)
      ),
      (C) => C.call(
        (I) => I.transition().call(
          (R) => this.services.transitions.setupTransition({
            transition: R,
            name: "radar_x_axes_exit",
            animate: e
          })
        ).attr("opacity", 0).remove()
      )
    ), E.appendOrSelect(t, "g.x-labels").attr("role", U.GROUP).selectAll("text").data(this.uniqueKeys).join(
      (C) => C.append("text").text((I) => I).attr("opacity", 0).attr(
        "x",
        (I) => Y(T(I), _.range()[1] + h, D).x
      ).attr(
        "y",
        (I) => Y(T(I), _.range()[1] + h, D).y
      ).style("text-anchor", (I) => Xt(T(I)).textAnchor).style(
        "dominant-baseline",
        (I) => Xt(T(I)).dominantBaseline
      ).call(
        (I) => I.transition().call(
          (R) => this.services.transitions.setupTransition({
            transition: R,
            name: "radar_x_labels_enter",
            animate: e
          })
        ).attr("opacity", 1)
      ),
      (C) => C.call(
        (I) => I.transition().call(
          (R) => this.services.transitions.setupTransition({
            transition: R,
            name: "radar_x_labels_update",
            animate: e
          })
        ).attr("opacity", 1).attr(
          "x",
          (R) => Y(T(R), _.range()[1] + h, D).x
        ).attr(
          "y",
          (R) => Y(T(R), _.range()[1] + h, D).y
        ).end().finally(() => {
          const R = y(o, "radar", "alignment"), be = this.getAlignmentXOffset(R, t, this.getParent());
          t.attr("x", be);
        })
      ),
      (C) => C.call(
        (I) => I.transition().call(
          (R) => this.services.transitions.setupTransition({
            transition: R,
            name: "radar_x_labels_exit",
            animate: e
          })
        ).attr("opacity", 0).remove()
      )
    ), E.appendOrSelect(t, "g.blobs").attr("role", U.GROUP).selectAll("path").data(this.groupedDataNormalized, (C) => C.name).join(
      (C) => C.append("path").attr(
        "class",
        (I) => this.model.getColorClassName({
          classNameTypes: [$.FILL, $.STROKE],
          dataGroupName: I.name,
          originalClassName: "blob"
        })
      ).attr("role", U.GRAPHICS_SYMBOL).attr("aria-label", (I) => I.name).attr("opacity", 0).attr(
        "transform",
        e ? () => `translate(${D.x}, ${D.y}) scale(${1 + Math.random() * 0.35})` : `translate(${D.x}, ${D.y})`
      ).style("fill", (I) => V(I.name)).style("fill-opacity", Ee.opacity.selected).style("stroke", (I) => V(I.name)).call((I) => {
        const R = I.transition().call(
          (be) => this.services.transitions.setupTransition({
            transition: be,
            name: "radar_blobs_enter",
            animate: e
          })
        );
        e && R.delay(() => Math.random() * 30).attr("transform", `translate(${D.x}, ${D.y})`), R.attr("opacity", 1).attr("d", (be) => A(be.data));
      }),
      (C) => (C.attr(
        "class",
        (I) => this.model.getColorClassName({
          classNameTypes: [$.FILL, $.STROKE],
          dataGroupName: I.name,
          originalClassName: "blob"
        })
      ).style("fill", (I) => V(I.name)).style("stroke", (I) => V(I.name)), C.call(
        (I) => I.transition().call(
          (R) => this.services.transitions.setupTransition({
            transition: R,
            name: "radar_blobs_update",
            animate: e
          })
        ).attr("opacity", 1).attr("transform", `translate(${D.x}, ${D.y})`).attr("d", (R) => A(R.data))
      ), C),
      (C) => C.call((I) => {
        const R = I.transition().call(
          (be) => this.services.transitions.setupTransition({
            transition: be,
            name: "radar_blobs_exit",
            animate: e
          })
        );
        e && R.delay(() => Math.random() * 30).attr(
          "transform",
          () => `translate(${D.x}, ${D.y}) scale(${1 + Math.random() * 0.35})`
        ), R.attr("opacity", 0).remove();
      })
    ), E.appendOrSelect(t, "g.dots").attr("role", U.GROUP).selectAll("circle").data(this.fullDataNormalized.filter((C) => y(C, p) !== null)).join(
      (C) => C.append("circle").attr("role", U.GRAPHICS_SYMBOL).attr("aria-label", (I) => I[c]),
      (C) => C,
      (C) => C.remove()
    ).attr(
      "class",
      (C) => this.model.getColorClassName({
        classNameTypes: [$.FILL],
        dataGroupName: C[l],
        originalClassName: we(C[d])
      })
    ).attr("cx", (C) => Y(T(C[d]), _(C[p]), D).x).attr("cy", (C) => Y(T(C[d]), _(C[p]), D).y).attr("r", 0).attr("opacity", 0).style("fill", (C) => V(C[l])), E.appendOrSelect(t, "g.x-axes-rect").attr("role", U.GROUP).selectAll("rect").data(this.uniqueKeys).join(
      (C) => C.append("rect"),
      (C) => C,
      (C) => C.remove()
    ).attr("x", D.x).attr("y", D.y - b / 2).attr("width", _.range()[1]).attr("height", b).style("fill", "red").style("fill-opacity", 0).attr("transform", (C) => `rotate(${Vn(T(C))}, ${D.x}, ${D.y})`), E.appendOrSelect(t, "g.y-labels").attr("role", U.GROUP).selectAll("text").data(Ke(F)).join(
      (C) => C.append("text").attr("opacity", 0).text((I) => I).attr(
        "x",
        (I) => Y(-Math.PI / 2, _(I), D).x + u
      ).attr("y", (I) => Y(-Math.PI / 2, _(I), D).y).style("text-anchor", "start").style("dominant-baseline", "middle").call(
        (I) => I.transition().call(
          (R) => this.services.transitions.setupTransition({
            transition: R,
            name: "radar_y_labels_enter",
            animate: e
          })
        ).attr("opacity", 1)
      ),
      (C) => C.call(
        (I) => I.transition().call(
          (R) => this.services.transitions.setupTransition({
            transition: R,
            name: "radar_y_labels_update",
            animate: e
          })
        ).text((R) => R).attr("opacity", 1).attr(
          "x",
          (R) => Y(-Math.PI / 2, _(R), D).x + u
        ).attr("y", (R) => Y(-Math.PI / 2, _(R), D).y)
      ),
      (C) => C.call(
        (I) => I.transition().call(
          (R) => this.services.transitions.setupTransition({
            transition: R,
            name: "radar_y_labels_exit",
            animate: e
          })
        ).attr("opacity", 0).remove()
      )
    ), this.addEventListeners();
  }
  getAlignmentXOffset(e, t, s) {
    const n = E.getSVGElementSize(t, {
      useBBox: !0
    }), { width: a } = E.getSVGElementSize(s, {
      useAttrs: !0
    });
    let i = 0;
    return e === ue.CENTER ? i = Math.floor((a - n.width) / 2) : e === ue.RIGHT && (i = a - n.width), i;
  }
  destroy() {
    this.parent.selectAll(".x-axes-rect > rect").on("mouseover", null).on("mousemove", null).on("mouseout", null);
    const e = this.services.events;
    e.removeEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.removeEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
  addEventListeners() {
    const e = this, {
      axes: { angle: t }
    } = y(this.getOptions(), "radar");
    this.parent.selectAll(".x-axes-rect > rect").on("mouseover", function(s, n) {
      const a = x(this);
      e.services.events.dispatchEvent(f.Radar.X_AXIS_MOUSEOVER, {
        event: s,
        element: a,
        datum: n
      });
      const i = e.parent.select(`.x-axes .x-axis-${we(n)}`), o = e.parent.selectAll(`.dots circle.${we(n)}`), l = e.model.getActiveDataGroupNames(), c = e.getOptions(), { groupMapsTo: d } = c.data, p = y(c, "radar", "axes", "value");
      i.classed("hovered", !0).attr("stroke-dasharray", "4 4"), o.classed("hovered", !0).attr(
        "opacity",
        (u) => l.indexOf(u[d]) !== -1 ? 1 : 0
      ).attr("r", Ee.dotsRadius);
      const h = e.fullDataNormalized.filter(
        (u) => u[t] === n && l.indexOf(u[d]) !== -1
      );
      e.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: s,
        hoveredElement: a,
        items: h.filter((u) => typeof u[p] == "number").map((u) => ({
          label: u[d],
          value: u[p],
          color: e.model.getFillColor(u[d]),
          class: e.model.getColorClassName({
            classNameTypes: [$.TOOLTIP],
            dataGroupName: u[d]
          })
        }))
      });
    }).on("mousemove", function(s, n) {
      const a = x(this);
      e.services.events.dispatchEvent(f.Radar.X_AXIS_MOUSEMOVE, {
        event: s,
        element: a,
        datum: n
      }), e.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: s
      });
    }).on("click", function(s, n) {
      e.services.events.dispatchEvent(f.Radar.X_AXIS_CLICK, {
        event: s,
        element: x(this),
        datum: n
      });
    }).on("mouseout", function(s, n) {
      const a = x(this), i = e.parent.select(`.x-axes .x-axis-${we(n)}`), o = e.parent.selectAll(`.dots circle.${we(n)}`);
      i.classed("hovered", !1).attr("stroke-dasharray", "0"), o.classed("hovered", !1).attr("opacity", 0).attr("r", 0), e.services.events.dispatchEvent(f.Radar.X_AXIS_MOUSEOUT, {
        event: s,
        element: a,
        datum: n
      }), e.services.events.dispatchEvent(f.Tooltip.HIDE);
    });
  }
}
class Uc extends $t {
  constructor() {
    super(...arguments), this.type = "simple-bar", this.renderType = H.SVG, this.handleLegendOnHover = (e) => {
      const { hoveredElement: t } = e.detail, { groupMapsTo: s } = this.getOptions().data;
      this.parent.selectAll("path.bar").transition("legend-hover-simple-bar").call(
        (n) => this.services.transitions.setupTransition({
          transition: n,
          name: "legend-hover-simple-bar"
        })
      ).attr("opacity", (n) => n[s] !== t.datum().name ? 0.3 : 1);
    }, this.handleLegendMouseOut = () => {
      this.parent.selectAll("path.bar").transition("legend-mouseout-simple-bar").call(
        (e) => this.services.transitions.setupTransition({
          transition: e,
          name: "legend-mouseout-simple-bar"
        })
      ).attr("opacity", 1);
    };
  }
  init() {
    const e = this.services.events;
    e.addEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.addEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
  render(e) {
    const t = this.getOptions(), { groupMapsTo: s } = t.data, n = this.getComponentContainer({ withinChartClip: !0 }), a = this.model.getDisplayData(this.configs.groups), i = this.services.cartesianScales.getOrientation(), o = n.selectAll("path.bar").data(a, (c) => c[s]);
    o.exit().attr("opacity", 0).remove(), o.enter().append("path").attr("opacity", 0).merge(o).classed("bar", !0).attr("width", this.getBarWidth.bind(this)).transition().call(
      (c) => this.services.transitions.setupTransition({
        transition: c,
        name: "bar-update-enter",
        animate: e
      })
    ).attr(
      "class",
      (c) => this.model.getColorClassName({
        classNameTypes: [$.FILL],
        dataGroupName: c[s],
        originalClassName: "bar"
      })
    ).style("fill", (c) => this.model.getFillColor(c[s])).attr("d", (c) => {
      const d = this.services.cartesianScales.getRangeIdentifier(), p = this.getBarWidth(), h = c[d], u = this.services.cartesianScales.getDomainValue(c) - p / 2, g = u + p;
      let m, b;
      if (Array.isArray(h) && h.length === 2)
        m = this.services.cartesianScales.getRangeValue(h[0]), b = this.services.cartesianScales.getRangeValue(h[1]);
      else {
        const O = this.services.cartesianScales.getRangeScale().domain()[0];
        m = this.services.cartesianScales.getRangeValue(Math.max(0, O)), b = this.services.cartesianScales.getRangeValue(c);
      }
      const v = Math.abs(b - m);
      if (v !== 0 && v < 2 && (h > 0 && i === le.VERTICAL || h < 0 && i === le.HORIZONTAL ? b = m - 2 : b = m + 2), !this.isOutsideZoomedDomain(u, g))
        return ie({ x0: u, x1: g, y0: m, y1: b }, i);
    }).attr("opacity", 1).attr("role", U.GRAPHICS_SYMBOL).attr("aria-roledescription", "bar").attr("aria-label", (c) => c.value), this.addEventListeners();
  }
  addEventListeners() {
    const e = this;
    this.parent.selectAll("path.bar").on("mouseover", function(t, s) {
      const n = x(this);
      n.classed("hovered", !0), e.services.events.dispatchEvent(f.Bar.BAR_MOUSEOVER, {
        event: t,
        element: n,
        datum: s
      }), e.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: t,
        hoveredElement: n,
        data: [s]
      });
    }).on("mousemove", function(t, s) {
      e.services.events.dispatchEvent(f.Bar.BAR_MOUSEMOVE, {
        event: t,
        element: x(this),
        datum: s
      }), e.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: t
      });
    }).on("click", function(t, s) {
      e.services.events.dispatchEvent(f.Bar.BAR_CLICK, {
        event: t,
        element: x(this),
        datum: s
      });
    }).on("mouseout", function(t, s) {
      const n = x(this);
      n.classed("hovered", !1), e.services.events.dispatchEvent(f.Bar.BAR_MOUSEOUT, {
        event: t,
        element: n,
        datum: s
      }), e.services.events.dispatchEvent(f.Tooltip.HIDE, {
        hoveredElement: n
      });
    });
  }
  destroy() {
    this.parent.selectAll("path.bar").on("mouseover", null).on("mousemove", null).on("mouseout", null);
    const e = this.services.events;
    e.removeEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.removeEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
}
class zc extends cr {
  constructor() {
    super(...arguments), this.type = "skeleton-lines";
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    const t = y(this.getOptions(), "data", "loading"), s = !y(this.getOptions(), "grid", "x", "enabled") && !y(this.getOptions(), "grid", "y", "enabled") && !y(this.getOptions(), "axes", "bottom", "visible") && !y(this.getOptions(), "axes", "left", "visible");
    t && !s ? super.renderGridSkeleton(t) : t && s ? this.renderSparklineSkeleton(t) : this.removeSkeleton();
  }
  renderSparklineSkeleton(e) {
    this.setScales(), this.drawBackdrop(e), this.drawSparkline(e), this.updateBackdropStyle(), e && this.setShimmerEffect("shimmer-lines");
  }
  drawSparkline(e) {
    const t = this.backdrop.attr("width"), s = [100], n = E.appendOrSelect(this.backdrop, "g.y.skeleton"), a = n.selectAll("line").data(s);
    a.enter().append("line").merge(a).attr("x1", 0).attr("x2", t).attr("y1", (i) => i).attr("y2", (i) => i), n.selectAll("line").classed("shimmer-effect-lines", e).classed("empty-state-lines", !e).style(
      "stroke",
      e ? `url(#${this.services.domUtils.generateElementIDString("shimmer-lines")})` : null
    );
  }
  updateBackdropStyle() {
    const e = this.parent;
    this.backdrop = E.appendOrSelect(e, "svg.chart-skeleton.DAII"), E.appendOrSelect(this.backdrop, "rect.chart-skeleton-backdrop").classed("shimmer-effect-lines", !1).classed("shimmer-effect-sparkline", !0).style("stroke", null);
  }
}
class Fc extends z {
  constructor() {
    super(...arguments), this.type = "area-stacked", this.renderType = H.SVG, this.handleLegendOnHover = (e) => {
      const { hoveredElement: t } = e.detail, s = this.getOptions(), { groupMapsTo: n } = s.data;
      this.parent.selectAll("path.area").transition("legend-hover-area").call(
        (a) => this.services.transitions.setupTransition({
          transition: a,
          name: "legend-hover-area"
        })
      ).attr("opacity", (a) => y(a, 0, n) !== t.datum().name ? fe.opacity.unselected : fe.opacity.selected);
    }, this.handleLegendMouseOut = () => {
      this.parent.selectAll("path.area").transition("legend-mouseout-area").call(
        (e) => this.services.transitions.setupTransition({
          transition: e,
          name: "legend-mouseout-area"
        })
      ).attr("opacity", fe.opacity.selected);
    };
  }
  init() {
    const e = this.services.events;
    e.addEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.addEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
  render(e = !0) {
    const t = this.getComponentContainer({ withinChartClip: !0 }), s = this, n = this.getOptions(), { groupMapsTo: a } = n.data, i = Object.keys(n.axes).some((g) => n.axes[g].percentage), o = this.model.getStackedData({
      percentage: i,
      groups: this.configs.groups
    }), l = y(o, 0, 0), c = this.services.cartesianScales.getDomainAxisPosition({ datum: l }), d = this.services.cartesianScales.getRangeAxisPosition({ datum: l }), p = this.services.cartesianScales.getScaleByPosition(d), h = t.selectAll("path.area").data(o, (g) => y(g, 0, a));
    this.areaGenerator = kt().x(
      (g) => this.services.cartesianScales.getValueThroughAxisPosition(
        c,
        g.data.sharedStackKey
      )
    ).y0((g) => p(g[0])).y1((g) => p(g[1])).curve(this.services.curves.getD3Curve()), h.exit().attr("opacity", 0).remove(), h.enter().append("path").attr("opacity", 0).merge(h).data(o, (g) => y(g, 0, a)).attr("class", "area").attr(
      "class",
      (g) => this.model.getColorClassName({
        classNameTypes: [$.FILL],
        dataGroupName: y(g, 0, a),
        originalClassName: "area"
      })
    ).style("fill", (g) => s.model.getFillColor(y(g, 0, a))).attr("role", U.GRAPHICS_SYMBOL).attr("aria-roledescription", "area").attr("aria-label", (g) => y(g, 0, a)).transition().call(
      (g) => this.services.transitions.setupTransition({
        transition: g,
        name: "area-update-enter",
        animate: e
      })
    ).attr("opacity", fe.opacity.selected).attr("d", this.areaGenerator);
  }
}
class Wc extends $t {
  constructor() {
    super(...arguments), this.type = "stacked-bar", this.renderType = H.SVG, this.handleLegendOnHover = (e) => {
      const { hoveredElement: t } = e.detail, { groupMapsTo: s } = this.model.getOptions().data;
      this.parent.selectAll("path.bar").transition("legend-hover-bar").call(
        (n) => this.services.transitions.setupTransition({
          transition: n,
          name: "legend-hover-bar"
        })
      ).attr("opacity", (n) => n[s] !== t.datum().name ? 0.3 : 1);
    }, this.handleLegendMouseOut = () => {
      this.parent.selectAll("path.bar").transition("legend-mouseout-bar").call(
        (e) => this.services.transitions.setupTransition({
          transition: e,
          name: "legend-mouseout-bar"
        })
      ).attr("opacity", 1);
    };
  }
  init() {
    const e = this.services.events;
    e.addEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.addEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
  render(e) {
    const t = this.getComponentContainer({ withinChartClip: !0 }), s = this.getOptions(), { groupMapsTo: n } = s.data, a = this.model.getStackedData({
      groups: this.configs.groups,
      divergent: !0
    }), i = this.model.getActiveDataGroupNames(), o = t.selectAll("g.bars").data(a, (c) => y(c, 0, n));
    o.exit().attr("opacity", 0).remove(), o.enter().append("g").classed("bars", !0).attr("role", U.GROUP).attr("data-name", "bars");
    const l = t.selectAll("g.bars").selectAll("path.bar").data(
      (c) => c,
      (c) => c.data.sharedStackKey
    );
    l.exit().remove(), l.enter().append("path").merge(l).classed("bar", !0).transition().call(
      (c) => this.services.transitions.setupTransition({
        transition: c,
        name: "bar-update-enter",
        animate: e
      })
    ).attr(
      "class",
      (c) => this.model.getColorClassName({
        classNameTypes: [$.FILL],
        dataGroupName: c[n],
        originalClassName: "bar"
      })
    ).style("fill", (c) => this.model.getFillColor(c[n])).attr("d", (c) => {
      const d = c.data.sharedStackKey, p = this.getBarWidth(), h = this.services.cartesianScales.getDomainValue(d) - p / 2, u = h + p, g = this.services.cartesianScales.getRangeValue(c[0]);
      let m = this.services.cartesianScales.getRangeValue(c[1]);
      if (!this.isOutsideZoomedDomain(h, u)) {
        if (Math.abs(m - g) > 0 && Math.abs(m - g) > s.bars.dividerSize) {
          const b = c[0] < 0 && c[1] <= 0;
          b && i.length > 1 ? this.services.cartesianScales.getOrientation() === le.VERTICAL ? m += c[1] === 0 ? 2 : 1 : m -= 1 : b || (this.services.cartesianScales.getOrientation() === le.VERTICAL ? m += 1 : m -= 1);
        }
        return ie(
          { x0: h, x1: u, y0: g, y1: m },
          this.services.cartesianScales.getOrientation()
        );
      }
    }).attr("opacity", 1).attr("role", U.GRAPHICS_SYMBOL).attr("aria-roledescription", "bar").attr("aria-label", (c) => c[1] - c[0]), this.addEventListeners();
  }
  addEventListeners() {
    const e = this.getOptions(), { groupMapsTo: t } = e.data, s = this;
    this.parent.selectAll("path.bar").on("mouseover", function(n, a) {
      const i = x(this);
      i.classed("hovered", !0), s.services.events.dispatchEvent(f.Bar.BAR_MOUSEOVER, {
        event: n,
        element: i,
        datum: a
      });
      let l = s.model.getDisplayData(s.configs.groups).find((c) => {
        const d = s.services.cartesianScales.getDomainIdentifier(c), p = s.services.cartesianScales.getRangeIdentifier(c);
        return c[p] === a.data[a[t]] && c[d].toString() === a.data.sharedStackKey && c[t] === a[t];
      });
      if (l === void 0) {
        const c = s.services.cartesianScales.getDomainIdentifier(), d = s.services.cartesianScales.getRangeIdentifier();
        l = {
          [c]: a.data.sharedStackKey,
          [d]: a.data[a[t]],
          [t]: a[t]
        };
      }
      s.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: n,
        hoveredElement: i,
        data: [l]
      });
    }).on("mousemove", function(n, a) {
      const i = x(this);
      s.services.events.dispatchEvent(f.Bar.BAR_MOUSEMOVE, {
        event: n,
        element: i,
        datum: a
      }), s.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: n
      });
    }).on("click", function(n, a) {
      s.services.events.dispatchEvent(f.Bar.BAR_CLICK, {
        event: n,
        element: x(this),
        datum: a
      });
    }).on("mouseout", function(n, a) {
      const i = x(this);
      i.classed("hovered", !1), s.services.events.dispatchEvent(f.Bar.BAR_MOUSEOUT, {
        event: n,
        element: i,
        datum: a
      }), s.services.events.dispatchEvent(f.Tooltip.HIDE, {
        hoveredElement: i
      });
    });
  }
  getBarWidth() {
    const e = this.getOptions();
    if (y(e, "bars", "width"))
      return e.bars.width;
    const t = this.services.cartesianScales.getMainXScale(), s = E.getSVGElementSize(this.parent, {
      useAttrs: !0
    }).width, n = this.model.getStackKeys().length, a = y(e, "bars", "spacingFactor");
    return t.step ? Math.min(e.bars.maxWidth, t.step() / 2) : Math.min(e.bars.maxWidth, s * a / n);
  }
  destroy() {
    this.parent.selectAll("path.bar").on("mouseover", null).on("mousemove", null).on("mouseout", null);
    const e = this.services.events;
    e.removeEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.removeEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
}
class jc extends Vt {
  constructor() {
    super(...arguments), this.type = "scatter-stacked", this.renderType = H.SVG;
  }
  render(e) {
    if (!y(this.getOptions(), "points", "enabled"))
      return;
    const s = this.getComponentContainer({ withinChartClip: !0 }), n = this.getOptions(), { groupMapsTo: a } = n.data, i = Object.keys(n.axes).some((u) => n.axes[u].percentage), o = this.model.getStackedData({
      groups: this.configs.groups,
      percentage: i
    }), l = s.selectAll("g.dots").data(o, (u) => y(u, 0, a));
    l.exit().attr("opacity", 0).remove();
    const d = l.enter().append("g").classed("dots", !0).attr("role", U.GROUP).merge(l).selectAll("circle.dot").data((u) => u);
    d.exit().attr("opacity", 0).remove();
    const h = d.enter().append("circle").classed("dot", !0).attr("opacity", 0).merge(d).datum((u) => {
      const g = u[a], m = this.services.cartesianScales.getDomainIdentifier(u), b = this.services.cartesianScales.getRangeIdentifier(u);
      return {
        [a]: g,
        [m]: u.data.sharedStackKey,
        [b]: u[1]
      };
    });
    this.styleCircles(h, e), this.addEventListeners();
  }
  getTooltipData(e, t) {
    const s = this.getOptions(), { groupMapsTo: n } = s.data, a = Object.keys(s.axes).some((l) => s.axes[l].percentage), i = this.model.getStackedData({
      groups: this.configs.groups,
      percentage: a
    }), o = [];
    return i.forEach((l, c) => {
      l.forEach((d, p) => {
        const h = d[n], u = d.data.sharedStackKey;
        let g = d.data[h];
        const m = d[1], b = this.services.cartesianScales.getDomainIdentifier(d), v = this.services.cartesianScales.getRangeIdentifier(d);
        g != null && e === this.services.cartesianScales.getDomainValue(u) && t === this.services.cartesianScales.getRangeValue(m) && (a && (g = this.model.getStackedData({
          groups: this.configs.groups
        })[c][p].data[h]), g !== null && o.push({
          [n]: h,
          [b]: u,
          [v]: g
        }));
      });
    }), this.model.getDisplayData(this.configs.groups).filter((l) => {
      const c = this.services.cartesianScales.getDomainIdentifier(l), d = this.services.cartesianScales.getRangeIdentifier(l);
      return o.find((p) => p[n] == l[n] && p[c] == l[c] && p[d] == l[d]) !== void 0;
    });
  }
}
const Ae = 6;
class Zc extends z {
  constructor() {
    super(...arguments), this.type = "tree", this.renderType = H.SVG;
  }
  getLongestLabel(e) {
    let t = "";
    return e.forEach((s) => {
      const n = s.children ? this.getLongestLabel(s.children) : "";
      (n.length > t.length || s.name.length > t.length) && (t = n.length > s.name.length ? n : s.name);
    }), t;
  }
  getMockLabelWidth(e, t) {
    const s = e.append("text").attr("dy", "0.31em").attr("x", 0).attr("text-anchor", "end").text(t), { width: n } = E.getSVGElementSize(s.node(), {
      useBBox: !0
    });
    return s.remove(), n;
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    const t = this.getComponentContainer();
    t.html("");
    const { width: s, height: n } = E.getSVGElementSize(this.parent, {
      useAttrs: !0
    });
    if (s < 1 || n < 1)
      return;
    const a = this.model.getOptions(), i = this.model.getDisplayData(), o = y(a, "tree", "rootTitle") || "Tree", l = this.getMockLabelWidth(t, o), c = this.getLongestLabel(i), d = this.getMockLabelWidth(t, c), p = {
      top: 0,
      right: 0,
      bottom: 0,
      left: l > 0 ? l + Ae : 30 - Ae
    }, h = Pt({
      name: o,
      children: i
    }), u = 10, g = s / 6, m = (T) => {
      const k = h.descendants().reverse(), _ = h.links();
      let F = h, V = h;
      h.eachBefore((N) => {
        N.x < F.x && (F = N), N.x > V.x && (V = N);
      });
      const A = V.x - F.x, M = t.transition().call(
        (N) => this.services.transitions.setupTransition({
          transition: N,
          name: "tree-update-viewbox",
          animate: !0
        })
      ).attr("viewBox", [-p.left, F.x, s, A].join(" ")), G = w.selectAll("g").data(k, (N) => N.id), D = this, X = G.enter().append("g").attr("transform", () => `translate(${T.y0},${T.x0})`).attr(
        "class",
        (N) => N.depth !== 0 && N.children && N.children.length > 0 ? "clickable" : null
      ).on("mouseover", function(N, ae) {
        D.services.events.dispatchEvent(f.Tree.NODE_MOUSEOVER, {
          event: N,
          element: x(this),
          datum: ae
        });
      }).on("click", function(N, ae) {
        ae.depth !== 0 && (ae.children = ae.children ? null : ae._children, m(ae)), D.services.events.dispatchEvent(f.Tree.NODE_CLICK, {
          event: N,
          element: x(this),
          datum: ae
        });
      }).on("mouseout", function(N, ae) {
        D.services.events.dispatchEvent(f.Tree.NODE_MOUSEOUT, {
          event: N,
          element: x(this),
          datum: ae
        });
      });
      X.append("circle").attr("r", 2.5).attr("class", (N) => N._children ? "parent" : "child").attr("stroke-width", 10), X.append("text").attr("dy", "0.31em").attr("x", (N) => N._children ? -Ae : Ae).attr("text-anchor", (N) => N._children ? "end" : "start").text((N) => N.data.name).clone(!0).attr("class", "text-stroke").lower(), G.merge(X).transition(M).attr("transform", (N) => `translate(${N.y},${N.x})`).attr("fill-opacity", 1).attr("stroke-opacity", 1), G.exit().transition(M).remove().attr("transform", () => `translate(${T.y},${T.x})`).attr("fill-opacity", 0).attr("stroke-opacity", 0);
      const re = L.selectAll("path").data(_, (N) => N.target.id), W = re.enter().append("path").attr("d", () => {
        const N = { x: T.x0, y: T.y0 };
        return O({ source: N, target: N });
      });
      re.merge(W).transition(M).attr("d", O), re.exit().transition(M).remove().attr("d", () => {
        const N = { x: T.x, y: T.y };
        return O({ source: N, target: N });
      }), h.eachBefore((N) => {
        N.x0 = N.x, N.y0 = N.y;
      });
    }, b = h.descendants(), v = b[b.length - 1].depth, S = y(a, "tree", "type") === _n.DENDROGRAM ? rn().size([
      n,
      s - d - v * Ae - l
    ]) : on().nodeSize([u, g]).size([
      n,
      s - d - v * Ae - l
    ]), O = ln().x((T) => T.y).y((T) => T.x);
    h.x0 = g / 2, h.y0 = 0, h.descendants().forEach((T, k) => {
      T.id = k, T._children = T.children;
    }), S(h), t.attr("viewBox", [-p.left, -p.top, s, u]).style("user-select", "none");
    const L = t.append("g").attr("class", "links"), w = t.append("g").attr("class", "nodes");
    m(h);
  }
}
var Er = "#000000", Sr = "#ffffff", xr = "#fcf4d6", Or = "#fddc69", Tr = "#f1c21b", Lr = "#d2a106", wr = "#b28600", Mr = "#8e6a00", Ar = "#684e00", Cr = "#483700", kr = "#302400", Ir = "#1c1500", Dr = {
  10: xr,
  20: Or,
  30: Tr,
  40: Lr,
  50: wr,
  60: Mr,
  70: Ar,
  80: Cr,
  90: kr,
  100: Ir
}, Rr = "#fff2e8", _r = "#ffd9be", Pr = "#ffb784", Vr = "#ff832b", Br = "#eb6200", $r = "#ba4e00", Gr = "#8a3800", Nr = "#5e2900", Hr = "#3e1a00", Ur = "#231000", zr = {
  10: Rr,
  20: _r,
  30: Pr,
  40: Vr,
  50: Br,
  60: $r,
  70: Gr,
  80: Nr,
  90: Hr,
  100: Ur
}, Fr = "#fff1f1", Wr = "#ffd7d9", jr = "#ffb3b8", Zr = "#ff8389", Xr = "#fa4d56", Yr = "#da1e28", qr = "#a2191f", Kr = "#750e13", Jr = "#520408", Qr = "#2d0709", eo = {
  10: Fr,
  20: Wr,
  30: jr,
  40: Zr,
  50: Xr,
  60: Yr,
  70: qr,
  80: Kr,
  90: Jr,
  100: Qr
}, to = "#fff0f7", so = "#ffd6e8", no = "#ffafd2", ao = "#ff7eb6", io = "#ee5396", ro = "#d02670", oo = "#9f1853", lo = "#740937", co = "#510224", ho = "#2a0a18", uo = {
  10: to,
  20: so,
  30: no,
  40: ao,
  50: io,
  60: ro,
  70: oo,
  80: lo,
  90: co,
  100: ho
}, po = "#f6f2ff", go = "#e8daff", mo = "#d4bbff", fo = "#be95ff", vo = "#a56eff", yo = "#8a3ffc", bo = "#6929c4", Eo = "#491d8b", So = "#31135e", xo = "#1c0f30", Oo = {
  10: po,
  20: go,
  30: mo,
  40: fo,
  50: vo,
  60: yo,
  70: bo,
  80: Eo,
  90: So,
  100: xo
}, To = "#edf5ff", Lo = "#d0e2ff", wo = "#a6c8ff", Mo = "#78a9ff", Ao = "#4589ff", Co = "#0f62fe", ko = "#0043ce", Io = "#002d9c", Do = "#001d6c", Ro = "#001141", _o = {
  10: To,
  20: Lo,
  30: wo,
  40: Mo,
  50: Ao,
  60: Co,
  70: ko,
  80: Io,
  90: Do,
  100: Ro
}, Po = "#e5f6ff", Vo = "#bae6ff", Bo = "#82cfff", $o = "#33b1ff", Go = "#1192e8", No = "#0072c3", Ho = "#00539a", Uo = "#003a6d", zo = "#012749", Fo = "#061727", Wo = {
  10: Po,
  20: Vo,
  30: Bo,
  40: $o,
  50: Go,
  60: No,
  70: Ho,
  80: Uo,
  90: zo,
  100: Fo
}, jo = "#d9fbfb", Zo = "#9ef0f0", Xo = "#3ddbd9", Yo = "#08bdba", qo = "#009d9a", Ko = "#007d79", Jo = "#005d5d", Qo = "#004144", el = "#022b30", tl = "#081a1c", sl = {
  10: jo,
  20: Zo,
  30: Xo,
  40: Yo,
  50: qo,
  60: Ko,
  70: Jo,
  80: Qo,
  90: el,
  100: tl
}, nl = "#defbe6", al = "#a7f0ba", il = "#6fdc8c", rl = "#42be65", ol = "#24a148", ll = "#198038", cl = "#0e6027", dl = "#044317", hl = "#022d0d", ul = "#071908", pl = {
  10: nl,
  20: al,
  30: il,
  40: rl,
  50: ol,
  60: ll,
  70: cl,
  80: dl,
  90: hl,
  100: ul
}, gl = "#f2f4f8", ml = "#dde1e6", fl = "#c1c7cd", vl = "#a2a9b0", yl = "#878d96", bl = "#697077", El = "#4d5358", Sl = "#343a3f", xl = "#21272a", Ol = "#121619", Tl = {
  10: gl,
  20: ml,
  30: fl,
  40: vl,
  50: yl,
  60: bl,
  70: El,
  80: Sl,
  90: xl,
  100: Ol
}, Ll = "#f4f4f4", wl = "#e0e0e0", Ml = "#c6c6c6", Al = "#a8a8a8", Cl = "#8d8d8d", kl = "#6f6f6f", Il = "#525252", Dl = "#393939", Rl = "#262626", _l = "#161616", Pl = {
  10: Ll,
  20: wl,
  30: Ml,
  40: Al,
  50: Cl,
  60: kl,
  70: Il,
  80: Dl,
  90: Rl,
  100: _l
}, Vl = "#f7f3f2", Bl = "#e5e0df", $l = "#cac5c4", Gl = "#ada8a8", Nl = "#8f8b8b", Hl = "#726e6e", Ul = "#565151", zl = "#3c3838", Fl = "#272525", Wl = "#171414", jl = {
  10: Vl,
  20: Bl,
  30: $l,
  40: Gl,
  50: Nl,
  60: Hl,
  70: Ul,
  80: zl,
  90: Fl,
  100: Wl
}, ps = {
  black: {
    100: Er
  },
  blue: _o,
  coolGray: Tl,
  cyan: Wo,
  gray: Pl,
  green: pl,
  magenta: uo,
  orange: zr,
  purple: Oo,
  red: eo,
  teal: sl,
  warmGray: jl,
  white: {
    0: Sr
  },
  yellow: Dr
};
const Zl = (r) => {
  if (!r)
    return null;
  for (const e of Object.keys(ps)) {
    const t = ps[e];
    for (const s of Object.keys(t))
      if (t[+s] === r)
        return s;
  }
  return null;
}, gs = function() {
  const r = x(this.parentNode).select("rect.leaf"), e = getComputedStyle(r.node(), null).getPropertyValue(
    "fill"
  ), t = bs(e);
  let s;
  if (t && (s = Zl(t ? t.hex() : null)), s == null) {
    const n = ys(t).l;
    s = Math.abs(n * 100 - 100);
  }
  return s > 50 ? "white" : "black";
};
let Xl = 0;
class Xc extends z {
  constructor() {
    super(...arguments), this.type = "treemap", this.renderType = H.SVG, this.handleLegendOnHover = (e) => {
      const { hoveredElement: t } = e.detail;
      this.parent.selectAll("g[data-name='leaf']").transition("legend-hover-treemap").call(
        (s) => this.services.transitions.setupTransition({
          transition: s,
          name: "legend-hover-treemap"
        })
      ).attr(
        "opacity",
        (s) => s.parent.data.name === t.datum().name ? 1 : 0.3
      );
    }, this.handleLegendMouseOut = () => {
      this.parent.selectAll("g[data-name='leaf']").transition("legend-mouseout-treemap").call(
        (e) => this.services.transitions.setupTransition({
          transition: e,
          name: "legend-mouseout-treemap"
        })
      ).attr("opacity", 1);
    };
  }
  init() {
    const { events: e } = this.services;
    e.addEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.addEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
  render(e = !0) {
    const t = this.getComponentContainer();
    this.model.getData();
    const s = this.model.getDisplayData(), n = this.model.getOptions(), a = y(window, "location"), { width: i, height: o } = E.getSVGElementSize(t, {
      useAttrs: !0
    }), l = Pt({
      name: n.title || "Treemap",
      children: s
    }).sum((m) => m.value).sort((m, b) => b.value - m.value), c = cn().size([i, o]).paddingInner(1).paddingOuter(0).round(!0)(
      l
    ), d = t.selectAll("g[data-name='leaf']").data(c.leaves(), (m) => m.data.name);
    d.exit().attr("opacity", 0).remove();
    const h = d.enter().append("g").attr("data-name", "leaf").attr("data-uid", () => Xl++).merge(d);
    h.attr("data-name", "leaf").transition().call(
      (m) => this.services.transitions.setupTransition({
        transition: m,
        name: "treemap-group-update",
        animate: e
      })
    ).attr("transform", (m) => `translate(${m.x0},${m.y0})`);
    const u = h.selectAll("rect.leaf").data((m) => [m]);
    u.exit().attr("width", 0).attr("height", 0).remove(), u.enter().append("rect").classed("leaf", !0).merge(u).attr("width", 0).attr("height", 0).attr("id", function() {
      const m = x(this.parentNode).attr("data-uid");
      return `${n.style.prefix}-leaf-${m}`;
    }).attr("class", (m) => {
      for (; m.depth > 1; )
        m = m.parent;
      return this.model.getColorClassName({
        classNameTypes: [$.FILL],
        dataGroupName: m.data.name,
        originalClassName: "leaf"
      });
    }).transition().call(
      (m) => this.services.transitions.setupTransition({
        transition: m,
        name: "treemap-leaf-update-enter",
        animate: e
      })
    ).attr("width", (m) => m.x1 - m.x0).attr("height", (m) => m.y1 - m.y0).style("fill", (m) => {
      for (; m.depth > 1; )
        m = m.parent;
      return this.model.getFillColor(m.data.name);
    }), h.selectAll("clipPath").data(
      (m) => m.data.showLabel !== !0 ? [] : [1],
      (m) => m
    ).join(
      (m) => m.append("clipPath").attr("id", function() {
        const b = x(this.parentNode).attr("data-uid");
        return `${n.style.prefix}-clip-${b}`;
      }).append("use").attr("xlink:href", function() {
        const b = x(this.parentNode.parentNode).attr("data-uid"), v = `${n.style.prefix}-leaf-${b}`;
        return new URL(`#${v}`, a) + "";
      }),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      (m) => null,
      (m) => m.remove()
    ), h.selectAll("text").data(
      (m) => {
        if (m.data.showLabel !== !0)
          return [];
        let b = m;
        for (; b.depth > 1; )
          b = b.parent;
        const v = ys(this.model.getFillColor(b.data.name));
        return [
          {
            text: m.data.name,
            color: v.l < 0.5 ? "white" : "black"
          }
        ];
      },
      (m) => m
    ).join(
      (m) => {
        const b = m.append("text").text((v) => v.text).style("fill", gs).attr("x", 7).attr("y", 18);
        return a && b.attr("clip-path", function() {
          const v = x(this.parentNode).attr("data-uid"), S = `${n.style.prefix}-clip-${v}`;
          return `url(${new URL(`#${S}`, a) + ""})`;
        }), b;
      },
      (m) => m.text((b) => b.text).style("fill", gs),
      (m) => m.remove()
    ), this.addEventListeners();
  }
  addEventListeners() {
    const e = this;
    this.parent.selectAll("rect.leaf").on("mouseover", function(t, s) {
      const n = x(this);
      let a = getComputedStyle(this, null).getPropertyValue("fill"), i = s;
      for (; i.depth > 1; )
        i = i.parent;
      n.transition("graph_element_mouseover_fill_update").call(
        (o) => e.services.transitions.setupTransition({
          transition: o,
          name: "graph_element_mouseover_fill_update"
        })
      ).style("fill", (o) => {
        const l = e.model.getFillColor(o.parent.data.name);
        return l && (a = l), bs(a).darker(0.7).toString();
      }), e.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: t,
        hoveredElement: n,
        items: [
          {
            color: a,
            label: i.data.name,
            bold: !0
          },
          {
            label: s.data.name,
            value: s.data.value
          }
        ]
      }), e.services.events.dispatchEvent(f.Treemap.LEAF_MOUSEOVER, {
        event: t,
        element: n,
        datum: s
      });
    }).on("mousemove", function(t, s) {
      const n = x(this);
      e.services.events.dispatchEvent(f.Treemap.LEAF_MOUSEMOVE, {
        event: t,
        element: n,
        datum: s
      }), e.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: t
      });
    }).on("click", function(t, s) {
      e.services.events.dispatchEvent(f.Treemap.LEAF_CLICK, {
        event: t,
        element: x(this),
        datum: s
      });
    }).on("mouseout", function(t, s) {
      const n = x(this);
      n.classed("hovered", !1);
      let a = s;
      for (; a.depth > 1; )
        a = a.parent;
      n.transition().call(
        (i) => e.services.transitions.setupTransition({
          transition: i,
          name: "graph_element_mouseout_fill_update"
        })
      ).style("fill", (i) => e.model.getFillColor(i.parent.data.name)), e.services.events.dispatchEvent(f.Treemap.LEAF_MOUSEOUT, {
        event: t,
        element: n,
        datum: s
      }), e.services.events.dispatchEvent(f.Tooltip.HIDE, {
        hoveredElement: n
      });
    });
  }
}
class Yc extends z {
  constructor() {
    super(...arguments), this.type = "wordcloud", this.renderType = H.SVG, this.handleLegendOnHover = (e) => {
      const { hoveredElement: t } = e.detail, { groupMapsTo: s } = this.getOptions().data;
      this.parent.selectAll("text.word").transition("legend-hover-wordcloud").call(
        (n) => this.services.transitions.setupTransition({
          transition: n,
          name: "legend-hover-wordcloud"
        })
      ).attr("opacity", (n) => n[s] !== t.datum().name ? 0.3 : 1);
    }, this.handleLegendMouseOut = () => {
      this.parent.selectAll("text.word").transition("legend-mouseout-wordcloud").call(
        (e) => this.services.transitions.setupTransition({
          transition: e,
          name: "legend-mouseout-wordcloud"
        })
      ).attr("opacity", 1);
    };
  }
  init() {
    const e = this.services.events;
    e.addEventListener(f.Legend.ITEM_HOVER, this.handleLegendOnHover), e.addEventListener(f.Legend.ITEM_MOUSEOUT, this.handleLegendMouseOut);
  }
  render(e = !0) {
    const t = this, s = this.getComponentContainer().attr("width", "100%").attr("height", "100%"), n = this.model.getDisplayData(), a = this.getFontSizeScale(n), i = this.getOptions(), { fontSizeMapsTo: o, wordMapsTo: l } = i.wordCloud, { groupMapsTo: c } = i.data, { width: d, height: p } = E.getSVGElementSize(s, {
      useAttrs: !0
    });
    if (d === 0 || p === 0)
      return;
    const h = Un().size([d, p]).words(
      n.map(function(g) {
        const m = g[o];
        if (typeof g[o] != "number")
          throw Error(
            "Badly formatted WordCloud data. `value` should only be an integer or float"
          );
        return {
          [c]: g[c],
          text: g[l],
          size: m,
          value: m
        };
      })
    ).padding(5).rotate(0).fontSize((g) => a(g.size)).on("end", u);
    h.start();
    function u(g) {
      const m = E.appendOrSelect(s, "g.words");
      m.attr("transform", `translate(${h.size()[0] / 2}, ${h.size()[1] / 2})`);
      const b = m.selectAll("text").data(g, (S) => `${S[c]}-${S.text}`);
      b.exit().attr("opacity", 0).remove(), b.enter().append("text").attr("opacity", 0).merge(b).style("font-size", (S) => `${S.size}px`).text(function(S) {
        return S.text;
      }).attr(
        "class",
        (S) => t.model.getColorClassName({
          classNameTypes: [$.FILL],
          dataGroupName: S[c],
          originalClassName: `word ${S.size > 32 ? "light" : ""}`
        })
      ).style("fill", (S) => t.model.getFillColor(S[c], S.text, S)).attr("text-anchor", "middle").transition().call(
        (S) => t.services.transitions.setupTransition({
          transition: S,
          name: "wordcloud-text-update-enter",
          animate: e
        })
      ).attr("transform", (S) => `translate(${S.x}, ${S.y})`).attr("opacity", 1);
    }
    this.addEventListeners();
  }
  getFontSizeScale(e) {
    const t = this.getOptions(), { fontSizeMapsTo: s } = t.wordCloud, n = e.map((l) => l[s]).filter((l) => l), a = E.getHTMLElementSize(this.services.domUtils.getMainContainer()), i = n.length > 0, o = i ? Ke(n) : [1, 1];
    return Oe().domain(o).range(i ? t.wordCloud.fontSizeRange(a, e) : [4, 4]);
  }
  addEventListeners() {
    const e = this.getOptions(), { groupMapsTo: t } = e.data, s = this, n = gt((a) => {
      const i = s.parent.selectAll("text.word").transition("wordcloud-word-mouse-highlight").call(
        (o) => s.services.transitions.setupTransition({
          transition: o,
          name: "wordcloud-word-mouse-highlight"
        })
      );
      a === null ? i.attr("opacity", 1) : i.attr("opacity", function() {
        return a === this ? 1 : 0.3;
      });
    }, 6);
    this.parent.selectAll("text.word").on("mouseover", function(a, i) {
      const o = this;
      n(o), s.services.events.dispatchEvent(f.WordCloud.WORD_MOUSEOVER, {
        event: a,
        element: x(this),
        datum: i
      }), s.services.events.dispatchEvent(f.Tooltip.SHOW, {
        event: a,
        hoveredElement: o,
        items: [
          {
            label: e.tooltip.wordLabel,
            value: i.text
          },
          {
            label: e.tooltip.valueLabel,
            value: i.value
          },
          {
            label: e.tooltip.groupLabel,
            value: i[t],
            class: s.model.getColorClassName({
              classNameTypes: [$.TOOLTIP],
              dataGroupName: i[t]
            })
          }
        ]
      });
    }).on("mousemove", function(a, i) {
      const o = x(this);
      s.services.events.dispatchEvent(f.WordCloud.WORD_MOUSEMOVE, {
        element: o,
        datum: i
      }), s.services.events.dispatchEvent(f.Tooltip.MOVE, {
        event: a
      });
    }).on("click", function(a, i) {
      s.services.events.dispatchEvent(f.WordCloud.WORD_CLICK, {
        event: a,
        element: x(this),
        datum: i
      });
    }).on("mouseout", function(a, i) {
      const o = x(this);
      n(null), s.services.events.dispatchEvent(f.WordCloud.WORD_MOUSEOUT, {
        event: a,
        element: o,
        datum: i
      }), s.services.events.dispatchEvent(f.Tooltip.HIDE, {
        hoveredElement: o
      });
    });
  }
}
class Yl extends z {
  constructor() {
    super(...arguments), this.type = "geo", this.renderType = H.SVG;
  }
  render() {
    const e = this.getComponentContainer({ withinChartClip: !0 }), { width: t, height: s } = E.getSVGElementSize(e, {
      useAttrs: !0
    });
    if (t < 1 || s < 1)
      return;
    const n = this.getProjection(), a = y(this.getOptions(), "geoData"), i = this.model.getCombinedData(), o = {}, l = {};
    Object.keys(i).forEach((v) => {
      typeof i[v].value == "number" ? o[v] = i[v] : l[v] = i[v];
    });
    const c = fr(a, Object.values(l)), d = pr(a, {
      // We need to specify that we are converting geometry collections
      type: "GeometryCollection",
      geometries: Object.values(o)
    }), p = n.fitSize([t, s], d), h = dn().projection(p);
    E.appendOrSelect(e, "g.geo").selectAll("path").data(d.features).join("path").attr("d", h);
    const g = this.services.domUtils.generateElementIDString("geo-pattern-stripes"), m = E.appendOrSelect(e, "defs");
    E.appendOrSelect(m, "pattern").attr("id", g).attr("width", 5).attr("height", 10).attr("patternUnits", "userSpaceOnUse").attr("patternTransform", "rotate(45)").append("path").classed("pattern-fill", !0).attr(
      "d",
      It()([
        [0, 0],
        [0, 10]
      ])
    );
    const b = E.appendOrSelect(e, "g.missing-data");
    E.appendOrSelect(b, "path").datum(c).attr("d", h).style("fill", `url(#${g})`);
  }
  /**
   * @info
   * Depending on projection, we may need to provide additional configuration
   * e.g. sizing
   *
   * In such case, function can be refactored so that
   * projection should return an object with the configuraiton & function
   */
  getProjection() {
    let e = null;
    switch (y(this.getOptions(), "thematic", "projection")) {
      case xe.geoEqualEarth:
        e = vn();
        break;
      case xe.geoAlbers:
        e = fn();
        break;
      case xe.geoConicEqualArea:
        e = mn();
        break;
      case xe.geoConicEquidistant:
        e = gn();
        break;
      case xe.geoEquirectangular:
        e = pn();
        break;
      case xe.geoMercator:
        e = un();
        break;
      case xe.geoNaturalEarth1:
        e = hn();
        break;
      default:
        throw new Error("Projection is not supported.");
    }
    return e;
  }
}
class qc extends Yl {
  constructor() {
    super(...arguments), this.type = "choropleth";
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(e = !0) {
    super.render();
    const t = this.model.getCombinedData();
    this.getComponentContainer({ withinChartClip: !0 }).select("g.geo").selectAll("path").classed("border", !0).attr("class", (a) => this.model.getColorClassName({
      value: t[a.properties.NAME].value,
      originalClassName: "border"
    })), this.addCountryAreaEventListener();
  }
  addCountryAreaEventListener() {
    const e = this, t = this.model.getCombinedData();
    this.parent.selectAll("path.border").on("mouseover", function(s, n) {
      const a = x(this);
      e.services.events.dispatchEvent(Ue.CHOROPLETH_MOUSEOVER, {
        event: s,
        element: a,
        datum: t[n.properties.NAME]
      }), e.services.events.dispatchEvent(ot.SHOW, {
        event: s,
        hoveredElement: a,
        items: [
          {
            label: n.properties.NAME,
            value: t[n.properties.NAME].value
          }
        ]
      });
    }).on("mousemove", function(s, n) {
      e.services.events.dispatchEvent(Ue.CHOROPLETH_MOUSEMOVE, {
        event: s,
        element: x(this),
        datum: t[n.properties.NAME]
      }), e.services.events.dispatchEvent(ot.MOVE, {
        event: s
      });
    }).on("click", function(s, n) {
      e.services.events.dispatchEvent(Ue.CHOROPLETH_CLICK, {
        event: s,
        element: x(this),
        datum: t[n.properties.NAME]
      });
    }).on("mouseout", function(s, n) {
      const a = x(this);
      e.services.events.dispatchEvent(Ue.CHOROPLETH_MOUSEOUT, {
        event: s,
        element: a,
        datum: t[n.properties.NAME]
      }), e.services.events.dispatchEvent(ot.HIDE, {
        event: s,
        hoveredElement: a
      });
    });
  }
}
export {
  wc as $,
  dc as A,
  fc as B,
  rc as C,
  _c as D,
  Bc as E,
  Ec as F,
  uc as G,
  cc as H,
  $c as I,
  zc as J,
  Gc as K,
  nr as L,
  ic as M,
  Dc as N,
  Nc as O,
  br as P,
  Hc as Q,
  js as R,
  ac as S,
  sr as T,
  Zc as U,
  Xc as V,
  Yc as W,
  Zs as X,
  lr as Y,
  oc as Z,
  Lc as _,
  Ha as a,
  Tc as a0,
  Oc as a1,
  xc as a2,
  Mc as a3,
  Ac as a4,
  Cc as a5,
  kc as a6,
  Yl as a7,
  $t as a8,
  z as a9,
  Ua as b,
  Da as c,
  ir as d,
  ar as e,
  rr as f,
  lc as g,
  hc as h,
  mc as i,
  gc as j,
  pc as k,
  Vt as l,
  cr as m,
  vc as n,
  yc as o,
  bc as p,
  Ic as q,
  qc as r,
  Rc as s,
  Fc as t,
  jc as u,
  Sc as v,
  Uc as w,
  Vc as x,
  Wc as y,
  Pc as z
};
//# sourceMappingURL=choropleth-91db5841.mjs.map
